import React from 'react';
import { IconsGeneralColor, FontColorSuccess, Active500, FontColorError, FontColorSelected, FontColorWarning, Third, Second, Third300, Impediment, MrWhite } from '@targetprocess/css-variables';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AccessPrivateIcon = function AccessPrivateIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? 'transparent' : _ref$outlineColor;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M5.0079,6.26303 C5.12974,4.44051 6.64665,3 8.5,3 C10.35335,3 11.87026,4.44051 11.9921,6.26303 C12.59426,6.60771 13,7.2565 13,8 L13,11 C13,12.10451 12.10458,13 11,13 L6,13 C4.895419,13 4,12.10451 4,11 L4,8 C4,7.2565 4.40574,6.60771 5.0079,6.26303 Z",
    fill: outlineColor
  }), React.createElement("path", {
    d: "M11,7 C11.55228,7 12,7.44775 12,8 L12,11 C12,11.55225 11.55228,12 11,12 L6,12 C5.447723,12 5,11.55225 5,11 L5,8 C5,7.44775 5.447723,7 6,7 L6,6.5 C6,5.11926 7.11929,4 8.5,4 C9.88071,4 11,5.11926 11,6.5 L11,7 Z M10,6.5 L10,7 L7,7 L7,6.5 C7,5.67163 7.67157,5 8.5,5 C9.32843,5 10,5.67163 10,6.5 Z",
    fill: color
  })));
};
AccessPrivateIcon.category = 'Permissions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AccessCustomIcon = function AccessCustomIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? 'transparent' : _ref$outlineColor;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M11.34814,4.15773 C11.39429,4.19567 11.44409,4.24327 11.4917,4.3004 C11.84717,4.45804 12.18506,4.72064 12.44336,5.14725 C12.80078,5.73744 12.92969,6.52491 12.92969,7.48197 C12.92969,8.05477 12.73584,8.57159 12.46533,8.99297 C12.81934,9.216 13.1282,9.49114 13.3762,9.83336 C13.835,10.46654 14,11.21167 14,12.00016 L14,13.0002 L3,13.0002 L3,12.00016 C3,11.19659 3.154541,10.44147 3.574463,9.78761 C3.874268,9.32081 4.27588,8.95735 4.75317,8.67271 C4.41797,8.19276 4.17456,7.59406 4.17456,6.92877 C4.17456,5.78517 4.34033,4.8711 4.80176,4.22054 C5.08276,3.78114 5.58154,3.284264 6.48877,3.0933573 C6.80127,3.0275834 7.14575,2.99353577 7.43701,3.00101842 C7.57275,3.00450743 7.7605,3.0180627 7.94482,3.0723615 C8.03223,3.0980909 8.19336,3.153817 8.35181,3.278426 C8.40918,3.323333 8.47241,3.38325 8.53174,3.458075 C8.6709,3.517756 8.80737,3.592149 8.93823,3.68433 C9.06714,3.775168 9.19067,3.88328 9.30566,4.01161 L9.63867,3.946798 C9.71387,3.932162 9.79102,3.919448 9.8689,3.908885 C10.07666,3.880688 10.28906,3.867818 10.479,3.874622 C10.59912,3.878932 10.77539,3.892816 10.9519,3.947796 C11.03613,3.974012 11.19336,4.03125 11.34814,4.15773 Z",
    id: "access-custom-icon",
    fill: outlineColor
  }), React.createElement("path", {
    d: "M5.63135,4.779943 C5.79346,4.51798 6.08209,4.200841 6.69476,4.0719352 C7.18536,3.9686638 7.7598,3.9724479 7.7598,4.110265 C7.7598,4.110265 7.75949,4.176794 7.74091,4.265905 C8.52921,4.392736 9.09937,4.914464 9.09937,6.92875 C9.09937,8.06229 7.95795,9.08524 7.13696,9.08524 C6.31598,9.08524 5.17468,8.06229 5.17465,6.92875 C5.17465,5.82352 5.34622,5.16776 5.63135,4.779943 Z",
    fill: color,
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M5.7637,9.28263 C4.521301,9.80314 4,10.64384 4,12.00016 L10.3006,12.00016 C10.3006,10.63834 9.77267,9.79667 8.5184,9.27653 C8.1116,9.5756 7.62619,9.78531 7.13696,9.78531 C6.651,9.78531 6.16879,9.57853 5.7637,9.28263 Z",
    fill: color,
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M10.73627,4.971105 C10.73627,4.852209 10.25687,4.845251 9.82977,4.928381 C10.02191,5.47916 10.09937,6.14762 10.09937,6.92875 C10.09937,7.58951 9.85941,8.18461 9.52765,8.663 C9.86139,8.85978 10.15881,9.09464 10.41092,9.37601 C11.10828,9.21769 11.92969,8.38968 11.92969,7.48197 C11.92969,5.68754 11.42175,5.22257 10.71948,5.10953 C10.73596,5.03031 10.73627,4.971105 10.73627,4.971105 Z",
    fill: color,
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M13,12.00016 L11.3006,12.00016 C11.3006,11.19254 11.14377,10.43436 10.71909,9.77897 C10.70477,9.75687 10.69028,9.73502 10.67551,9.71341 C10.84122,9.65702 11.00345,9.5756 11.15649,9.47648 C12.45834,9.92985 13,10.69816 13,12.00016 Z",
    fill: color,
    fillRule: "nonzero"
  })));
};
AccessCustomIcon.category = 'Permissions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ActionCompletedIcon = function ActionCompletedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? FontColorSuccess : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M3 8C3 5.23859 5.23853 3 8 3C8.44629 3 8.87744 3.05823 9.28711 3.16699C9.8208 3.30865 10.3684 2.99084 10.5103 2.45703C10.6519 1.92322 10.334 1.37561 9.80029 1.23395C9.22485 1.08112 8.62109 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15C11.866 15 15 11.866 15 8C15 6.85474 14.7241 5.77094 14.2344 4.81421C14.2192 4.78467 14.2029 4.75616 14.1853 4.72882L14.707 4.20709C15.0977 3.81659 15.0977 3.18341 14.707 2.79291C14.3167 2.40234 13.6833 2.40234 13.293 2.79291L7.5 8.58582L5.70703 6.79291C5.31665 6.40234 4.68335 6.40234 4.29297 6.79291C3.90234 7.18341 3.90234 7.81659 4.29297 8.20709L6.79297 10.7071C7.18335 11.0977 7.81665 11.0977 8.20703 10.7071L12.6797 6.2345C12.8867 6.78259 13 7.37726 13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8Z",
    fill: color
  }));
};
ActionCompletedIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AddIcon = function AddIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM5 7C4.44775 7 4 7.44775 4 8C4 8.55225 4.44775 9 5 9H7V11C7 11.5522 7.44775 12 8 12C8.55225 12 9 11.5522 9 11V9H11C11.5522 9 12 8.55225 12 8C12 7.44775 11.5522 7 11 7H9V5C9 4.44775 8.55225 4 8 4C7.44775 4 7 4.44775 7 5V7H5Z",
    fill: color
  }));
};
AddIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AddTagIcon = function AddTagIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M12 1C12 0.447754 12.4478 0 13 0C13.5523 0 14 0.447754 14 1V2H15C15.5523 2 16 2.44775 16 3C16 3.55225 15.5523 4 15 4H14V5C14 5.55225 13.5523 6 13 6C12.4478 6 12 5.55225 12 5V4H11C10.4478 4 10 3.55225 10 3C10 2.44775 10.4478 2 11 2H12V1Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M0.00442805 6.69519C-0.033902 7.27075 0.178012 7.83472 0.585727 8.24255L7.7222 15.379C8.30789 15.9648 9.25785 15.9647 9.84354 15.379L13.3789 11.8435C13.9649 11.2577 13.9649 10.308 13.3789 9.72217L6.24271 2.58569C5.83475 2.17786 5.27079 1.96606 4.69535 2.00439L1.60721 2.21021C0.857211 2.26025 0.260287 2.8573 0.210239 3.60718L0.00442805 6.69519ZM4.54032 6.54016C4.9307 6.14966 4.9307 5.51648 4.54032 5.12598C4.14969 4.73547 3.51639 4.73547 3.12601 5.12598C2.73539 5.51648 2.73539 6.14966 3.12601 6.54016C3.51664 6.93066 4.14969 6.93066 4.54032 6.54016Z",
    fill: color
  }));
};
AddTagIcon.category = 'Tags';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Values = {
  0: 'M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.2386 3 3 5.23858 3 8C3 10.7614 5.2386 13 8 13ZM15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8Z',
  10: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8H8L3.87939 5.16711C4.78101 3.85809 6.29028 3 8 3C10.7615 3 13 5.23859 13 8Z',
  20: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8H8L6.50806 3.22632C6.97925 3.07922 7.48047 3 8 3C10.7615 3 13 5.23859 13 8Z',
  30: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8H8L9.33667 3.18066C11.4492 3.76526 13 5.70148 13 8Z',
  40: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8H8L12.1206 5.16711C12.6753 5.97235 13 6.94824 13 8Z',
  50: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM13 8C13 10.7614 10.7615 13 8 13C5.23853 13 3 10.7614 3 8H13Z',
  60: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM12.3586 10.4517C11.5012 11.9728 9.87061 13 8 13C5.23853 13 3 10.7614 3 8H8L12.3586 10.4517Z',
  70: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM10.0046 12.582C9.39087 12.8508 8.71289 13 8 13C5.23853 13 3 10.7614 3 8H8L10.0046 12.582Z',
  80: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM6.62842 12.8096L8 8H3C3 10.2858 4.53369 12.2134 6.62842 12.8096Z',
  90: 'M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM3 8C3 9.05176 3.32471 10.0277 3.87939 10.8329L8 8H3Z',
  100: 'M8 15C11.866 15 15 11.866 15 8C15 4.134 11.866 1 8 1C4.13403 1 1 4.134 1 8C1 11.866 4.13403 15 8 15Z'
};
var AllocationIcon = function AllocationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    // hasOwnProperty explicitly checked here
    // eslint-disable-next-line security/detect-object-injection
    d: Values.hasOwnProperty(value) ? Values[value] : Values[0],
    fill: color
  }));
};
AllocationIcon.category = 'Entity';
AllocationIcon.Values = Values;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AllocationsIcon = function AllocationsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 6.5C1 3.46243 3.46243 1 6.5 1C8.79809 1 10.767 2.40944 11.5894 4.41105C13.5896 5.23315 15 7.20067 15 9.49998C15 12.5375 12.5375 15 9.49998 15C7.20068 15 5.23316 13.5896 4.41107 11.5894C2.40945 10.767 1 8.79809 1 6.5ZM6.5 10C4.73676 10 3.27806 8.69615 3.03544 7H7V3.03544C8.69615 3.27806 10 4.73676 10 6.5C10 8.433 8.433 10 6.5 10ZM7.02528 11.9752C7.65906 12.6087 8.53434 13 9.49998 13C11.433 13 13 11.433 13 9.49998C13 8.53433 12.6087 7.65904 11.9752 7.02526C11.7272 9.64355 9.64356 11.7272 7.02528 11.9752Z",
    fill: color
  }));
};
AllocationsIcon.category = 'Entity';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var Types = {
  APPROVED: 'approved'
};
var ApproveIconColor = _defineProperty({}, Types.APPROVED, FontColorSuccess);
var ApproveStatusIcon = function ApproveStatusIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    type = _ref.type;
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  var fill = ApproveIconColor.hasOwnProperty(type) ? ApproveIconColor[type] : color;
  return React.createElement("svg", {
    width: "13",
    height: "14",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5.47803 0C3.72803 0 1.97803 0.972221 1.97803 3.88889C1.97803 6.5625 3.54492 9 5.47803 9C7.41113 9 8.97803 6.5625 8.97803 3.88889C8.97803 1.21528 7.22803 0 5.47803 0Z",
    fill: fill
  }), React.createElement("path", {
    d: "M5.24026 13.996C3.26107 13.93 1.48992 13.0424 0.257219 11.6633C-0.215999 11.1339 -0.00156516 10.333 0.617163 9.98464C1.12235 9.70019 1.75197 9.81227 2.24383 10.1192C2.93553 10.5508 3.80226 10.8361 4.66992 10.9474C4.28996 11.9637 4.48007 13.1446 5.24026 13.996Z",
    fill: fill
  }), React.createElement("path", {
    d: "M14.7071 10.7071C15.0976 10.3166 15.0976 9.68342 14.7071 9.29289C14.3166 8.90237 13.6834 8.90237 13.2929 9.29289L9.5 13.0858L7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L8.79289 15.2071C9.18342 15.5976 9.81658 15.5976 10.2071 15.2071L14.7071 10.7071Z",
    fill: fill
  }));
};
ApproveStatusIcon.category = 'Messages';
ApproveStatusIcon.Types = Types;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ApproximatelyEqualIcon = function ApproximatelyEqualIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15H12C13.6569 15 15 13.6569 15 12V4C15 2.34315 13.6569 1 12 1H4ZM12.5068 5.55288L11.8545 6.15074C10.7032 7.20614 9.00705 7.40988 7.63851 6.65718C6.83362 6.21449 5.83607 6.33432 5.15893 6.95504L4.50676 7.55288L3.49316 6.44715L4.14534 5.84932C5.29669 4.7939 6.99283 4.59015 8.36139 5.34286C9.16627 5.78554 10.1638 5.66571 10.841 5.045L11.4932 4.44714L12.5068 5.55288ZM12.5068 9.55288L11.8545 10.1507C10.7032 11.2061 9.00705 11.4099 7.63851 10.6572C6.83362 10.2145 5.83607 10.3343 5.15893 10.955L4.50676 11.5529L3.49316 10.4471L4.14534 9.84932C5.29669 8.7939 6.99283 8.59015 8.36139 9.34286C9.16627 9.78554 10.1638 9.66571 10.841 9.045L11.4932 8.44714L12.5068 9.55288Z",
    fill: color
  }));
};
ApproximatelyEqualIcon.category = 'Info';

var _Rotations;
var Directions = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};
var Rotations = (_Rotations = {}, _defineProperty(_Rotations, Directions.LEFT, 0), _defineProperty(_Rotations, Directions.TOP, -270), _defineProperty(_Rotations, Directions.BOTTOM, 270), _defineProperty(_Rotations, Directions.RIGHT, 180), _Rotations);
var ArrowIcon = function ArrowIcon(_ref) {
  var direction = _ref.direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  var rotationDegrees = Rotations.hasOwnProperty(direction) ?
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  Rotations[direction] : Rotations[Directions.LEFT];
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      transform: "rotate(".concat(rotationDegrees, "deg)"),
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.70711 4.29289C7.31658 3.90237 6.68342 3.90237 6.29289 4.29289L3.29289 7.29289C2.90237 7.68342 2.90237 8.31658 3.29289 8.70711L6.29289 11.7071C6.68342 12.0976 7.31658 12.0976 7.70711 11.7071C8.09763 11.3166 8.09763 10.6834 7.70711 10.2929L6.41421 9H11.5C12.0523 9 12.5 8.55228 12.5 8C12.5 7.44772 12.0523 7 11.5 7L6.41421 7L7.70711 5.70711C8.09763 5.31658 8.09763 4.68342 7.70711 4.29289Z",
    fill: color
  }));
};
ArrowIcon.category = 'Navigation';
ArrowIcon.Directions = Directions;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AttachmentIcon = function AttachmentIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5504 14.2069C9.79651 15.453 12.3848 16.0292 14.2071 14.207C16.0292 12.3849 15.4533 9.7965 14.2072 8.5503L14.1993 8.54236C14.0433 8.38633 11.6134 5.95603 11.0251 5.36794C10.5586 4.90157 9.94819 4.61364 9.28473 4.60508C8.61572 4.59645 7.98441 4.87331 7.48955 5.36817C6.42605 6.43166 6.54063 7.95478 7.48955 8.9037L9.94234 11.3565C10.3329 11.747 10.966 11.747 11.3566 11.3565C11.7471 10.9659 11.7471 10.3328 11.3566 9.94225L8.90376 7.48949C8.90376 7.48948 8.90376 7.48949 8.90376 7.48949C8.7786 7.36432 8.73646 7.23627 8.73449 7.13854C8.73268 7.04926 8.76228 6.92386 8.90376 6.78238C9.05525 6.63089 9.18077 6.60391 9.25895 6.60491C9.34267 6.60599 9.46985 6.64118 9.6111 6.78238C10.2185 7.3896 12.7907 9.96226 12.7928 9.96432C13.4367 10.6082 13.6665 11.9192 12.7929 12.7928C11.9193 13.6664 10.6085 13.4366 9.96459 12.7927L3.60046 6.42883C3.60046 6.42882 3.60047 6.42883 3.60046 6.42883C2.94024 5.76859 2.67468 4.52618 3.60045 3.60043C4.52626 2.67464 5.76866 2.9402 6.42888 3.60042C6.8194 3.99095 7.45257 3.99095 7.84309 3.60042C8.23361 3.2099 8.23361 2.57673 7.84309 2.18621C6.61325 0.956367 4.08896 0.283532 2.18625 2.1862C0.283528 4.08889 0.956423 6.61321 2.18625 7.84304L8.5504 14.2069C8.55039 14.2069 8.5504 14.2069 8.5504 14.2069Z",
    fill: color
  }));
};
AttachmentIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes = {
  DEFAULT: 'default',
  BIG: 'big'
};
var AzureIcon = function AzureIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes.DEFAULT : _ref$size;
  var numericSize = size === Sizes.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px")
  }), React.createElement("path", {
    style: size === Sizes.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    },
    d: "M11.1777 18.1455C14.0042 17.6767 16.3388 17.2888 16.3656 17.2834L16.4143 17.2737L13.7458 14.2934C12.2782 12.6542 11.0773 11.3067 11.0773 11.299C11.0773 11.2843 13.8328 4.15961 13.8483 4.13426C13.8535 4.12579 15.7286 7.16556 18.3938 11.5029C20.889 15.5635 22.9461 18.9116 22.9652 18.943L23 19L14.5193 18.999L6.03868 18.9979L11.1777 18.1455ZM1 17.2367C1 17.2325 2.25738 15.183 3.79417 12.6823L6.58834 8.1356L9.84462 5.56975C11.6356 4.15853 13.1057 3.00217 13.1116 3.00006C13.1175 2.99795 13.094 3.05363 13.0593 3.12378C13.0246 3.19394 11.4334 6.39843 9.5234 10.2449L6.05061 17.2384L3.52531 17.2413C2.13639 17.243 1 17.2409 1 17.2367Z",
    fill: "#0089D6"
  }));
};
AzureIcon.category = 'Tool';
AzureIcon.Sizes = Sizes;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$1 = {
  BIG: 'big',
  DEFAULT: 'default'
};
var AzureDevOpsIcon = function AzureDevOpsIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$1.DEFAULT : _ref$size;
  var numericSize = size === Sizes$1.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px")
  }), React.createElement("path", {
    style: size === Sizes$1.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    },
    d: "M18.1371 5.53701L18.1761 5.56601V18.507L2.43506 16.113L9.03206 24V20.829L18.0661 24L23.9651 18.987V4.46001L18.1371 5.53701Z",
    fill: "#0078D4"
  }), React.createElement("path", {
    style: size === Sizes$1.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    },
    d: "M2.433 8.441L18.137 5.537L10.618 0V2.58L2.433 5.824L0 8.995V15.741L2.435 16.113L2.433 16.111V8.441Z",
    fill: "#0078D4"
  }));
};
AzureDevOpsIcon.category = 'Tool';
AzureDevOpsIcon.Sizes = Sizes$1;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AutomationRuleIcon = function AutomationRuleIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 4.5C7 5.70948 6.14112 6.71836 5 6.94999V9C5 10.3807 6.11929 11.5 7.5 11.5H10V10H14V14H10V12.5H7.5C5.567 12.5 4 10.933 4 9V6.94999C2.85888 6.71836 2 5.70948 2 4.5C2 3.11929 3.11929 2 4.5 2C5.88071 2 7 3.11929 7 4.5Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 8L12.5 7.49999C12.5 5.567 10.933 4 9 4V5C10.3807 5 11.5 6.11928 11.5 7.49999L11.5 8H12.5Z",
    fill: color
  }));
};
AutomationRuleIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var AutoPushIcon = function AutoPushIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.29689 2.12412C6.27164 1.74201 6.54132 1.39659 6.92696 1.33493C7.27687 1.27899 7.63532 1.25 8.00002 1.25C11.7279 1.25 14.75 4.27208 14.75 8C14.75 9.9992 13.8799 11.7962 12.5002 13.0311C12.1916 13.3073 11.7174 13.281 11.4412 12.9724C11.1649 12.6638 11.1912 12.1896 11.4998 11.9134C12.5751 10.951 13.25 9.5548 13.25 8C13.25 5.2232 11.0942 2.94992 8.36502 2.76249L8.51923 2.98273C8.75682 3.32203 8.67436 3.78969 8.33505 4.02727C7.99575 4.26486 7.52809 4.1824 7.29051 3.84309L6.43014 2.61436C6.32595 2.46556 6.28331 2.29206 6.29689 2.12412Z",
    fill: color
  }), React.createElement("path", {
    d: "M9.70752 13.8759C9.73277 14.258 9.46309 14.6034 9.07745 14.6651C8.72754 14.721 8.36909 14.75 8.00439 14.75C4.27647 14.75 1.25439 11.7279 1.25439 8C1.25439 6.0008 2.12447 4.20384 3.50421 2.96894C3.81285 2.69269 4.287 2.71896 4.56325 3.0276C4.83949 3.33625 4.81322 3.81039 4.50458 4.08664C3.42932 5.04902 2.75439 6.4452 2.75439 8C2.75439 10.7768 4.91018 13.0501 7.63939 13.2375L7.48518 13.0173C7.24759 12.678 7.33005 12.2103 7.66936 11.9727C8.00866 11.7351 8.47632 11.8176 8.7139 12.1569L9.57427 13.3856C9.67846 13.5344 9.7211 13.7079 9.70752 13.8759Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.6082 10.4438L6.85582 9.9289H9.14394L9.39157 10.4438C9.57109 10.8171 10.0192 10.9741 10.3925 10.7946C10.7658 10.6151 10.9229 10.167 10.7434 9.79366L8.70531 5.55597C8.57173 5.27821 8.28942 5.12016 7.99988 5.13142C7.71035 5.12016 7.42804 5.27821 7.29445 5.55597L5.25641 9.79366C5.07688 10.167 5.23395 10.6151 5.60724 10.7946C5.98053 10.9741 6.42867 10.8171 6.6082 10.4438ZM7.99988 7.55007L7.57722 8.4289H8.42254L7.99988 7.55007Z",
    fill: color
  }));
};
AutoPushIcon.category = 'Tool';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$2 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var BitbucketIcon = function BitbucketIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$2.DEFAULT : _ref$size;
  var numericSize = size === Sizes$2.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$2.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    }
  }, React.createElement("path", {
    d: "M1.71398 3.00006C1.50574 2.99749 1.30698 3.08318 1.171 3.23414C1.03503 3.38511 0.975758 3.5859 1.0091 3.78265L4.00133 21.1683C4.07828 21.6075 4.47359 21.9303 4.93882 21.934H19.2938C19.643 21.9383 19.9428 21.6973 19.9987 21.3673L22.9909 3.78602C23.0242 3.58927 22.965 3.38848 22.829 3.23752C22.693 3.08655 22.4943 3.00086 22.286 3.00343L1.71398 3.00006ZM14.3138 15.5654H9.73204L8.49144 9.36198H15.424L14.3138 15.5654Z",
    fill: "#2684FF"
  }), React.createElement("path", {
    d: "M22.0212 9.35321H15.4112L14.3019 15.5516H9.72378L4.31812 21.6928C4.48945 21.8346 4.7079 21.9134 4.9344 21.9152H19.2814C19.6303 21.9195 19.9299 21.6787 19.9858 21.349L22.0212 9.35321Z",
    fill: "url(#bitbucketIconLinearGradient)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "bitbucketIconLinearGradient",
    x1: "23.5496",
    y1: "11.089",
    x2: "16.3547",
    y2: "21.7628",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: "0.18",
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })))));
};
BitbucketIcon.category = 'Tool';
BitbucketIcon.Sizes = Sizes$2;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var BlockerIcon = function BlockerIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8ZM13 8C13 10.7614 10.7615 13 8 13C6.98096 13 6.0332 12.6951 5.24268 12.1716L12.1716 5.24255C12.6951 6.03299 13 6.9809 13 8ZM10.7573 3.82841C9.9668 3.30489 9.01904 3 8 3C5.23853 3 3 5.23857 3 8C3 9.0191 3.30493 9.96701 3.82837 10.7574L10.7573 3.82841Z",
    fill: color
  }));
};
BlockerIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$1 = {
  DEFAULT: 'default',
  HIDDEN: 'hidden'
};
var BoardEmptyLanesIcon = function BoardEmptyLanesIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$1.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$1.DEFAULT && React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M14 14.799C14.5523 14.799 15 14.3513 15 13.799L15 2.16668C15 1.6144 14.5523 1.16669 14 1.16669C13.4477 1.16669 13 1.6144 13 2.16669L13 13.799C13 14.3513 13.4478 14.799 14 14.799Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.00004 14.799C2.55232 14.799 3.00003 14.3513 3.00003 13.799L3 2.16668C3 1.6144 2.55228 1.16669 2 1.16669C1.44771 1.16669 0.999998 1.6144 1 2.16669L1.00003 13.799C1.00003 14.3513 1.44775 14.799 2.00004 14.799Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 3H7V13H9V3ZM7 1C5.89543 1 5 1.89543 5 3V13C5 14.1046 5.89543 15 7 15H9C10.1046 15 11 14.1046 11 13V3C11 1.89543 10.1046 1 9 1H7Z",
    fill: color
  })), type === Types$1.HIDDEN && React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M14 14.799C14.5523 14.799 15 14.3513 15 13.799L15 2.16668C15 1.6144 14.5523 1.16669 14 1.16669C13.4477 1.16669 13 1.6144 13 2.16669L13 13.799C13 14.3513 13.4478 14.799 14 14.799Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.00004 14.799C2.55232 14.799 3.00003 14.3513 3.00003 13.799L3 2.16668C3 1.6144 2.55228 1.16669 2 1.16669C1.44771 1.16669 0.999998 1.6144 1 2.16669L1.00003 13.799C1.00003 14.3513 1.44775 14.799 2.00004 14.799Z",
    fill: color
  }), React.createElement("path", {
    d: "M7 1C5.89543 1 5 1.89543 5 3V13C5 14.1046 5.89543 15 7 15H9C10.1046 15 11 14.1046 11 13V3C11 1.89543 10.1046 1 9 1H7Z",
    fill: color
  })));
};
BoardEmptyLanesIcon.category = 'Boards & Views';
BoardEmptyLanesIcon.Types = Types$1;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var BoardIcon = function BoardIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1 10C1 9.44772 1.44772 9 2 9H6C6.55228 9 7 9.44772 7 10V12C7 12.5523 6.55228 13 6 13H2C1.44772 13 1 12.5523 1 12V10Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 10C9 9.44772 9.44772 9 10 9H14C14.5523 9 15 9.44772 15 10V12C15 12.5523 14.5523 13 14 13H10C9.44772 13 9 12.5523 9 12V10Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 4C1 3.44772 1.44772 3 2 3H6C6.55228 3 7 3.44772 7 4V6C7 6.55228 6.55228 7 6 7H2C1.44772 7 1 6.55228 1 6V4Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V6C15 6.55228 14.5523 7 14 7H10C9.44772 7 9 6.55228 9 6V4Z",
    fill: color
  }));
};
BoardIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var BranchIcon = function BranchIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 12 12",
    fill: "none"
  }, React.createElement("path", {
    d: "M3 4C2.72386 4 2.5 4.22386 2.5 4.5V7.5C2.5 7.77614 2.72386 8 3 8C3.27614 8 3.5 7.77614 3.5 7.5V6.5H7.5C8.60457 6.5 9.5 5.60457 9.5 4.5V4H8.5V4.5C8.5 5.05228 8.05228 5.5 7.5 5.5H3.5V4.5C3.5 4.22386 3.27614 4 3 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 11.5C1.89543 11.5 1 10.6046 1 9.5C1 8.39543 1.89543 7.5 3 7.5C4.10457 7.5 5 8.39543 5 9.5C5 10.6046 4.10457 11.5 3 11.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 4.5C7.89543 4.5 7 3.60457 7 2.5C7 1.39543 7.89543 0.5 9 0.5C10.1046 0.5 11 1.39543 11 2.5C11 3.60457 10.1046 4.5 9 4.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 4.5C1.89543 4.5 1 3.60457 1 2.5C1 1.39543 1.89543 0.5 3 0.5C4.10457 0.5 5 1.39543 5 2.5C5 3.60457 4.10457 4.5 3 4.5Z",
    fill: color
  }));
};
BranchIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CalendarIcon = function CalendarIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C5 1.44772 4.55225 1 4 1C3.44775 1 3 1.44772 3 2V3C1.89551 3 1 3.89543 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89543 14.1045 3 13 3V2C13 1.44772 12.5522 1 12 1C11.4478 1 11 1.44772 11 2V3H5V2ZM3 7V13H13V7H3Z",
    fill: color
  }));
};
CalendarIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CapacityIcon = function CapacityIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    fill: color
  }, React.createElement("path", {
    d: "M1 4C1 3.44772 1.52233 3 2.16667 3H8.5V5H2.16667C1.52233 5 1 4.55228 1 4Z"
  }), React.createElement("path", {
    d: "M1 8C1 7.44772 1.52233 7 2.16667 7H8.5V9H2.16667C1.52233 9 1 8.55228 1 8Z"
  }), React.createElement("path", {
    d: "M1 12C1 11.4477 1.52233 11 2.16667 11H8.5V13H2.16667C1.52233 13 1 12.5523 1 12Z"
  }), React.createElement("g", {
    opacity: "0.3"
  }, React.createElement("path", {
    d: "M14.9998 4C14.9998 3.44772 14.4774 3 13.8331 3H10.9998V5H13.8331C14.4774 5 14.9998 4.55228 14.9998 4Z"
  }), React.createElement("path", {
    d: "M14.9998 8C14.9998 7.44772 14.4774 7 13.8331 7H10.9998V9H13.8331C14.4774 9 14.9998 8.55228 14.9998 8Z"
  }), React.createElement("path", {
    d: "M14.9998 12C14.9998 11.4477 14.4774 11 13.8331 11H10.9998V13H13.8331C14.4774 13 14.9998 12.5523 14.9998 12Z"
  })), React.createElement("rect", {
    x: "9",
    y: "1",
    width: "2",
    height: "14",
    rx: "1"
  })));
};
CapacityIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CardIcon = function CardIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H13C14.1046 2 15 2.89543 15 4V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4ZM5 4H13V12H5V4Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H13C14.1046 2 15 2.89543 15 4V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4ZM5 4H13V12H5V4Z",
    fill: color
  }));
};
CardIcon.category = 'Entity';

var _Rotations$1, _SizeOptions;
var Directions$1 = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};
var Rotations$1 = (_Rotations$1 = {}, _defineProperty(_Rotations$1, Directions$1.LEFT, -270), _defineProperty(_Rotations$1, Directions$1.TOP, -180), _defineProperty(_Rotations$1, Directions$1.BOTTOM, 0), _defineProperty(_Rotations$1, Directions$1.RIGHT, -90), _Rotations$1);
var Sizes$3 = {
  DEFAULT: 'default',
  SMALL: 'small'
};
var SizeOptions = (_SizeOptions = {}, _defineProperty(_SizeOptions, Sizes$3.DEFAULT, {
  width: 16,
  height: 16,
  points: 'M13.7071 4.79289C14.0976 5.18342 14.0976 5.81658 13.7071 6.20711L8.70711 11.2071C8.31658 11.5976 7.68342 11.5976 7.29289 11.2071L2.29289 6.20711C1.90237 5.81658 1.90237 5.18342 2.29289 4.79289C2.68342 4.40237 3.31658 4.40237 3.70711 4.79289L8 9.08579L12.2929 4.79289C12.6834 4.40237 13.3166 4.40237 13.7071 4.79289Z'
}), _defineProperty(_SizeOptions, Sizes$3.SMALL, {
  width: 16,
  height: 16,
  points: 'M4.29289 6.29289C3.90237 6.68342 3.90237 7.31658 4.29289 7.70711L7.29289 10.7071C7.68342 11.0976 8.31658 11.0976 8.70711 10.7071L11.7071 7.70711C12.0976 7.31658 12.0976 6.68342 11.7071 6.29289C11.3166 5.90237 10.6834 5.90237 10.2929 6.29289L8 8.58579L5.70711 6.29289C5.31658 5.90237 4.68342 5.90237 4.29289 6.29289Z'
}), _SizeOptions);
var CaretIcon = function CaretIcon(_ref) {
  var direction = _ref.direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$3.DEFAULT : _ref$size;
  var _ref2 = SizeOptions.hasOwnProperty(size) ?
    // hasOwnProperty explicitly checked here
    // eslint-disable-next-line security/detect-object-injection
    SizeOptions[size] : SizeOptions[Sizes$3.DEFAULT],
    width = _ref2.width,
    height = _ref2.height,
    points = _ref2.points;
  var rotationDegrees = Rotations$1.hasOwnProperty(direction) ?
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  Rotations$1[direction] : Rotations$1[Directions$1.LEFT];
  return React.createElement("svg", {
    style: {
      transform: "rotate(".concat(rotationDegrees, "deg)"),
      display: 'block',
      transition: 'transform 0.3s'
    },
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: points,
    fill: color
  }));
};
CaretIcon.category = 'Navigation';
CaretIcon.Directions = Directions$1;
CaretIcon.Sizes = Sizes$3;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartAreaIcon = function ChartAreaIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M3.29272 8.29309C3.09761 8.48834 3.00001 8.74417 3 8.99999V11C3 11.5523 3.44772 12 4 12H12C12.5523 12 13 11.5523 13 11V5C13 4.9316 12.9922 4.86935 12.9777 4.81313C12.9416 4.62244 12.8498 4.44023 12.7021 4.29269C12.3115 3.90228 11.6785 3.90246 11.2878 4.29309L8.99707 6.58535L7.70557 5.29309C7.51807 5.10543 7.26343 5 6.99829 5C6.73291 5 6.47852 5.10543 6.29102 5.29309L3.29272 8.29309Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H2Z",
    fill: color
  }));
};
ChartAreaIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartBarIcon = function ChartBarIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M7 2C7 1.44772 7.44775 1 8 1C8.55225 1 9 1.44772 9 2V11C9 11.5523 8.55225 12 8 12C7.44775 12 7 11.5523 7 11V2Z",
    fill: color
  }), React.createElement("path", {
    d: "M5 6C4.44775 6 4 6.44772 4 7V11C4 11.5523 4.44775 12 5 12C5.55225 12 6 11.5523 6 11V7C6 6.44772 5.55225 6 5 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M10 5C10 4.44772 10.4478 4 11 4C11.5522 4 12 4.44772 12 5V11C12 11.5523 11.5522 12 11 12C10.4478 12 10 11.5523 10 11V5Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H2Z",
    fill: color
  }));
};
ChartBarIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartBurndownIcon = function ChartBurndownIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M4.03117 2.00001C3.47889 1.9979 3.02946 2.4439 3.02735 2.99618C3.02524 3.54846 3.47124 3.99788 4.02352 3.99999C6.62536 4.00994 8.83781 5.67675 9.65886 7.99994H9.12452C8.56665 7.99994 8.29102 8.70544 8.6858 9.117L10.3088 10.8088C10.5535 11.0637 10.9482 11.0637 11.1926 10.8088L11.9688 9.99994H12V9.96728L12.8157 9.117C13.2105 8.70544 12.9285 7.99994 12.3709 7.99994H11.7477C10.8618 4.55884 7.74556 2.0142 4.03117 2.00001Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 13.9999C1 13.4477 1.44772 12.9999 2 12.9999H14C14.5523 12.9999 15 13.4477 15 13.9999C15 14.5522 14.5523 14.9999 14 14.9999H2C1.44772 14.9999 1 14.5522 1 13.9999Z",
    fill: color
  }));
};
ChartBurndownIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartLineIcon = function ChartLineIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M12.7021 4.29269C13.0928 4.6831 13.093 5.31625 12.7026 5.70691L9.70435 8.70691C9.51685 8.89456 9.26245 9 8.99707 9C8.73169 9 8.47729 8.89456 8.28979 8.70691L6.99829 7.41464L4.70728 9.70691C4.31689 10.0975 3.68384 10.0977 3.29321 9.7073C2.90234 9.31689 2.90234 8.68374 3.29272 8.29309L6.29102 5.29309C6.47852 5.10543 6.73291 5 6.99829 5C7.26343 5 7.51807 5.10543 7.70557 5.29309L8.99707 6.58535L11.2878 4.29309C11.6785 3.90246 12.3115 3.90228 12.7021 4.29269Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H2Z",
    fill: color
  }));
};
ChartLineIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartScatterplotIcon = function ChartScatterplotIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M14 4C14 4.55228 13.5522 5 13 5C12.4478 5 12 4.55228 12 4C12 3.44772 12.4478 3 13 3C13.5522 3 14 3.44772 14 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 11C3.55225 11 4 10.5523 4 10C4 9.44772 3.55225 9 3 9C2.44775 9 2 9.44772 2 10C2 10.5523 2.44775 11 3 11Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 9.5C9 10.3284 8.32837 11 7.5 11C6.67163 11 6 10.3284 6 9.5C6 8.67157 6.67163 8 7.5 8C8.32837 8 9 8.67157 9 9.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M8.5 6C9.32837 6 10 5.32843 10 4.5C10 3.67157 9.32837 3 8.5 3C7.67163 3 7 3.67157 7 4.5C7 5.32843 7.67163 6 8.5 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M6 6C6 6.55228 5.55225 7 5 7C4.44775 7 4 6.55228 4 6C4 5.44772 4.44775 5 5 5C5.55225 5 6 5.44772 6 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 9C11.5522 9 12 8.55228 12 8C12 7.44772 11.5522 7 11 7C10.4478 7 10 7.44772 10 8C10 8.55228 10.4478 9 11 9Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H2Z",
    fill: color
  }));
};
ChartScatterplotIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartStackedAreaIcon = function ChartStackedAreaIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M12.7021 2.29269C13.0928 2.6831 13.093 3.31625 12.7026 3.70691L9.70435 6.70691C9.51685 6.89456 9.26245 7 8.99707 7C8.73169 7 8.47729 6.89456 8.28979 6.70691L6.99829 5.41464L4.70728 7.70691C4.31689 8.09753 3.68384 8.09771 3.29321 7.7073C2.90234 7.31689 2.90234 6.68374 3.29272 6.29309L6.29102 3.29309C6.47852 3.10543 6.73291 3 6.99829 3C7.26343 3 7.51807 3.10543 7.70557 3.29309L8.99707 4.58535L11.2878 2.29309C11.6785 1.90246 12.3115 1.90228 12.7021 2.29269Z",
    fill: color
  }), React.createElement("path", {
    d: "M6.2909 8.12234L4.93161 9.48237L4.93351 9.48438C4.93351 9.48438 4.69133 9.72266 3.99406 10.4102C3.29895 11.0955 3.38609 11.9944 3.99426 12L3.99992 12H11.9999C12.5522 12 12.9999 11.5523 12.9999 11V7.01036L12.9998 6.99999C12.9998 6.47656 12.3632 6.04687 11.8008 6.6094L11.7891 6.6209L9.70427 8.7069C9.51677 8.89456 9.26237 8.99999 8.99699 8.99999C8.73161 8.99999 8.47722 8.89456 8.28972 8.7069L7.70551 8.12235C7.31495 7.73156 6.68147 7.73155 6.2909 8.12234Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 14C1 13.4477 1.44772 13 2 13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14Z",
    fill: color
  }));
};
ChartStackedAreaIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChartStackedBarIcon = function ChartStackedBarIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M9 2C9 2.55228 8.55229 3 8 3C7.44772 3 7 2.55228 7 2C7 1.44772 7.44772 1 8 1C8.55229 1 9 1.44772 9 2Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 6C8.55229 6 9 5.55228 9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M6 8C6 8.55229 5.55228 9 5 9C4.44772 9 4 8.55229 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M5 12C5.55228 12 6 11.5523 6 11C6 10.4477 5.55228 10 5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44772 13 1 13.4477 1 14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13H2Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 12C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10C10.4477 10 10 10.4477 10 11C10 11.5523 10.4477 12 11 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M12 8C12 8.55229 11.5523 9 11 9C10.4477 9 10 8.55229 10 8C10 7.44772 10.4477 7 11 7C11.5523 7 12 7.44772 12 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 6C11.5523 6 12 5.55228 12 5C12 4.44772 11.5523 4 11 4C10.4477 4 10 4.44772 10 5C10 5.55228 10.4477 6 11 6Z",
    fill: color
  }));
};
ChartStackedBarIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ChevronIcon = function ChevronIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5.24774 7.48938L7.41193 9.74524C7.73782 10.0849 8.26424 10.0849 8.59013 9.74524L10.7543 7.48938C11.2808 6.94066 10.9047 6 10.1611 6H5.83265C5.08897 6 4.72131 6.94066 5.24774 7.48938Z",
    fill: color
  }));
};
ChevronIcon.category = 'Navigation';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CircleIcon = function CircleIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    version: "1.1",
    fill: color,
    style: {
      display: 'block'
    }
  }, React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    fill: color
  }));
};
CircleIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$4 = {
  DEFAULT: 'default',
  SMALL: 'small'
};
var CloseIcon = function CloseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$4.DEFAULT : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, size === Sizes$4.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.70703 2.29289C3.31665 1.90237 2.68335 1.90237 2.29297 2.29289C1.90234 2.68342 1.90234 3.31658 2.29297 3.70711L6.58594 8L2.29297 12.2929C1.90234 12.6834 1.90234 13.3166 2.29297 13.7071C2.68335 14.0976 3.31665 14.0976 3.70703 13.7071L8 9.41414L12.293 13.7071C12.6833 14.0976 13.3167 14.0976 13.707 13.7071C14.0977 13.3166 14.0977 12.6834 13.707 12.2929L9.41406 8L13.707 3.70711C14.0977 3.31658 14.0977 2.68342 13.707 2.29289C13.3167 1.90237 12.6833 1.90237 12.293 2.29289L8 6.58586L3.70703 2.29289Z",
    fill: color
  }), size === Sizes$4.SMALL && React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5356 4.87872C12.9261 4.48822 12.9261 3.855 12.5356 3.4645C12.1451 3.07401 11.5119 3.07401 11.1214 3.4645L8.00004 6.58582L4.87872 3.4645C4.48822 3.07401 3.855 3.07401 3.4645 3.4645C3.07401 3.855 3.07401 4.48822 3.4645 4.87872L6.58582 8.00004L3.4645 11.1214C3.07401 11.5119 3.07401 12.1451 3.4645 12.5356C3.855 12.9261 4.48822 12.9261 4.87872 12.5356L8.00004 9.41425L11.1214 12.5356C11.5119 12.9261 12.1451 12.9261 12.5356 12.5356C12.9261 12.1451 12.9261 11.5119 12.5356 11.1214L9.41425 8.00004L12.5356 4.87872Z",
    fill: color
  }));
};
CloseIcon.category = 'Common Actions';
CloseIcon.Sizes = Sizes$4;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CodeIcon = function CodeIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.20703 5.20711C6.59766 4.8166 6.59766 4.18343 6.20703 3.79292C5.81665 3.40236 5.18335 3.40236 4.79297 3.79292L1.29297 7.29292C0.902344 7.68343 0.902344 8.3166 1.29297 8.70711L4.79297 12.2071C5.18335 12.5977 5.81665 12.5977 6.20703 12.2071C6.59766 11.8166 6.59766 11.1834 6.20703 10.7929L3.41431 8.00002L6.20703 5.20711Z",
    fill: color
  }), React.createElement("path", {
    d: "M9.79297 5.20711C9.40234 4.8166 9.40234 4.18343 9.79297 3.79292C10.1833 3.40236 10.8167 3.40236 11.207 3.79292L14.707 7.29292C15.0977 7.68343 15.0977 8.3166 14.707 8.70711L11.207 12.2071C10.8167 12.5977 10.1833 12.5977 9.79297 12.2071C9.40234 11.8166 9.40234 11.1834 9.79297 10.7929L12.5857 8.00002L9.79297 5.20711Z",
    fill: color
  }));
};
CodeIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$2 = {
  DEFAULT: 'default',
  OUTLINE: 'outline',
  COMPACT: 'compact'
};
var CommentIcon = function CommentIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$2.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$2.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.3938 1H13.5994C14.3696 1 15 1.67499 15 2.5V11.5C15 12.325 14.3696 13 13.5994 13H7.5C7.02148 13 6.78467 13.2289 6.42432 13.5773C6.10205 13.8889 5.68091 14.2962 4.89917 14.7206C4.677 14.8412 4.42676 14.6312 4.45044 14.3795C4.55713 13.2471 3.86084 13 3 13H2.69995C1.76123 13 1 12.2389 1 11.3V2.5C1 1.67499 1.62329 1 2.3938 1ZM4 5C4 4.44772 4.44775 4 5 4H11C11.5522 4 12 4.44772 12 5C12 5.55228 11.5522 6 11 6H5C4.44775 6 4 5.55228 4 5ZM5 8C4.44775 8 4 8.44772 4 9C4 9.55228 4.44775 10 5 10H9C9.55225 10 10 9.55228 10 9C10 8.44772 9.55225 8 9 8H5Z",
    fill: color
  }), type === Types$2.OUTLINE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.7 11C3.3134 11 3 10.6866 3 10.3V3.7C3 3.3134 3.3134 3 3.7 3H12.3C12.6866 3 13 3.3134 13 3.7V10.3C13 10.6866 12.6866 11 12.3 11H3.7ZM13.5994 1H2.3938C1.62329 1 1 1.67499 1 2.5V11.3C1 12.2389 1.76123 13 2.69995 13H3C3.86084 13 4.55713 13.2471 4.45044 14.3795C4.42676 14.6312 4.677 14.8412 4.89917 14.7206C5.68091 14.2962 6.10205 13.8889 6.42432 13.5773C6.78467 13.2289 7.02148 13 7.5 13H13.5994C14.3696 13 15 12.325 15 11.5V2.5C15 1.67499 14.3696 1 13.5994 1Z",
    fill: color
  }), type === Types$2.COMPACT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.3938 4H11.5994C12.3696 4 13 4.67499 13 5.5V10.5C13 11.325 12.3696 12 11.5994 12H9.5C9.02148 12 8.78467 12.2289 8.42432 12.5773C8.10205 12.8889 7.68091 13.2962 6.89917 13.7206C6.677 13.8412 6.42676 13.6312 6.45044 13.3795C6.55713 12.2471 5.86084 12 5 12H4.69995C3.76123 12 3 11.2389 3 10.3V5.5C3 4.67499 3.62329 4 4.3938 4Z",
    fill: color
  }));
};
CommentIcon.category = 'Entity';
CommentIcon.Types = Types$2;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var CopyIcon = function CopyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 1C10.1045 1 11 1.89539 11 3V5H13C14.1045 5 15 5.89539 15 7V13C15 14.1046 14.1045 15 13 15H7C5.89551 15 5 14.1046 5 13V11H3C1.89551 11 1 10.1046 1 9V3C1 1.89539 1.89551 1 3 1H9ZM5 9V7C5 5.89539 5.89551 5 7 5H9V3H3V9H5Z",
    fill: color
  }));
};
CopyIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var EnableIcon = function EnableIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V7.5C9 8.05228 8.55228 8.5 8 8.5C7.44772 8.5 7 8.05228 7 7.5V2C7 1.44772 7.44772 1 8 1ZM4.16173 3.28152C4.5758 3.64699 4.6152 4.27893 4.24974 4.693C3.47125 5.57502 3 6.73126 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 6.73126 12.5287 5.57502 11.7503 4.693C11.3848 4.27893 11.4242 3.64699 11.8383 3.28152C12.2523 2.91606 12.8843 2.95546 13.2497 3.36953C14.3383 4.60291 15 6.2254 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 6.2254 1.66166 4.60291 2.75026 3.36953C3.11573 2.95546 3.74766 2.91606 4.16173 3.28152Z",
    fill: color
  }));
};
EnableIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DashboardIcon = function DashboardIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M7.29297 7.29289L9.29297 5.29289C9.68335 4.90237 10.3167 4.90237 10.707 5.29289C11.0977 5.68341 11.0977 6.31659 10.707 6.70711L8.70703 8.70711C8.31665 9.09763 7.68335 9.09763 7.29297 8.70711C6.90234 8.31659 6.90234 7.68341 7.29297 7.29289Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8ZM8 3C5.23853 3 3 5.23857 3 8C3 9.6356 3.7854 11.0878 4.99951 12H11.0005C12.2146 11.0878 13 9.6356 13 8C13 5.23857 10.7615 3 8 3Z",
    fill: color
  }));
};
DashboardIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateAnticipatedFinishIcon = function DateAnticipatedFinishIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.15137 11.1494C6.46655 11.4637 7.00439 11.2405 7.00439 10.7954V7.20935C7.00439 6.76367 6.46509 6.54065 6.15039 6.85632L4.35718 8.6543C4.16211 8.84985 4.1626 9.1665 4.35815 9.36145L6.15137 11.1494Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 10.7954C9 11.2405 9.53784 11.4637 9.85303 11.1494L11.6462 9.36145C11.8418 9.1665 11.8423 8.84985 11.6472 8.6543L9.854 6.85632C9.53931 6.54065 9 6.76367 9 7.20935V10.7954Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2C5 1.44775 4.55225 1 4 1C3.44775 1 3 1.44775 3 2V3C1.89551 3 1 3.89539 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89539 14.1045 3 13 3V2C13 1.44775 12.5522 1 12 1C11.4478 1 11 1.44775 11 2V3H5V2ZM3 5V13H13V5H3Z",
    fill: color
  }));
};
DateAnticipatedFinishIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateCreatedIcon = function DateCreatedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2C5 1.44769 4.55225 1 4 1C3.44775 1 3 1.44769 3 2V3C1.89551 3 1 3.89545 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89545 14.1045 3 13 3V2C13 1.44769 12.5522 1 12 1C11.4478 1 11 1.44769 11 2V3H5V2ZM7 7C7 6.44769 7.44775 6 8 6C8.55225 6 9 6.44769 9 7V8H10C10.5522 8 11 8.44769 11 9C11 9.55231 10.5522 10 10 10H9V11C9 11.5523 8.55225 12 8 12C7.44775 12 7 11.5523 7 11V10H6C5.44775 10 5 9.55231 5 9C5 8.44769 5.44775 8 6 8H7V7Z",
    fill: color
  }));
};
DateCreatedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateFinishedIcon = function DateFinishedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1C4.55225 1 5 1.44769 5 2V3H11V2C11 1.44769 11.4478 1 12 1C12.5522 1 13 1.44769 13 2V3C14.1045 3 15 3.89545 15 5V13C15 14.1046 14.1045 15 13 15H3C1.89551 15 1 14.1046 1 13V5C1 3.89545 1.89551 3 3 3V2C3 1.44769 3.44775 1 4 1ZM11.207 8.20709C11.5977 7.81659 11.5977 7.18341 11.207 6.79291C10.8167 6.40234 10.1833 6.40234 9.79297 6.79291L7.5 9.08582L6.70703 8.29291C6.31665 7.90234 5.68335 7.90234 5.29297 8.29291C4.90234 8.68341 4.90234 9.31659 5.29297 9.70709L6.79297 11.2071C7.18335 11.5977 7.81665 11.5977 8.20703 11.2071L11.207 8.20709Z",
    fill: color
  }));
};
DateFinishedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateForecastedFinishIcon = function DateForecastedFinishIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2C5 1.44775 4.55225 1 4 1C3.44775 1 3 1.44775 3 2V3C1.89551 3 1 3.89539 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89539 14.1045 3 13 3V2C13 1.44775 12.5522 1 12 1C11.4478 1 11 1.44775 11 2V3H5V2ZM3 10V13H13V5H3V8H7.90015V7.05957C7.90015 6.65356 8.3584 6.41687 8.68945 6.65186L11.4331 8.59998C11.7141 8.79944 11.7139 9.21667 11.4326 9.41577L8.68896 11.3574C8.35767 11.5918 7.90015 11.355 7.90015 10.9493V10H3Z",
    fill: color
  }));
};
DateForecastedFinishIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateLastRunIcon = function DateLastRunIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2C5 1.44769 4.55225 1 4 1C3.44775 1 3 1.44769 3 2V3C1.89551 3 1 3.89545 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89545 14.1045 3 13 3V2C13 1.44769 12.5522 1 12 1C11.4478 1 11 1.44769 11 2V3H5V2ZM5.77734 11.2888C5.44507 11.5103 5 11.2721 5 10.8727V7.1413C5 6.74194 5.44507 6.50372 5.77734 6.72528L8.57593 8.591C8.8728 8.78888 8.8728 9.22516 8.57593 9.42303L5.77734 11.2888ZM10 6C9.44775 6 9 6.44769 9 7V11C9 11.5523 9.44775 12 10 12C10.5522 12 11 11.5523 11 11V7C11 6.44769 10.5522 6 10 6Z",
    fill: color
  }));
};
DateLastRunIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateLastStateChangedIcon = function DateLastStateChangedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1C4.55225 1 5 1.44769 5 2V3H11V2C11 1.44769 11.4478 1 12 1C12.5522 1 13 1.44769 13 2V3C14.1045 3 15 3.89545 15 5V13C15 14.1046 14.1045 15 13 15H3C1.89551 15 1 14.1046 1 13V5C1 3.89545 1.89551 3 3 3V2C3 1.44769 3.44775 1 4 1ZM4 10.8727C4 11.2721 4.44507 11.5103 4.77734 11.2888L7.57593 9.42303C7.8728 9.22516 7.8728 8.78888 7.57593 8.591L4.77734 6.72528C4.44507 6.50372 4 6.74194 4 7.1413V10.8727ZM9 10.8728C9 11.2722 9.44507 11.5104 9.77734 11.2888L12.5759 9.42309C12.8728 9.22522 12.8728 8.78894 12.5759 8.59106L9.77734 6.72534C9.44507 6.50378 9 6.742 9 7.14135V10.8728Z",
    fill: color
  }));
};
DateLastStateChangedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DatePlannedFinishIcon = function DatePlannedFinishIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M11.207 8.20715C11.5977 7.81653 11.5977 7.18347 11.207 6.79285C10.8167 6.40234 10.1833 6.40234 9.79297 6.79285L7.5 9.08582L6.70703 8.29285C6.31665 7.90234 5.68335 7.90234 5.29297 8.29285C4.90234 8.68347 4.90234 9.31653 5.29297 9.70715L6.79297 11.2072C7.18335 11.5977 7.81665 11.5977 8.20703 11.2072L11.207 8.20715Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1C4.55225 1 5 1.44775 5 2V3H11V2C11 1.44775 11.4478 1 12 1C12.5522 1 13 1.44775 13 2V3C14.1045 3 15 3.89539 15 5V13C15 14.1046 14.1045 15 13 15H3C1.89551 15 1 14.1046 1 13V5C1 3.89539 1.89551 3 3 3V2C3 1.44775 3.44775 1 4 1ZM3 13V5H13V13H3Z",
    fill: color
  }));
};
DatePlannedFinishIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DatePlannedStartIcon = function DatePlannedStartIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.30005 10.8657C6.30005 11.2651 6.74512 11.5033 7.07739 11.2817L9.87598 9.41602C10.1729 9.21814 10.1729 8.78186 9.87598 8.58398L7.07739 6.71826C6.74512 6.4967 6.30005 6.73486 6.30005 7.13428V10.8657Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2C5 1.44775 4.55225 1 4 1C3.44775 1 3 1.44775 3 2V3C1.89551 3 1 3.89539 1 5V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V5C15 3.89539 14.1045 3 13 3V2C13 1.44775 12.5522 1 12 1C11.4478 1 11 1.44775 11 2V3H5V2ZM3 5H13V13H3V5Z",
    fill: color
  }));
};
DatePlannedStartIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DateStartedIcon = function DateStartedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 1C4.55225 1 5 1.44769 5 2V3H11V2C11 1.44769 11.4478 1 12 1C12.5522 1 13 1.44769 13 2V3C14.1045 3 15 3.89545 15 5V13C15 14.1046 14.1045 15 13 15H3C1.89551 15 1 14.1046 1 13V5C1 3.89545 1.89551 3 3 3V2C3 1.44769 3.44775 1 4 1ZM6.30005 10.8657C6.30005 11.2651 6.74512 11.5033 7.07739 11.2817L9.87598 9.41602C10.1729 9.21814 10.1729 8.78186 9.87598 8.58398L7.07739 6.71826C6.74512 6.4967 6.30005 6.73492 6.30005 7.13428V10.8657Z",
    fill: color
  }));
};
DateStartedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DescriptionIcon = function DescriptionIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4C1.5 3.44772 1.94772 3 2.5 3H13.5C14.0523 3 14.5 3.44772 14.5 4C14.5 4.55228 14.0523 5 13.5 5H2.5C1.94772 5 1.5 4.55228 1.5 4ZM1.5 8C1.5 7.44772 1.94772 7 2.5 7H13.5C14.0523 7 14.5 7.44772 14.5 8C14.5 8.55228 14.0523 9 13.5 9H2.5C1.94772 9 1.5 8.55228 1.5 8ZM2.5 11C1.94772 11 1.5 11.4477 1.5 12C1.5 12.5523 1.94772 13 2.5 13H10.5C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11H2.5Z",
    fill: color
  }));
};
DescriptionIcon.category = 'Entity';

var _Rotations$2;
var Directions$2 = {
  LEFT: 'left',
  RIGHT: 'right'
};
var Rotations$2 = (_Rotations$2 = {}, _defineProperty(_Rotations$2, Directions$2.LEFT, 0), _defineProperty(_Rotations$2, Directions$2.RIGHT, -180), _Rotations$2);
var DoubleCaretIcon = function DoubleCaretIcon(_ref) {
  var direction = _ref.direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  var rotationDegrees = Rotations$2.hasOwnProperty(direction) ?
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  Rotations$2[direction] : Rotations$2[Directions$2.LEFT];
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      transform: "rotate(".concat(rotationDegrees, "deg)"),
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70711 11.7071C7.31658 12.0976 6.68342 12.0976 6.29289 11.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289L6.29289 4.29289C6.68342 3.90237 7.31658 3.90237 7.70711 4.29289C8.09763 4.68342 8.09763 5.31658 7.70711 5.70711L5.41421 8L7.70711 10.2929C8.09763 10.6834 8.09763 11.3166 7.70711 11.7071Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289L10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289C12.0976 4.68342 12.0976 5.31658 11.7071 5.70711L9.41421 8L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071Z",
    fill: color
  }));
};
DoubleCaretIcon.category = 'Navigation';
DoubleCaretIcon.Directions = Directions$2;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DownloadIcon = function DownloadIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M9 2C9 1.44775 8.55225 1 8 1C7.44775 1 7 1.44775 7 2V7.58582L5.70715 6.29285C5.31653 5.90234 4.68347 5.90234 4.29285 6.29285C3.90234 6.68347 3.90234 7.31653 4.29285 7.70715L7.29285 10.7072C7.68347 11.0977 8.31653 11.0977 8.70715 10.7072L11.7072 7.70715C12.0977 7.31653 12.0977 6.68347 11.7072 6.29285C11.3165 5.90234 10.6835 5.90234 10.2928 6.29285L9 7.58582V2Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44775 13 1 13.4478 1 14C1 14.5522 1.44775 15 2 15H14C14.5522 15 15 14.5522 15 14C15 13.4478 14.5522 13 14 13H2Z",
    fill: color
  }));
};
DownloadIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var DragdropIndicatorIcon = function DragdropIndicatorIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "4px",
    height: "16px",
    viewBox: "0 0 4 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1 1C0.447754 1 0 1.44775 0 2C0 2.55225 0.447754 3 1 3H3C3.55225 3 4 2.55225 4 2C4 1.44775 3.55225 1 3 1H1Z",
    fill: color
  }), React.createElement("path", {
    d: "M0 6C0 5.44775 0.447754 5 1 5H3C3.55225 5 4 5.44775 4 6C4 6.55225 3.55225 7 3 7H1C0.447754 7 0 6.55225 0 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 9C0.447754 9 0 9.44775 0 10C0 10.5522 0.447754 11 1 11H3C3.55225 11 4 10.5522 4 10C4 9.44775 3.55225 9 3 9H1Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 13C0.447754 13 0 13.4478 0 14C0 14.5522 0.447754 15 1 15H3C3.55225 15 4 14.5522 4 14C4 13.4478 3.55225 13 3 13H1Z",
    fill: color
  }));
};
DragdropIndicatorIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var EditIcon = function EditIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M8.91699 3.6046L2.71875 9.80287C2.47534 10.0461 2.29907 10.3479 2.20654 10.6792L1 15L5.32056 13.7932C5.65186 13.7007 5.95361 13.5244 6.19678 13.2812L12.3953 7.08284L8.91699 3.6046Z",
    fill: color
  }), React.createElement("path", {
    d: "M13.7866 5.69152L14.5857 4.89242C15.3667 4.11136 15.3667 2.84504 14.5857 2.06399L13.9358 1.41415C13.1548 0.633108 11.8884 0.633108 11.1074 1.41415L10.3083 2.21326L13.7866 5.69152Z",
    fill: color
  }));
};
EditIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var EmotionIcon = function EmotionIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M10.5 9.5C10.5 10.5 9 11.5 8 11.5C7 11.5 5.5 10.5 5.5 9.5C5.5 9 6.75 9 8 9C9.25 9 10.5 9 10.5 9.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 6.25C11 6.94031 10.4404 7.5 9.75 7.5C9.05957 7.5 8.5 6.94031 8.5 6.25C8.5 5.55969 9.05957 5 9.75 5C10.4404 5 11 5.55969 11 6.25Z",
    fill: color
  }), React.createElement("path", {
    d: "M6.25 7.5C6.94043 7.5 7.5 6.94031 7.5 6.25C7.5 5.55969 6.94043 5 6.25 5C5.55957 5 5 5.55969 5 6.25C5 6.94031 5.55957 7.5 6.25 7.5Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM13 8C13 10.7615 10.7615 13 8 13C5.23853 13 3 10.7615 3 8C3 5.23853 5.23853 3 8 3C10.7615 3 13 5.23853 13 8Z",
    fill: color
  }));
};
EmotionIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ExternalIcon = function ExternalIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M10.7573 1C10.2051 1 9.75732 1.44769 9.75732 2C9.75732 2.55225 10.2051 3 10.7573 3H11.5857L7.29297 7.29291C6.90234 7.68341 6.90234 8.31659 7.29297 8.70709C7.68335 9.09766 8.31665 9.09766 8.70703 8.70709L13 4.41418V5.24261C13 5.79492 13.4478 6.24261 14 6.24261C14.5522 6.24261 15 5.79492 15 5.24261V2C15 1.73474 14.8945 1.48041 14.707 1.29285C14.5195 1.10535 14.2651 1 14 1H10.7573Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.16553 3.06921C7.71021 2.97784 8.07764 2.46222 7.98633 1.91754C7.89478 1.37286 7.37915 1.00543 6.83447 1.0968C3.52319 1.65234 1 4.53058 1 8.00006C1 11.866 4.13403 15.0001 8 15.0001C11.4695 15.0001 14.3477 12.4769 14.9033 9.16553C14.9946 8.62085 14.6272 8.10522 14.0825 8.01385C13.5378 7.92242 13.0222 8.28992 12.9309 8.83459C12.5342 11.1986 10.4766 13.0001 8 13.0001C5.23853 13.0001 3 10.7615 3 8.00006C3 5.52356 4.80151 3.46582 7.16553 3.06921Z",
    fill: color
  }));
};
ExternalIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 4C6.44775 4 6 4.44771 6 5C6 5.55229 6.44775 6 7 6H8.58569L4.29297 10.2929C3.90234 10.6834 3.90234 11.3166 4.29297 11.7071C4.68335 12.0976 5.31665 12.0976 5.70703 11.7071L10 7.41422V9C10 9.55229 10.4478 10 11 10C11.5522 10 12 9.55229 12 9V5C12 4.44771 11.5522 4 11 4H7Z",
    fill: color
  }));
};
ExternalLinkIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$3 = {
  DEFAULT: 'default',
  CHECKED: 'checked'
};
var FavoriteIcon = function FavoriteIcon(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$3.DEFAULT : _ref$type,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$3.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.00001 4.46739L7.55056 5.36509C7.11027 6.2445 6.2669 6.85227 5.29336 6.99171L4.34204 7.12798L5.0022 7.76231C5.72152 8.45348 6.05023 9.45699 5.87923 10.4398L5.71776 11.3678L6.61964 10.9004C7.48522 10.4519 8.51479 10.4519 9.38037 10.9004L10.2823 11.3678L10.1208 10.4398C9.94978 9.45699 10.2785 8.45348 10.9978 7.76231L11.658 7.12798L10.7066 6.99171C9.73311 6.85227 8.88975 6.24451 8.44945 5.36509L8.00001 4.46739ZM8.89419 1.78601C8.5255 1.0496 7.47451 1.0496 7.10582 1.78601L5.76218 4.46971C5.61542 4.76285 5.33429 4.96544 5.00978 5.01192L2.02923 5.43885C1.20455 5.55697 0.877441 6.5726 1.47816 7.14982L3.61649 9.20446C3.85627 9.43485 3.96583 9.76935 3.90883 10.097L3.40155 13.0125C3.25975 13.8275 4.11241 14.4524 4.84687 14.0718L7.53989 12.6762C7.82841 12.5266 8.1716 12.5266 8.46013 12.6762L11.1531 14.0718C11.8876 14.4524 12.7403 13.8275 12.5985 13.0125L12.0912 10.097C12.0342 9.76935 12.1437 9.43485 12.3835 9.20446L14.5218 7.14982C15.1226 6.5726 14.7955 5.55697 13.9708 5.43885L10.9902 5.01192C10.6657 4.96544 10.3846 4.76285 10.2378 4.46971L8.89419 1.78601Z",
    fill: color
  }), type === Types$3.CHECKED && React.createElement("path", {
    d: "M7.10582 1.78601C7.47451 1.0496 8.5255 1.0496 8.89419 1.78601L10.2378 4.46971C10.3846 4.76285 10.6657 4.96544 10.9902 5.01192L13.9708 5.43885C14.7955 5.55697 15.1226 6.5726 14.5218 7.14982L12.3835 9.20446C12.1437 9.43485 12.0342 9.76935 12.0912 10.097L12.5985 13.0125C12.7403 13.8275 11.8876 14.4524 11.1531 14.0718L8.46013 12.6762C8.1716 12.5266 7.82841 12.5266 7.53989 12.6762L4.84687 14.0718C4.11241 14.4524 3.25975 13.8275 3.40155 13.0125L3.90883 10.097C3.96583 9.76935 3.85627 9.43485 3.61649 9.20446L1.47816 7.14982C0.877441 6.5726 1.20455 5.55697 2.02923 5.43885L5.00978 5.01192C5.33429 4.96544 5.61542 4.76285 5.76218 4.46971L7.10582 1.78601Z",
    fill: Active500
  }));
};
FavoriteIcon.category = 'Common Actions';
FavoriteIcon.Types = Types$3;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$4 = {
  ON: 'on',
  OFF: 'off'
};
var FilterIcon = function FilterIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$4.ON : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$4.ON && React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.48124 4.59224C2.4811 4.59223 2.48186 4.5907 2.48393 4.5877C2.48241 4.59076 2.48137 4.59226 2.48124 4.59224ZM2.57671 4.5C2.59809 4.48348 2.62396 4.46486 2.65516 4.4442C2.87942 4.29575 3.25342 4.13302 3.78281 3.98479C4.83113 3.69125 6.3224 3.5 8 3.5C9.6776 3.5 11.1689 3.69125 12.2172 3.98479C12.7466 4.13302 13.1206 4.29575 13.3448 4.4442C13.376 4.46486 13.4019 4.48348 13.4233 4.5C13.4019 4.51651 13.376 4.53514 13.3448 4.5558C13.1206 4.70425 12.7466 4.86698 12.2172 5.01521C11.1689 5.30875 9.6776 5.5 8 5.5C6.3224 5.5 4.83113 5.30875 3.78281 5.01521C3.25342 4.86698 2.87942 4.70425 2.65516 4.5558C2.62396 4.53514 2.59809 4.51652 2.57671 4.5ZM13.5188 4.59224C13.5186 4.59226 13.5176 4.59076 13.5161 4.5877C13.5181 4.5907 13.5189 4.59223 13.5188 4.59224ZM13.5161 4.4123C13.5176 4.40924 13.5186 4.40774 13.5188 4.40776C13.5189 4.40777 13.5181 4.4093 13.5161 4.4123ZM2.48393 4.4123C2.48186 4.4093 2.4811 4.40777 2.48124 4.40776C2.48137 4.40774 2.48241 4.40924 2.48393 4.4123ZM3.37836 2.54034C4.59209 2.2005 6.22582 2 8 2C9.77418 2 11.4079 2.2005 12.6216 2.54034C13.2233 2.7088 13.7646 2.92316 14.1728 3.19344C14.5519 3.44434 15 3.8706 15 4.5C15 5.1294 14.5519 5.55566 14.1728 5.80656C13.7646 6.07684 13.2233 6.2912 12.6216 6.45966C11.4079 6.7995 9.77418 7 8 7C6.22582 7 4.59209 6.7995 3.37836 6.45966C2.77672 6.2912 2.23543 6.07684 1.82716 5.80656C1.44815 5.55566 1 5.1294 1 4.5C1 3.8706 1.44815 3.44434 1.82716 3.19344C2.23543 2.92316 2.77672 2.7088 3.37836 2.54034ZM3.07761 8.66776C3.2611 8.2964 3.71089 8.14411 4.08224 8.3276C4.94675 8.75477 6.212 9 8 9C9.788 9 11.0533 8.75477 11.9178 8.3276C12.2891 8.14411 12.7389 8.2964 12.9224 8.66776C13.1059 9.03911 12.9536 9.4889 12.5822 9.6724C11.4229 10.2452 9.89431 10.5 8 10.5C6.10569 10.5 4.57706 10.2452 3.41776 9.6724C3.0464 9.4889 2.89411 9.03911 3.07761 8.66776ZM10.1887 12.9532C10.3526 13.3336 10.177 13.7749 9.79663 13.9388C9.26881 14.1662 8.67451 14.2669 8.02749 14.2669C7.40125 14.2669 6.82449 14.1726 6.30945 13.9603C5.92648 13.8025 5.74397 13.3641 5.90179 12.9811C6.05962 12.5982 6.49801 12.4157 6.88098 12.5735C7.17479 12.6946 7.54892 12.7669 8.02749 12.7669C8.522 12.7669 8.90494 12.6897 9.20311 12.5612C9.58352 12.3973 10.0248 12.5728 10.1887 12.9532Z",
    fill: color
  }), type === Types$4.OFF && React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70711 14.7071L14.7071 2.70711C15.0976 2.31658 15.0976 1.68342 14.7071 1.29289C14.3166 0.902369 13.6834 0.902369 13.2929 1.29289L12.1627 2.42311C11.0101 2.15487 9.55931 2 8 2C6.22582 2 4.59209 2.2005 3.37836 2.54034C2.77672 2.7088 2.23543 2.92316 1.82716 3.19344C1.44815 3.44434 1 3.8706 1 4.5C1 5.1294 1.44815 5.55566 1.82716 5.80656C2.23543 6.07684 2.77672 6.2912 3.37836 6.45966C4.49784 6.77312 5.97464 6.96802 7.58938 6.9964L5.75189 8.8339C5.07815 8.71906 4.52716 8.54742 4.08229 8.3276C3.71093 8.14411 3.26114 8.2964 3.07765 8.66776C2.89416 9.03911 3.04645 9.4889 3.4178 9.67239C3.74837 9.83573 4.10896 9.97321 4.49949 10.0863L1.29289 13.2929C0.902369 13.6834 0.902369 14.3166 1.29289 14.7071C1.68342 15.0976 2.31658 15.0976 2.70711 14.7071ZM10.8809 3.7049C10.0369 3.57568 9.05533 3.5 8 3.5C6.3224 3.5 4.83113 3.69125 3.7828 3.98479C3.25342 4.13302 2.87942 4.29575 2.65516 4.4442C2.62396 4.46486 2.59809 4.48348 2.57671 4.5C2.59809 4.51652 2.62396 4.53514 2.65516 4.5558C2.87942 4.70425 3.25342 4.86698 3.7828 5.01521C4.83113 5.30875 6.3224 5.5 8 5.5C8.38219 5.5 8.7547 5.49007 9.11451 5.47127L10.8809 3.7049Z",
    fill: color
  }), React.createElement("path", {
    d: "M14.8859 5.02833L14.0023 5.91187C14.0614 5.87775 14.1183 5.84265 14.1728 5.80656C14.4342 5.63356 14.7284 5.37719 14.8859 5.02833Z",
    fill: color
  }), React.createElement("path", {
    d: "M9.47273 10.4415L11.354 8.56021C11.5584 8.49019 11.746 8.41249 11.9178 8.3276C12.2892 8.14411 12.7389 8.2964 12.9224 8.66776C13.1059 9.03911 12.9536 9.4889 12.5823 9.67239C11.7402 10.0885 10.7032 10.3368 9.47273 10.4415Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.23013 12.6841L6.09141 13.8228C6.15386 13.8794 6.22699 13.9264 6.3094 13.9603C6.82444 14.1726 7.40121 14.2669 8.02744 14.2669C8.67447 14.2669 9.26876 14.1662 9.79658 13.9388C10.177 13.7749 10.3525 13.3336 10.1886 12.9532C10.0247 12.5728 9.58347 12.3973 9.20306 12.5612C8.90489 12.6897 8.52195 12.7669 8.02744 12.7669C7.72095 12.7669 7.45729 12.7372 7.23013 12.6841Z",
    fill: color
  })));
};
FilterIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var FunctionIcon = function FunctionIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 4C7 3.49051 7.4246 3 8 3C8.5754 3 9 3.49051 9 4C9 4.55228 9.44772 5 10 5C10.5523 5 11 4.55228 11 4C11 2.50949 9.7996 1 8 1C6.2004 1 5 2.50949 5 4V6H4C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H5V12C5 12.5163 4.5886 13 4 13C3.4114 13 3 12.5163 3 12C3 11.4477 2.55228 11 2 11C1.44772 11 1 11.4477 1 12C1 13.4837 2.17454 15 4 15C5.82546 15 7 13.4837 7 12V8H8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6H7V4Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.4142 12L14.7071 13.2929C15.0976 13.6834 15.0976 14.3166 14.7071 14.7071C14.3166 15.0976 13.6834 15.0976 13.2929 14.7071L12 13.4142L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L10.5858 12L9.29289 10.7071C8.90237 10.3166 8.90237 9.68342 9.29289 9.29289C9.68342 8.90237 10.3166 8.90237 10.7071 9.29289L12 10.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L13.4142 12Z",
    fill: color
  }));
};
FunctionIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var FocusIcon = function FocusIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1C8.55225 1 9 1.44771 9 2V2.08296C11.5125 2.50449 13.4954 4.4875 13.917 7H14C14.5522 7 15 7.44771 15 8C15 8.55229 14.5522 9 14 9H13.917C13.4954 11.5125 11.5125 13.4955 9 13.917V14C9 14.5523 8.55225 15 8 15C7.44775 15 7 14.5523 7 14V13.917C4.48755 13.4955 2.50464 11.5125 2.08301 9H2C1.44751 9 1 8.55229 1 8C1 7.44771 1.44751 7 2 7H2.08301C2.50464 4.4875 4.48755 2.50449 7 2.08296V2C7 1.44771 7.44775 1 8 1ZM7 4.12601C5.59424 4.48778 4.48779 5.59439 4.12598 7H5C5.55225 7 6 7.44771 6 8C6 8.55229 5.55225 9 5 9H4.12598C4.48779 10.4056 5.59424 11.5122 7 11.874V11C7 10.4477 7.44775 10 8 10C8.55225 10 9 10.4477 9 11V11.874C10.4058 11.5122 11.5122 10.4056 11.874 9H11C10.4475 9 10 8.55229 10 8C10 7.44771 10.4475 7 11 7H11.874C11.5122 5.59439 10.4058 4.48778 9 4.12601V5C9 5.55228 8.55225 6 8 6C7.44775 6 7 5.55228 7 5V4.12601Z",
    fill: color
  }));
};
FocusIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$5 = {
  DEFAULT: 'default',
  OPEN: 'open'
};
var FolderIcon = function FolderIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$5.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    fill: "none",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$5.DEFAULT && React.createElement("path", {
    d: "M3 2C1.89551 2 1 2.89543 1 4V12C1 13.1046 1.89543 14 3 14C6.33333 14 9.66667 14 13 14C14.1046 14 15 13.1046 15 12V6C15 4.89543 14.1045 4 13 4H7.5L6 2H3Z",
    fill: color
  }), type === Types$5.OPEN && React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4C1 2.89543 1.89551 2 3 2H5.75C5.90738 2 6.05557 2.0741 6.15 2.2L7.35 3.8C7.44443 3.9259 7.59262 4 7.75 4H13C14.1045 4 15 4.89543 15 6V7.12603C14.6804 7.04376 14.3453 7 14 7H9.49998L8.74998 6C8.27785 5.37049 7.53688 5 6.74998 5H3.99998C2.80535 5 1.73296 5.52375 1 6.35419V4ZM3.43959 14H13C14.1046 14 15 13.1046 15 12V9.26759C14.7058 9.09741 14.3643 9 14 9H8.74998C8.59261 9 8.44441 8.9259 8.34998 8.8L7.14998 7.2C7.05556 7.0741 6.90736 7 6.74998 7H3.99998C2.89549 7 1.99998 7.89543 1.99998 9L1.47843 11.6078C1.23091 12.8454 2.1775 14 3.43959 14Z",
    fill: color
  }));
};
FolderIcon.category = 'Boards & Views';
FolderIcon.Types = Types$5;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$6 = {
  DEFAULT: 'default',
  OFF: 'off'
};
var FullscreenIcon = function FullscreenIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$6.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, type === Types$6.DEFAULT && React.createElement("path", {
    d: "M3.00098 10C2.45098 10 2.00098 10.45 2.00098 11V13C2.00098 13.55 2.45098 14 3.00098 14H5.00098C5.55098 14 6.00098 13.55 6.00098 13C6.00098 12.45 5.55098 12 5.00098 12H4.00098V11C4.00098 10.45 3.55098 10 3.00098 10ZM3.00098 6C3.55098 6 4.00098 5.55 4.00098 5V4H5.00098C5.55098 4 6.00098 3.55 6.00098 3C6.00098 2.45 5.55098 2 5.00098 2H3.00098C2.45098 2 2.00098 2.45 2.00098 3V5C2.00098 5.55 2.45098 6 3.00098 6ZM12.001 12H11.001C10.451 12 10.001 12.45 10.001 13C10.001 13.55 10.451 14 11.001 14H13.001C13.551 14 14.001 13.55 14.001 13V11C14.001 10.45 13.551 10 13.001 10C12.451 10 12.001 10.45 12.001 11V12ZM10.001 3C10.001 3.55 10.451 4 11.001 4H12.001V5C12.001 5.55 12.451 6 13.001 6C13.551 6 14.001 5.55 14.001 5V3C14.001 2.45 13.551 2 13.001 2H11.001C10.451 2 10.001 2.45 10.001 3Z",
    fill: color
  }), type === Types$6.OFF && React.createElement("g", null, React.createElement("path", {
    d: "M4.00098 3C4.00098 2.45 4.45098 2 5.00098 2C5.55098 2 6.00098 2.45 6.00098 3L6.00098 5C6.00098 5.55 5.55098 6 5.00098 6L3.00098 6C2.45098 6 2.00098 5.55 2.00098 5C2.00098 4.45 2.45098 4 3.00098 4H4.00098V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M13 4C13.55 4 14 4.45 14 5C14 5.55 13.55 6 13 6H11C10.45 6 10 5.55 10 5V3C10 2.45 10.45 2 11 2C11.55 2 12 2.45 12 3V4H13Z",
    fill: color
  }), React.createElement("path", {
    d: "M12 13C12 13.55 11.55 14 11 14C10.45 14 10 13.55 10 13V11C10 10.45 10.45 10 11 10H13C13.55 10 14 10.45 14 11C14 11.55 13.55 12 13 12H12V13Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 12C2.45 12 2 11.55 2 11C2 10.45 2.45 10 3 10H5C5.55 10 6 10.45 6 11V13C6 13.55 5.55 14 5 14C4.45 14 4 13.55 4 13L4 12H3Z",
    fill: color
  }))));
};
FullscreenIcon.category = 'Navigation';
FullscreenIcon.Types = Types$6;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$5 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var GitHubIcon = function GitHubIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$5.DEFAULT : _ref$size;
  var numericSize = size === Sizes$5.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    style: size === Sizes$5.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    },
    d: "M11.9991 2C6.47773 2 2 6.59044 2 12.2534C2 16.7828 4.86504 20.626 8.83876 21.9825C9.33908 22.0762 9.52141 21.7597 9.52141 21.4877C9.52141 21.2442 9.51282 20.5996 9.50791 19.7442C6.72636 20.3636 6.13948 18.3696 6.13948 18.3696C5.68459 17.185 5.02895 16.8696 5.02895 16.8696C4.121 16.2339 5.09771 16.2465 5.09771 16.2465C6.10142 16.3189 6.62936 17.3033 6.62936 17.3033C7.52135 18.8699 8.97014 18.4174 9.53983 18.1549C9.63069 17.4927 9.88913 17.0408 10.1746 16.7846C7.95414 16.5253 5.61951 15.646 5.61951 11.7171C5.61951 10.5974 6.00934 9.68282 6.64901 8.9659C6.54588 8.70658 6.20271 7.66422 6.74723 6.25242C6.74723 6.25242 7.58642 5.97672 9.49685 7.30293C10.2943 7.07571 11.1501 6.96241 12.0003 6.958C12.8499 6.96241 13.7051 7.07571 14.5038 7.30293C16.413 5.97672 17.2509 6.25242 17.2509 6.25242C17.7967 7.66422 17.4535 8.70658 17.351 8.9659C17.9919 9.68282 18.3787 10.5974 18.3787 11.7171C18.3787 15.6561 16.0403 16.5228 13.8131 16.7765C14.1716 17.0931 14.4915 17.7187 14.4915 18.6754C14.4915 20.0457 14.4792 21.1516 14.4792 21.4877C14.4792 21.7622 14.6597 22.0813 15.1668 21.9812C19.1374 20.6223 22 16.7821 22 12.2534C22 6.59044 17.5223 2 11.9991 2",
    fill: "#1B1817"
  }));
};
GitHubIcon.category = 'Tool';
GitHubIcon.Sizes = Sizes$5;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$6 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var GitLabIcon = function GitLabIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$6.DEFAULT : _ref$size;
  var numericSize = size === Sizes$6.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$6.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    }
  }, React.createElement("path", {
    d: "M21.9629 13.3185L20.8455 9.88408L18.6343 3.07202C18.6088 2.99602 18.5601 2.92995 18.495 2.88313C18.43 2.83631 18.3519 2.81113 18.2717 2.81113C18.1916 2.81113 18.1135 2.83631 18.0484 2.88313C17.9834 2.92995 17.9347 2.99602 17.9092 3.07202L15.6992 9.87994H8.35175L6.14055 3.07202C6.1151 2.99602 6.0664 2.92995 6.00135 2.88313C5.93629 2.83631 5.85817 2.81113 5.77803 2.81113C5.69788 2.81113 5.61976 2.83631 5.5547 2.88313C5.48965 2.92995 5.44095 2.99602 5.4155 3.07202L3.20843 9.87994L2.09042 13.3185C2.04087 13.4711 2.04082 13.6356 2.09027 13.7883C2.13972 13.941 2.23615 14.0742 2.36579 14.1688L12.0249 21.1889L21.684 14.1688C21.8142 14.0746 21.9112 13.9416 21.9613 13.7889C22.0114 13.6362 22.012 13.4715 21.9629 13.3185",
    fill: "#FC6D26"
  }), React.createElement("path", {
    d: "M12.0271 21.1824L15.6991 9.87935H8.354L12.0271 21.1824Z",
    fill: "#E24329"
  }), React.createElement("path", {
    d: "M12.0248 21.1829L8.35165 9.87935H3.21069L12.0248 21.1829Z",
    fill: "#FC6D26"
  }), React.createElement("path", {
    d: "M3.20673 9.88348L2.08872 13.3179C2.03917 13.4705 2.03911 13.635 2.08856 13.7877C2.13801 13.9404 2.23444 14.0736 2.36408 14.1682L12.0232 21.1889L3.20673 9.88348Z",
    fill: "#FCA326"
  }), React.createElement("path", {
    d: "M3.20801 9.88348H8.35546L6.14012 3.07556C6.11467 2.99956 6.06597 2.93349 6.00092 2.88667C5.93587 2.83985 5.85775 2.81467 5.7776 2.81467C5.69745 2.81467 5.61933 2.83985 5.55428 2.88667C5.48922 2.93349 5.44053 2.99956 5.41507 3.07556L3.20801 9.88348Z",
    fill: "#E24329"
  }), React.createElement("path", {
    d: "M12.0273 21.1829L15.6993 9.87935H20.8462L12.0273 21.1829Z",
    fill: "#FC6D26"
  }), React.createElement("path", {
    d: "M20.8443 9.88348L21.9629 13.3179C22.0124 13.4705 22.0125 13.635 21.963 13.7877C21.9136 13.9404 21.8171 14.0736 21.6875 14.1682L12.0278 21.1824L20.8443 9.88348V9.88348Z",
    fill: "#FCA326"
  }), React.createElement("path", {
    d: "M20.8473 9.88348H15.6992L17.9104 3.07556C17.9359 2.99956 17.9846 2.93349 18.0496 2.88667C18.1147 2.83985 18.1928 2.81467 18.2729 2.81467C18.3531 2.81467 18.4312 2.83985 18.4963 2.88667C18.5613 2.93349 18.61 2.99956 18.6355 3.07556L20.8467 9.88348H20.8473Z",
    fill: "#E24329"
  })));
};
GitLabIcon.category = 'Tool';
GitLabIcon.Sizes = Sizes$6;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var HelpIcon = function HelpIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8ZM8 4.79999C7.26367 4.79999 6.66675 5.39694 6.66675 6.13333C6.66675 6.68561 6.21899 7.13333 5.66675 7.13333C5.1145 7.13333 4.66675 6.68561 4.66675 6.13333C4.66675 4.29236 6.15918 2.79999 8 2.79999C9.84106 2.79999 11.3335 4.29236 11.3335 6.13333C11.3335 7.55734 10.4119 8.40125 9.7915 8.89752C9.71411 8.95944 9.64453 9.01382 9.5813 9.06265L9.42334 9.18365L9.42041 9.18576C9.26953 9.30075 9.15723 9.38632 9.04688 9.48938C9.02222 9.51248 9.00342 9.53143 8.9895 9.54639C8.9187 10.0293 8.50269 10.4 8 10.4C7.44775 10.4 7 9.95227 7 9.39999C7 8.72623 7.42358 8.26883 7.68237 8.02725C7.86157 7.85999 8.11182 7.66791 8.3186 7.50934L8.33472 7.49701L8.44434 7.41241L8.54199 7.33578C9.08838 6.89874 9.3335 6.57596 9.3335 6.13333C9.3335 5.39694 8.73657 4.79999 8 4.79999ZM8 13.1333C8.51538 13.1333 8.93335 12.7155 8.93335 12.2C8.93335 11.6845 8.51538 11.2667 8 11.2667C7.48462 11.2667 7.06665 11.6845 7.06665 12.2C7.06665 12.7155 7.48462 13.1333 8 13.1333Z",
    fill: color
  }));
};
HelpIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var HierarchyIcon = function HierarchyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block',
      transform: 'rotate(180deg)'
    }
  }, React.createElement("path", {
    d: "M5.20703 5.20718C5.59766 4.81656 5.59766 4.1835 5.20703 3.79288C4.81665 3.40237 4.18335 3.40237 3.79297 3.79288L1.29297 6.29288C0.902344 6.6835 0.902344 7.31656 1.29297 7.70718L3.79297 10.2072C4.18335 10.5977 4.81665 10.5977 5.20703 10.2072C5.59766 9.81656 5.59766 9.1835 5.20703 8.79288L4.41431 8.00003H10C11.6567 8.00003 13 9.34317 13 11C13 11.5523 13.4478 12 14 12C14.5522 12 15 11.5523 15 11C15 8.23856 12.7615 6.00003 10 6.00003H4.41431L5.20703 5.20718Z",
    fill: color
  }));
};
HierarchyIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var IdeaIcon = function IdeaIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5 12.5C5 12.2239 5.22388 12 5.5 12H10.5C10.7761 12 11 12.2239 11 12.5V13C11 13.5523 10.5522 14 10 14C10 14.5523 9.55225 15 9 15H7C6.44775 15 6 14.5523 6 14C5.44775 14 5 13.5523 5 13V12.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M5 6C5 4.34314 6.34326 3 8 3C9.65674 3 11 4.34314 11 6C11 6.6181 10.8142 7.18982 10.4954 7.66595C10.2534 8.02765 9.93726 8.45178 9.6748 8.79388C9.52554 8.98825 9.37392 9.18072 9.22144 9.37256C8.87476 9.80261 8.94238 10.4321 9.37256 10.7786C9.80249 11.1252 10.4321 11.0575 10.7786 10.6274L11.2612 10.0117C11.5317 9.6593 11.8789 9.19458 12.1575 8.7785C12.6897 7.9834 13 7.02643 13 6C13 3.23859 10.7615 1 8 1C5.23853 1 3 3.23859 3 6C3 7.02643 3.3103 7.9834 3.84253 8.7785C4.12109 9.19458 4.46826 9.6593 4.73877 10.0117C4.89767 10.2185 5.05892 10.4234 5.22144 10.6274C5.56787 11.0575 6.19727 11.1252 6.62744 10.7787C7.05737 10.4321 7.12524 9.80267 6.77832 9.37225L6.3252 8.79388C6.19531 8.62463 6.05225 8.43518 5.91162 8.24316C5.76807 8.04724 5.62695 7.84863 5.50464 7.66595C5.18579 7.18982 5 6.6181 5 6Z",
    fill: color
  }));
};
IdeaIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ImportIcon = function ImportIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M8 1C8.55228 1 9 1.44772 9 2V7.58579L10.2929 6.29289C10.6834 5.90237 11.3166 5.90237 11.7071 6.29289C12.0976 6.68342 12.0976 7.31658 11.7071 7.70711L8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289C4.68342 5.90237 5.31658 5.90237 5.70711 6.29289L7 7.58579V2C7 1.44772 7.44772 1 8 1Z",
    fill: color
  }), React.createElement("path", {
    d: "M1.29289 11.2929C1.68342 10.9024 2.31658 10.9024 2.70711 11.2929L4.41421 13H11.5858L13.2929 11.2929C13.6834 10.9024 14.3166 10.9024 14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L12.7071 14.7071C12.5196 14.8946 12.2652 15 12 15H4C3.73478 15 3.48043 14.8946 3.29289 14.7071L1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929Z",
    fill: color
  }));
};
ImportIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var InfoIcon = function InfoIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.2386 3 3 5.23858 3 8C3 10.7614 5.2386 13 8 13ZM15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11V8ZM8 4C7.44772 4 7 4.44772 7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4Z",
    fill: color
  }));
};
InfoIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var InternalIcon = function InternalIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M11.2427 9.00002C11.7949 9.00002 12.2427 8.55232 12.2427 8.00002C12.2427 7.44777 11.7949 7.00002 11.2427 7.00002H10.4143L14.707 2.70711C15.0977 2.3166 15.0977 1.68343 14.707 1.29292C14.3167 0.902359 13.6833 0.902359 13.293 1.29292L9 5.58583V4.7574C9 4.20509 8.55225 3.7574 8 3.7574C7.44775 3.7574 7 4.20509 7 4.7574V8.00002C7 8.26527 7.10547 8.51961 7.29297 8.70717C7.48047 8.89467 7.73486 9.00002 8 9.00002H11.2427Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.16553 3.06923C7.71021 2.97786 8.07764 2.46223 7.98633 1.91756C7.89478 1.37288 7.37915 1.00545 6.83447 1.09682C3.52319 1.65236 1 4.53059 1 8.00008C1 11.866 4.13403 15.0001 8 15.0001C11.4695 15.0001 14.3477 12.4769 14.9033 9.16554C14.9946 8.62086 14.6272 8.10524 14.0825 8.01387C13.5378 7.92244 13.0222 8.28993 12.9309 8.83461C12.5342 11.1986 10.4766 13.0001 8 13.0001C5.23853 13.0001 3 10.7615 3 8.00008C3 5.52357 4.80151 3.46584 7.16553 3.06923Z",
    fill: color
  }));
};
InternalIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$7 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var JiraIcon = function JiraIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$7.DEFAULT : _ref$size;
  var numericSize = size === Sizes$7.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$7.BIG ? {
      transform: 'scale(1.5)',
      transformOrigin: '0 0'
    } : {}
  }, React.createElement("path", {
    d: "M15.5748 7.52842L8.71164 0.665263L8.04638 0L2.88006 5.16632L0.517959 7.52842C0.271683 7.775 0.271683 8.17447 0.517959 8.42105L5.23796 13.1411L8.04638 15.9495L13.2127 10.7832L13.2927 10.7032L15.5748 8.42105C15.8211 8.17447 15.8211 7.775 15.5748 7.52842ZM8.04638 10.3326L5.68849 7.97474L8.04638 5.61684L10.4043 7.97474L8.04638 10.3326Z",
    fill: "#2684FF"
  }), React.createElement("path", {
    d: "M8.04647 5.61682C6.5027 4.07286 6.49517 1.57214 8.02963 0.0189209L2.86963 5.17682L5.67805 7.98524L8.04647 5.61682Z",
    fill: "url(#jiraicon_linear)"
  }), React.createElement("path", {
    d: "M8.059 10.3263C9.60277 11.8703 9.61029 14.371 8.07584 15.9242L13.2358 10.7663L10.4274 7.95788L8.059 10.3263Z",
    fill: "url(#jiraicon1_linear)"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "jiraicon_linear",
    x1: "7.03274",
    y1: "3.82419",
    x2: "3.77379",
    y2: "5.20048",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })), React.createElement("linearGradient", {
    id: "jiraicon1_linear",
    x1: "9.07273",
    y1: "12.1189",
    x2: "12.3317",
    y2: "10.7426",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })))));
};
JiraIcon.category = 'Tool';
JiraIcon.Sizes = Sizes$7;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$8 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var JiraServiceDeskIcon = function JiraServiceDeskIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$8.DEFAULT : _ref$size;
  var numericSize = size === Sizes$8.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$8.BIG ? {
      transform: 'scale(1.5)',
      transformOrigin: '0 0'
    } : {}
  }, React.createElement("path", {
    d: "M9.12321 6.29883L13.4622 6.31567C13.5875 6.31625 13.7102 6.35168 13.8165 6.41798C13.9229 6.48428 14.0087 6.57885 14.0644 6.69112C14.1201 6.80338 14.1435 6.92893 14.1319 7.05372C14.1204 7.17851 14.0744 7.29763 13.999 7.39778L7.59479 15.9494C7.11602 15.5918 6.71237 15.1434 6.40691 14.6298C6.10145 14.1163 5.90016 13.5475 5.81453 12.9562C5.7289 12.3648 5.76062 11.7623 5.90786 11.1832C6.0551 10.6041 6.31499 10.0596 6.67268 9.58093L9.12321 6.29883Z",
    fill: "url(#jiraservicedeskicon_linear)"
  }), React.createElement("path", {
    d: "M6.67089 9.58105L2.35721 9.55369C2.23189 9.5531 2.10919 9.51768 2.00284 9.45138C1.89649 9.38508 1.81067 9.29051 1.75498 9.17824C1.69928 9.06597 1.6759 8.94043 1.68745 8.81564C1.69899 8.69084 1.74501 8.57172 1.82037 8.47158L8.16142 0C8.64019 0.357557 9.04383 0.80593 9.34929 1.31951C9.65476 1.83309 9.85605 2.40181 9.94168 2.9932C10.0273 3.58458 9.99559 4.18705 9.84835 4.76617C9.70111 5.3453 9.44122 5.88975 9.08352 6.36842L6.67089 9.58105Z",
    fill: "#2684FF"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "jiraservicedeskicon_linear",
    x1: "8.95056",
    y1: "6.93932",
    x2: "10.7759",
    y2: "12.4537",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: "#0052CC"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  })))));
};
JiraServiceDeskIcon.category = 'Tool';
JiraServiceDeskIcon.Sizes = Sizes$8;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var KeyboardShortcutsIcon = function KeyboardShortcutsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 3.5C6.44772 3.5 6 3.94772 6 4.5V6.5C6 7.05228 6.44772 7.5 7 7.5H9C9.55228 7.5 10 7.05228 10 6.5V4.5C10 3.94772 9.55228 3.5 9 3.5H7ZM2 8.5C1.44772 8.5 1 8.94772 1 9.5V11.5C1 12.0523 1.44772 12.5 2 12.5H4C4.55228 12.5 5 12.0523 5 11.5V9.5C5 8.94772 4.55228 8.5 4 8.5H2ZM7 8.5C6.44772 8.5 6 8.94772 6 9.5V11.5C6 12.0523 6.44772 12.5 7 12.5H9C9.55228 12.5 10 12.0523 10 11.5V9.5C10 8.94772 9.55228 8.5 9 8.5H7ZM11 9.5C11 8.94772 11.4477 8.5 12 8.5H14C14.5523 8.5 15 8.94772 15 9.5V11.5C15 12.0523 14.5523 12.5 14 12.5H12C11.4477 12.5 11 12.0523 11 11.5V9.5Z",
    fill: color
  }));
};
KeyboardShortcutsIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var LastModifiedIcon = function LastModifiedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M14.9594 2.98159L14.9594 4.10127L10 4.10128L10 2.9816C9.99997 1.88723 10.9028 1.00002 12.0164 1.00005L12.943 1C14.0566 1.00003 14.9593 1.88722 14.9594 2.98159Z",
    fill: color
  }), React.createElement("path", {
    d: "M10.0408 10.1548L10 5.09206L14.9594 5.09203L15 10.155C15 10.4957 14.9106 10.8307 14.7404 11.1276L12.5205 15L10.3003 11.1276C10.1301 10.8306 10.0406 10.4957 10.0408 10.1548Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 3C1.44772 3 1 3.44772 1 4C1 4.55228 1.44772 5 2 5H7C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3H2Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 8C1 7.44772 1.44772 7 2 7H7C7.55228 7 8 7.44772 8 8C8 8.55229 7.55228 9 7 9H2C1.44772 9 1 8.55229 1 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 11C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13H7C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11H2Z",
    fill: color
  }));
};
LastModifiedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var LastViewedIcon = function LastViewedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2ZM10.4462 9.03197C10.7981 8.43645 11 7.74181 11 7C11 4.79086 9.20914 3 7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11C7.74181 11 8.43645 10.7981 9.03197 10.4462L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L10.4462 9.03197Z",
    fill: color
  }));
};
LastViewedIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$7 = {
  DEFAULT: 'default',
  OFF: 'off'
};
var LinkIcon = function LinkIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$7.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$7.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.13973 2.00167C10.4753 0.666111 12.6406 0.666111 13.9762 2.00167C15.3118 3.33722 15.3118 5.50258 13.9762 6.83814L12.3141 8.50022C11.9236 8.89075 11.2904 8.89075 10.8999 8.50022C10.5094 8.1097 10.5094 7.47654 10.8999 7.08601L12.562 5.42393C13.1165 4.86942 13.1165 3.97039 12.562 3.41588C12.0075 2.86137 11.1084 2.86137 10.5539 3.41588L9.07749 4.89233C8.40967 5.56015 8.34529 6.52449 8.8703 7.51931L8.87034 7.51938C9.67451 9.04344 9.78486 11.0298 8.31302 12.5016L6.83814 13.9765C5.50258 15.3121 3.33722 15.3121 2.00167 13.9765C0.666111 12.641 0.666111 10.4756 2.00167 9.14006L3.66375 7.47797C4.05428 7.08745 4.68744 7.08745 5.07797 7.47797C5.46849 7.8685 5.46849 8.50166 5.07797 8.89219L3.41588 10.5543C2.86137 11.1088 2.86137 12.0078 3.41588 12.5623C3.97039 13.1168 4.86942 13.1168 5.42393 12.5623L6.89881 11.0874C7.56805 10.4182 7.63108 9.45648 7.10151 8.45279C6.29864 6.93146 6.19675 4.94464 7.66327 3.47812L9.13973 2.00167Z",
    fill: color
  }), type === Types$7.OFF && React.createElement("g", null, React.createElement("path", {
    d: "M9.13971 2.00168C10.4754 0.666107 12.6407 0.666107 13.9764 2.00168C15.3118 3.33722 15.3118 5.50259 13.9764 6.83813L12.3143 8.50021C11.9236 8.89075 11.2906 8.89075 10.9 8.50021C10.5093 8.10971 10.5093 7.47653 10.9 7.086L12.5621 5.42392C13.1165 4.86942 13.1165 3.9704 12.5621 3.41589C12.0076 2.86136 11.1085 2.86136 10.554 3.41589L9.07745 4.89233C8.40973 5.56015 8.34528 6.52448 8.87042 7.51938C9.67462 9.04346 9.78497 11.0298 8.31305 12.5016L6.8382 13.9765C5.50275 15.3121 3.33722 15.3121 2.00177 13.9765C0.666077 12.641 0.666077 10.4756 2.00177 9.14005L3.66388 7.47797C4.05426 7.08746 4.68756 7.08746 5.07794 7.47797C5.46857 7.8685 5.46857 8.50165 5.07794 8.89218L3.41583 10.5543C2.86139 11.1088 2.86139 12.0078 3.41583 12.5623C3.97052 13.1168 4.86945 13.1168 5.42389 12.5623L6.89899 11.0874C7.56818 10.4182 7.63116 9.45648 7.10162 8.45279C6.29865 6.93146 6.19684 4.94464 7.66339 3.47812L9.13971 2.00168Z",
    fill: color
  }), React.createElement("path", {
    d: "M10.293 10.2929C10.6834 9.90234 11.3167 9.90234 11.7071 10.2929L12.5001 11.0858L13.293 10.2929C13.6834 9.90234 14.3167 9.90234 14.7071 10.2929C15.0977 10.6834 15.0977 11.3166 14.7071 11.7071L13.9141 12.5L14.7071 13.2929C15.0977 13.6834 15.0977 14.3166 14.7071 14.7071C14.3167 15.0976 13.6834 15.0976 13.293 14.7071L12.5001 13.9141L11.7071 14.7071C11.3167 15.0976 10.6834 15.0976 10.293 14.7071C9.9024 14.3166 9.9024 13.6834 10.293 13.2929L11.086 12.5L10.293 11.7071C9.9024 11.3166 9.9024 10.6834 10.293 10.2929Z",
    fill: color
  })));
};
LinkIcon.category = 'Entity';
LinkIcon.Types = Types$7;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ListIcon = function ListIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1 4C1 3.44772 1.52233 3 2.16667 3H13.8333C14.4777 3 15 3.44772 15 4C15 4.55228 14.4777 5 13.8333 5H2.16667C1.52233 5 1 4.55228 1 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 8C1 7.44772 1.52233 7 2.16667 7H13.8333C14.4777 7 15 7.44772 15 8C15 8.55228 14.4777 9 13.8333 9H2.16667C1.52233 9 1 8.55228 1 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 12C1 11.4477 1.52233 11 2.16667 11H13.8333C14.4777 11 15 11.4477 15 12C15 12.5523 14.4777 13 13.8333 13H2.16667C1.52233 13 1 12.5523 1 12Z",
    fill: color
  }));
};
ListIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2025
 *********************************************************************/
var FlexibleListIcon = function FlexibleListIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M1 4C1 3.44772 1.52233 3 2.16667 3H13.8333C14.4777 3 15 3.44772 15 4C15 4.55228 14.4777 5 13.8333 5H2.16667C1.52233 5 1 4.55228 1 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 8C3 7.44772 3.52233 7 4.16667 7H13.8333C14.4777 7 15 7.44772 15 8C15 8.55228 14.4777 9 13.8333 9H4.16667C3.52233 9 3 8.55228 3 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M6 12C6 11.4477 6.52233 11 7.16667 11H13.8333C14.4777 11 15 11.4477 15 12C15 12.5523 14.4777 13 13.8333 13H7.16667C6.52233 13 6 12.5523 6 12Z",
    fill: color
  }));
};
FlexibleListIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ListColumnsIcon = function ListColumnsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M12 1C12.5523 1 13 1.52233 13 2.16667V13.8333C13 14.4777 12.5523 15 12 15C11.4477 15 11 14.4777 11 13.8333V2.16667C11 1.52233 11.4477 1 12 1Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 1C8.55228 1 9 1.52233 9 2.16667V13.8333C9 14.4777 8.55228 15 8 15C7.44772 15 7 14.4777 7 13.8333L7 2.16667C7 1.52233 7.44772 1 8 1Z",
    fill: color
  }), React.createElement("path", {
    d: "M4 1C4.55228 1 5 1.52233 5 2.16667L5 13.8333C5 14.4777 4.55228 15 4 15C3.44772 15 3 14.4777 3 13.8333V2.16667C3 1.52233 3.44772 1 4 1Z",
    fill: color
  }));
};
ListColumnsIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ListLanesIcon = function ListLanesIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1 4C1 3.44772 1.52233 3 2.16667 3H13.8333C14.4777 3 15 3.44772 15 4C15 4.55228 14.4777 5 13.8333 5H2.16667C1.52233 5 1 4.55228 1 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 8C1 7.44772 1.52233 7 2.16667 7H13.8333C14.4777 7 15 7.44772 15 8C15 8.55228 14.4777 9 13.8333 9H2.16667C1.52233 9 1 8.55228 1 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 12C1 11.4477 1.52233 11 2.16667 11H13.8333C14.4777 11 15 11.4477 15 12C15 12.5523 14.4777 13 13.8333 13H2.16667C1.52233 13 1 12.5523 1 12Z",
    fill: color
  }));
};
ListLanesIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ListFirstLevel = function ListFirstLevel(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5 9C5 8.44772 5.52233 8 6.16667 8H13.8333C14.4777 8 15 8.44772 15 9C15 9.55228 14.4777 10 13.8333 10H6.16667C5.52233 10 5 9.55228 5 9Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 13C9 12.4477 9.52233 12 10.1667 12H13.8333C14.4777 12 15 12.4477 15 13C15 13.5523 14.4777 14 13.8333 14H10.1667C9.52233 14 9 13.5523 9 13Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H13C14.1046 2 15 2.89543 15 4C15 5.10457 14.1046 6 13 6H3C1.89543 6 1 5.10457 1 4Z",
    fill: color
  }));
};
ListFirstLevel.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ListSecondLevel = function ListSecondLevel(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1 3C1 2.44772 1.52233 2 2.16667 2H13.8333C14.4777 2 15 2.44772 15 3C15 3.55228 14.4777 4 13.8333 4H2.16667C1.52233 4 1 3.55228 1 3Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 13C9 12.4477 9.52233 12 10.1667 12H13.8333C14.4777 12 15 12.4477 15 13C15 13.5523 14.4777 14 13.8333 14H10.1667C9.52233 14 9 13.5523 9 13Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 8C5 6.89543 5.89543 6 7 6H13C14.1046 6 15 6.89543 15 8C15 9.10457 14.1046 10 13 10H7C5.89543 10 5 9.10457 5 8Z",
    fill: color
  }));
};
ListSecondLevel.category = 'Boards & Views';

var _LiveChatIconColor;
var Types$8 = {
  ON: 'on',
  OFF: 'off'
};
var LiveChatIconColor = (_LiveChatIconColor = {}, _defineProperty(_LiveChatIconColor, Types$8.ON, FontColorSuccess), _defineProperty(_LiveChatIconColor, Types$8.OFF, FontColorError), _LiveChatIconColor);
var LiveChatIcon = function LiveChatIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    type = _ref.type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6 1C3.23853 1 1 3.23858 1 6C1 7.78892 1.93945 9.35841 3.35205 10.242L7.83301 13.3233C9.18945 14.2561 10 14.1972 10 12.5509V11C12.7615 11 15 8.76142 15 6C15 3.23858 12.7615 1 10 1H6Z",
    // hasOwnProperty explicitly checked here
    // eslint-disable-next-line security/detect-object-injection
    fill: LiveChatIconColor.hasOwnProperty(type) ? LiveChatIconColor[type] : color
  }));
};
LiveChatIcon.category = 'Info';
LiveChatIcon.Types = Types$8;

var scopedAnimationName = 'loading-icon-spin';
var inlineStyle = "@keyframes ".concat(scopedAnimationName, " {from {transform: rotate(0deg)} to {transform: rotate(360deg)}}");
var LoadingIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadingIcon, _React$Component);
  function LoadingIcon() {
    _classCallCheck(this, LoadingIcon);
    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingIcon).apply(this, arguments));
  }
  _createClass(LoadingIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var existingStyleTag = document.querySelector("#".concat(scopedAnimationName));
      if (existingStyleTag) {
        return;
      }
      var styleTag = document.createElement('style');
      styleTag.setAttribute('id', scopedAnimationName);
      styleTag.type = 'text/css';
      styleTag.appendChild(document.createTextNode(inlineStyle));
      document.head.appendChild(styleTag);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$color = this.props.color,
        color = _this$props$color === void 0 ? IconsGeneralColor : _this$props$color;
      return React.createElement("svg", {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        style: {
          animation: "".concat(scopedAnimationName, " 0.8s steps(12, end) infinite"),
          display: 'block'
        }
      }, React.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fillRule: "evenodd",
        fill: color
      }, React.createElement("path", {
        d: "M7.5,0 C7.77614237,0 8,0.229644775 8,0.501464665 L8,2.99853534 C8,3.27548662 7.76806641,3.5 7.5,3.5 L7.5,3.5 C7.22385763,3.5 7,3.27035522 7,2.99853534 L7,0.501464665 C7,0.224513378 7.23193359,0 7.5,0 L7.5,0 L7.5,0 Z",
        opacity: "0.200000003"
      }), React.createElement("path", {
        d: "M0,8.5 C0,8.22385763 0.229644775,8 0.501464665,8 L2.99853534,8 C3.27548662,8 3.5,8.23193359 3.5,8.5 L3.5,8.5 C3.5,8.77614237 3.27035522,9 2.99853534,9 L0.501464665,9 C0.224513378,9 0,8.76806641 0,8.5 L0,8.5 L0,8.5 Z"
      }), React.createElement("path", {
        d: "M8.5,16 C8.22385763,16 8,15.7703552 8,15.4985353 L8,13.0014647 C8,12.7245134 8.23193359,12.5 8.5,12.5 L8.5,12.5 C8.77614237,12.5 9,12.7296448 9,13.0014647 L9,15.4985353 C9,15.7754866 8.76806641,16 8.5,16 L8.5,16 L8.5,16 Z",
        opacity: "0.800000012"
      }), React.createElement("path", {
        d: "M16,7.5 C16,7.77614237 15.7703552,8 15.4985353,8 L13.0014647,8 C12.7245134,8 12.5,7.76806641 12.5,7.5 L12.5,7.5 C12.5,7.22385763 12.7296448,7 13.0014647,7 L15.4985353,7 C15.7754866,7 16,7.23193359 16,7.5 L16,7.5 L16,7.5 Z",
        opacity: "0.5"
      }), React.createElement("path", {
        d: "M3.5669873,1.32179677 C3.80613361,1.18372558 4.11482239,1.27067498 4.25073233,1.50607791 L5.49926767,3.66860454 C5.63774331,3.90845139 5.54913962,4.21885248 5.3169873,4.35288568 L5.3169873,4.35288568 C5.07784099,4.49095687 4.76915221,4.40400747 4.63324226,4.16860454 L3.38470693,2.00607791 C3.24623129,1.76623106 3.33483498,1.45582997 3.5669873,1.32179677 L3.5669873,1.32179677 L3.5669873,1.32179677 L3.5669873,1.32179677 Z",
        opacity: "0.100000001"
      }), React.createElement("path", {
        d: "M1.32179677,12.4330127 C1.18372558,12.1938664 1.27067498,11.8851776 1.50607791,11.7492677 L3.66860454,10.5007323 C3.90845139,10.3622567 4.21885248,10.4508604 4.35288568,10.6830127 L4.35288568,10.6830127 C4.49095687,10.922159 4.40400747,11.2308478 4.16860454,11.3667577 L2.00607791,12.6152931 C1.76623106,12.7537687 1.45582997,12.665165 1.32179677,12.4330127 L1.32179677,12.4330127 L1.32179677,12.4330127 L1.32179677,12.4330127 Z"
      }), React.createElement("path", {
        d: "M12.4330127,14.6782032 C12.1938664,14.8162744 11.8851776,14.729325 11.7492677,14.4939221 L10.5007323,12.3313955 C10.3622567,12.0915486 10.4508604,11.7811475 10.6830127,11.6471143 L10.6830127,11.6471143 C10.922159,11.5090431 11.2308478,11.5959925 11.3667577,11.8313955 L12.6152931,13.9939221 C12.7537687,14.2337689 12.665165,14.54417 12.4330127,14.6782032 L12.4330127,14.6782032 L12.4330127,14.6782032 L12.4330127,14.6782032 Z",
        opacity: "0.699999988"
      }), React.createElement("path", {
        d: "M14.6782032,3.5669873 C14.8162744,3.80613361 14.729325,4.11482239 14.4939221,4.25073233 L12.3313955,5.49926767 C12.0915486,5.63774331 11.7811475,5.54913962 11.6471143,5.3169873 L11.6471143,5.3169873 C11.5090431,5.07784099 11.5959925,4.76915221 11.8313955,4.63324226 L13.9939221,3.38470693 C14.2337689,3.24623129 14.54417,3.33483498 14.6782032,3.5669873 L14.6782032,3.5669873 L14.6782032,3.5669873 L14.6782032,3.5669873 Z",
        opacity: "0.400000006"
      }), React.createElement("path", {
        d: "M0.82179677,4.4330127 C0.959867957,4.19386639 1.27067498,4.11482239 1.50607791,4.25073233 L3.66860454,5.49926767 C3.90845139,5.63774331 3.98691889,5.95086038 3.85288568,6.1830127 L3.85288568,6.1830127 C3.7148145,6.42215901 3.40400747,6.50120302 3.16860454,6.36529307 L1.00607791,5.11675774 C0.766231058,4.97828209 0.687763567,4.66516502 0.82179677,4.4330127 L0.82179677,4.4330127 L0.82179677,4.4330127 L0.82179677,4.4330127 Z",
        opacity: "0.100000001"
      }), React.createElement("path", {
        d: "M4.4330127,15.1782032 C4.19386639,15.040132 4.11482239,14.729325 4.25073233,14.4939221 L5.49926767,12.3313955 C5.63774331,12.0915486 5.95086038,12.0130811 6.1830127,12.1471143 L6.1830127,12.1471143 C6.42215901,12.2851855 6.50120302,12.5959925 6.36529307,12.8313955 L5.11675774,14.9939221 C4.97828209,15.2337689 4.66516502,15.3122364 4.4330127,15.1782032 L4.4330127,15.1782032 L4.4330127,15.1782032 L4.4330127,15.1782032 Z",
        opacity: "0.900000036"
      }), React.createElement("path", {
        d: "M15.1782032,11.5669873 C15.040132,11.8061336 14.729325,11.8851776 14.4939221,11.7492677 L12.3313955,10.5007323 C12.0915486,10.3622567 12.0130811,10.0491396 12.1471143,9.8169873 L12.1471143,9.8169873 C12.2851855,9.57784099 12.5959925,9.49879698 12.8313955,9.63470693 L14.9939221,10.8832423 C15.2337689,11.0217179 15.3122364,11.334835 15.1782032,11.5669873 L15.1782032,11.5669873 L15.1782032,11.5669873 L15.1782032,11.5669873 Z",
        opacity: "0.600000024"
      }), React.createElement("path", {
        d: "M11.5669873,0.82179677 C11.8061336,0.959867957 11.8851776,1.27067498 11.7492677,1.50607791 L10.5007323,3.66860454 C10.3622567,3.90845139 10.0491396,3.98691889 9.8169873,3.85288568 L9.8169873,3.85288568 C9.57784099,3.7148145 9.49879698,3.40400747 9.63470693,3.16860454 L10.8832423,1.00607791 C11.0217179,0.766231058 11.334835,0.687763567 11.5669873,0.82179677 L11.5669873,0.82179677 L11.5669873,0.82179677 L11.5669873,0.82179677 Z",
        opacity: "0.300000012"
      })));
    }
  }]);
  return LoadingIcon;
}(React.Component);
LoadingIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MailIcon = function MailIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M1.06787 4.48192L5.87866 9.29289C7.05029 10.4645 8.94971 10.4645 10.1213 9.29289L14.9321 4.48192C14.9763 4.64716 15 4.82083 15 5V12C15 13.1046 14.1045 14 13 14H3C1.89551 14 1 13.1046 1 12V5C1 4.82083 1.02368 4.64716 1.06787 4.48192Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.48193 3.06776L7.29297 7.87868C7.68335 8.26921 8.31665 8.26921 8.70703 7.87868L13.5181 3.06776C13.3528 3.02357 13.1792 3 13 3H3C2.8208 3 2.64722 3.02357 2.48193 3.06776Z",
    fill: color
  }));
};
MailIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$9 = {
  DEFAULT: 'default',
  REVERT: 'revert'
};
var MaximizeIcon = function MaximizeIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$9.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$9.DEFAULT && React.createElement("path", {
    d: "M7 14C7.55225 14 8 13.5523 8 13C8 12.4477 7.55225 12 7 12H5.41431L12 5.41422V7C12 7.55228 12.4478 8 13 8C13.5522 8 14 7.55228 14 7V3C14 2.74408 13.9023 2.48816 13.707 2.29289C13.5117 2.09763 13.2559 2 13 2H9C8.44775 2 8 2.44772 8 3C8 3.55228 8.44775 4 9 4H10.5857L4 10.5858V9C4 8.44772 3.55225 8 3 8C2.44775 8 2 8.44772 2 9V13C2 13.5523 2.44775 14 3 14H7Z",
    fill: color
  }), type === Types$9.REVERT && React.createElement("g", null, React.createElement("path", {
    d: "M9 8H13C13.5522 8 14 7.55228 14 7C14 6.44772 13.5522 6 13 6H11.4143L13.707 3.70711C14.0977 3.31658 14.0977 2.68342 13.707 2.29289C13.3167 1.90237 12.6833 1.90237 12.293 2.29289L10 4.58578V3C10 2.44772 9.55225 2 9 2C8.44775 2 8 2.44772 8 3V7C8 7.55228 8.44775 8 9 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 9C2 9.55228 2.44775 10 3 10H4.58569L2.29297 12.2929C1.90234 12.6834 1.90234 13.3166 2.29297 13.7071C2.68335 14.0976 3.31665 14.0976 3.70703 13.7071L6 11.4142V13C6 13.5523 6.44775 14 7 14C7.55225 14 8 13.5523 8 13V9C8 8.44772 7.55225 8 7 8H3C2.44775 8 2 8.44772 2 9Z",
    fill: color
  })));
};
MaximizeIcon.category = 'Common Actions';
MaximizeIcon.Types = Types$9;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$a = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuActivityIcon = function MenuActivityIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$a.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$a.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.8299 3.02312C7.75728 3.06876 7.67744 3.15 7.63134 3.31904L6.06767 9.05249C5.59306 10.7927 4.01242 12 2.20861 12H2C1.44772 12 1 11.5523 1 11C1 10.4477 1.44772 10 2 10H2.20861C3.11051 10 3.90083 9.39638 4.13814 8.52626L5.70181 2.79281C6.44298 0.0751802 10.414 0.4684 10.6078 3.2786L11.5067 16.3129C11.5439 16.8527 12.2927 16.9569 12.476 16.4478L13.8449 12.6451C14.4163 11.0581 15.9217 10 17.6085 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H17.6085C16.7651 12 16.0124 12.5291 15.7267 13.3226L14.3577 17.1253C13.4414 19.6708 9.69759 19.1495 9.51145 16.4505L8.61253 3.4162C8.60048 3.2414 8.53812 3.14608 8.47586 3.08708C8.40374 3.01874 8.29416 2.96602 8.16299 2.95303C8.03181 2.94005 7.91402 2.97025 7.8299 3.02312Z",
    fill: color
  }), type === Types$a.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.8299 3.02312C7.75728 3.06876 7.67744 3.15 7.63134 3.31904L6.06767 9.05249C5.59306 10.7927 4.01242 12 2.20861 12H2C1.44772 12 1 11.5523 1 11C1 10.4477 1.44772 10 2 10H2.20861C3.11051 10 3.90083 9.39638 4.13814 8.52626L5.70181 2.79281C6.44298 0.0751802 10.414 0.4684 10.6078 3.2786L11.5067 16.3129C11.5439 16.8527 12.2927 16.9569 12.476 16.4478L13.8449 12.6451C14.4163 11.0581 15.9217 10 17.6085 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H17.6085C16.7651 12 16.0124 12.5291 15.7267 13.3226L14.3577 17.1253C13.4414 19.6708 9.69759 19.1495 9.51145 16.4505L8.61253 3.4162C8.60048 3.2414 8.53812 3.14608 8.47586 3.08708C8.40374 3.01874 8.29416 2.96602 8.16299 2.95303C8.03181 2.94005 7.91402 2.97025 7.8299 3.02312Z",
    fill: color
  }));
};
MenuActivityIcon.category = 'Menu';
MenuActivityIcon.Types = Types$a;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$b = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuBoardsIcon = function MenuBoardsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$b.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$b.DEFAULT && React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.01005 9.20075C0.672721 8.45779 0.672715 6.5345 2.01005 5.79154L7.81549 2.56629C9.17459 1.81124 10.8272 1.81124 12.1863 2.56629L17.9917 5.79154C19.329 6.5345 19.329 8.45779 17.9917 9.20075L12.1863 12.426C10.8272 13.1811 9.17459 13.1811 7.81549 12.426L2.01005 9.20075ZM8.78677 10.6777L3.06001 7.49614L8.78677 4.31461C9.54183 3.89513 10.4599 3.89513 11.215 4.31461L16.9418 7.49614L11.215 10.6777C10.4599 11.0972 9.54183 11.0972 8.78677 10.6777Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.49044 12.6246C2.00908 12.3538 1.39936 12.5245 1.1286 13.0059C0.857838 13.4872 1.02856 14.097 1.50992 14.3677L8.03914 18.0404C9.25679 18.7253 10.7436 18.7253 11.9612 18.0404L18.4904 14.3677C18.9718 14.097 19.1425 13.4872 18.8718 13.0059C18.601 12.5245 17.9913 12.3538 17.5099 12.6246L10.9807 16.2972C10.3719 16.6397 9.62848 16.6397 9.01966 16.2972L2.49044 12.6246Z",
    fill: color
  })), type === Types$b.ACTIVE && React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.01005 9.20466C0.672721 8.4617 0.672715 6.5384 2.01005 5.79544L7.81549 2.5702C9.17459 1.81514 10.8272 1.81514 12.1863 2.5702L17.9917 5.79544C19.329 6.5384 19.329 8.4617 17.9917 9.20466L12.1863 12.4299C10.8272 13.185 9.17459 13.185 7.81549 12.4299L2.01005 9.20466Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.49044 12.6285C2.00908 12.3577 1.39936 12.5284 1.1286 13.0098C0.857838 13.4911 1.02856 14.1009 1.50992 14.3716L8.03914 18.0443C9.25679 18.7292 10.7436 18.7292 11.9612 18.0443L18.4904 14.3716C18.9718 14.1009 19.1425 13.4911 18.8718 13.0098C18.601 12.5284 17.9913 12.3577 17.5099 12.6285L10.9807 16.3011C10.3719 16.6436 9.62848 16.6436 9.01966 16.3011L2.49044 12.6285Z",
    fill: color
  })));
};
MenuBoardsIcon.category = 'Menu';
MenuBoardsIcon.Types = Types$b;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$c = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuFeedbackIcon = function MenuFeedbackIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$c.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$c.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.0265 4.69367L9.15385 6.65141C8.71786 7.62951 7.79358 8.30104 6.72863 8.41344L4.59703 8.63842L6.18929 10.0734C6.98478 10.7902 7.33783 11.8768 7.11564 12.9244L6.67091 15.0212L8.52885 13.9496C9.45454 13.4156 10.5944 13.4145 11.5212 13.9464L13.384 15.0157L12.9376 12.9221C12.7157 11.8817 13.0614 10.8016 13.8462 10.0834L15.4272 8.63634L13.3234 8.41354C12.2589 8.30081 11.3351 7.62938 10.8993 6.65163L10.0265 4.69367ZM10.8029 1.52298C10.5034 0.851065 9.54966 0.851064 9.25015 1.52298L7.32711 5.83715C7.18178 6.16318 6.87369 6.38702 6.5187 6.42449L2.15609 6.88494C1.2954 6.97578 0.948679 8.04288 1.59159 8.62227L4.85038 11.5591C5.11554 11.798 5.23323 12.1602 5.15916 12.5094L4.24895 16.8008C4.06938 17.6474 4.97711 18.3069 5.72681 17.8745L9.5281 15.682C9.83666 15.5041 10.2166 15.5037 10.5255 15.681L14.3315 17.8656C15.0817 18.2962 15.9877 17.6357 15.8073 16.7897L14.8936 12.505C14.8196 12.1582 14.9349 11.7981 15.1964 11.5587L18.4147 8.61332C19.0504 8.03158 18.7018 6.97194 17.8449 6.88119L13.5341 6.42467C13.1792 6.38709 12.8713 6.16328 12.726 5.83736L10.8029 1.52298Z",
    fill: color
  }), type === Types$c.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.25015 1.52298C9.54966 0.851064 10.5034 0.851065 10.8029 1.52298L12.726 5.83736C12.8713 6.16328 13.1792 6.38709 13.5341 6.42467L17.8449 6.88119C18.7018 6.97194 19.0504 8.03158 18.4147 8.61332L15.1964 11.5587C14.9349 11.7981 14.8196 12.1582 14.8936 12.505L15.8073 16.7897C15.9877 17.6357 15.0817 18.2962 14.3315 17.8656L10.5255 15.681C10.2166 15.5037 9.83666 15.5041 9.5281 15.682L5.72681 17.8745C4.97711 18.3069 4.06938 17.6474 4.24895 16.8008L5.15916 12.5094C5.23323 12.1602 5.11554 11.798 4.85038 11.5591L1.59159 8.62227C0.948679 8.04288 1.2954 6.97578 2.15609 6.88494L6.5187 6.42449C6.87369 6.38702 7.18178 6.16318 7.32711 5.83715L9.25015 1.52298Z",
    fill: color
  }));
};
MenuFeedbackIcon.category = 'Menu';
MenuFeedbackIcon.Types = Types$c;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$d = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuHelpIcon = function MenuHelpIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$d.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$d.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM9.27282 7.25324C9.12861 7.38959 9 7.61804 9 8C9 8.55228 8.55229 9 8 9C7.44772 9 7 8.55228 7 8C7 7.1196 7.31911 6.34804 7.89876 5.79998C8.46969 5.26016 9.22622 5 10 5C10.7738 5 11.5303 5.26016 12.1012 5.79998C12.6809 6.34804 13 7.1196 13 8C13 9.14607 12.4579 10.235 11.5515 10.8342C11.2525 11.0319 11.0758 11.2141 10.9824 11.3274C10.9353 11.3844 10.9084 11.4253 10.8971 11.4433L10.8928 11.4504C10.6505 11.9314 10.0679 12.1355 9.57669 11.906C9.07633 11.6722 8.86023 11.0771 9.09401 10.5767L9.09476 10.5751L9.09554 10.5734L9.09717 10.57L9.10073 10.5626L9.10913 10.5456C9.11531 10.5333 9.12266 10.5191 9.13125 10.5031C9.14844 10.4713 9.17065 10.4324 9.19854 10.3875C9.25436 10.2977 9.33287 10.1841 9.43943 10.0549C9.65331 9.79552 9.97665 9.47777 10.4485 9.16582C10.7377 8.9746 11 8.54601 11 8C11 7.61804 10.8714 7.38959 10.7272 7.25324C10.5743 7.10865 10.3308 7 10 7C9.66921 7 9.42574 7.10865 9.27282 7.25324ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14Z",
    fill: color
  }), type === Types$d.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM9.27282 7.25324C9.12861 7.38959 9 7.61804 9 8C9 8.55228 8.55229 9 8 9C7.44772 9 7 8.55228 7 8C7 7.1196 7.31911 6.34804 7.89876 5.79998C8.46969 5.26016 9.22622 5 10 5C10.7738 5 11.5303 5.26016 12.1012 5.79998C12.6809 6.34804 13 7.1196 13 8C13 9.14607 12.4579 10.235 11.5515 10.8342C11.2525 11.0319 11.0758 11.2141 10.9824 11.3274C10.9353 11.3844 10.9084 11.4253 10.8971 11.4433L10.8928 11.4504C10.6505 11.9314 10.0679 12.1355 9.57669 11.906C9.07633 11.6722 8.86023 11.0771 9.09401 10.5767L9.09476 10.5751L9.09554 10.5734L9.09717 10.57L9.10073 10.5626L9.10913 10.5456C9.11531 10.5333 9.12266 10.5191 9.13125 10.5031C9.14844 10.4713 9.17065 10.4324 9.19854 10.3875C9.25436 10.2977 9.33287 10.1841 9.43943 10.0549C9.65331 9.79552 9.97665 9.47777 10.4485 9.16582C10.7377 8.9746 11 8.54601 11 8C11 7.61804 10.8714 7.38959 10.7272 7.25324C10.5743 7.10865 10.3308 7 10 7C9.66921 7 9.42574 7.10865 9.27282 7.25324ZM11 14C11 14.5523 10.5523 15 10 15C9.44771 15 9 14.5523 9 14C9 13.4477 9.44771 13 10 13C10.5523 13 11 13.4477 11 14Z",
    fill: color
  }));
};
MenuHelpIcon.category = 'Menu';
MenuHelpIcon.Types = Types$d;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$e = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuNotificationIcon = function MenuNotificationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$e.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$e.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.00005 7C6.00005 5.72725 6.41993 4.74433 7.08215 4.08211C7.74438 3.41989 8.7273 3 10 3C11.2725 3 12.253 3.41953 12.9141 4.08785C13.5759 4.75692 14 5.75905 14 7.07693C14 8.01611 14.3638 8.95745 14.7108 9.77436C14.7954 9.97361 14.8805 10.1686 14.9645 10.3611L14.9646 10.3614C15.2513 11.0184 15.5254 11.6468 15.727 12.3192C15.7778 12.4886 15.74 12.6238 15.6313 12.745C15.5079 12.8825 15.2832 13 15 13H5.00005C4.71693 13 4.49153 12.8825 4.36718 12.7442C4.25733 12.622 4.21903 12.4852 4.26942 12.3149C4.46978 11.6378 4.7431 11.0064 5.0296 10.3444L5.02962 10.3444C5.11499 10.1471 5.20154 9.94718 5.28767 9.74251C5.63737 8.91155 6.00005 7.95896 6.00005 7ZM10 1C8.2728 1 6.75572 1.58011 5.66794 2.66789C4.58016 3.75567 4.00005 5.27275 4.00005 7C4.00005 7.51043 3.79887 8.1241 3.44426 8.96673C3.37508 9.13111 3.30005 9.30418 3.22187 9.4845L3.22183 9.4846C2.92806 10.1622 2.58994 10.9421 2.35162 11.7475C2.08859 12.6363 2.34278 13.4839 2.8799 14.0814C3.40253 14.6627 4.1786 15 5.00005 15H15C15.8215 15 16.5977 14.6626 17.1199 14.0807C17.6568 13.4824 17.9092 12.6337 17.6428 11.745C17.403 10.9449 17.0642 10.1699 16.7707 9.49825L16.7707 9.49824C16.6937 9.32208 16.6198 9.15304 16.5516 8.99252C16.197 8.15754 16 7.56105 16 7.07693C16 5.31787 15.4242 3.78155 14.336 2.68138C13.2471 1.58047 11.7276 1 10 1ZM10 19C8.87913 19 8.00005 18.089 8.00005 17H12C12 18.089 11.1209 19 10 19Z",
    fill: color
  }), type === Types$e.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1C8.2728 1 6.75572 1.58011 5.66794 2.66789C4.58016 3.75567 4.00005 5.27275 4.00005 7C4.00005 7.51043 3.79887 8.1241 3.44426 8.96673C3.37508 9.13111 3.30005 9.30418 3.22187 9.4845C2.9281 10.1621 2.58994 10.9421 2.35162 11.7475C2.08859 12.6363 2.34278 13.4839 2.8799 14.0814C3.40253 14.6627 4.1786 15 5.00005 15H15C15.8215 15 16.5977 14.6626 17.1199 14.0807C17.6568 13.4824 17.9092 12.6337 17.6428 11.745C17.403 10.9449 17.0642 10.1699 16.7707 9.49825C16.6937 9.32209 16.6198 9.15304 16.5516 8.99252C16.197 8.15754 16 7.56105 16 7.07693C16 5.31787 15.4242 3.78155 14.336 2.68138C13.2471 1.58047 11.7276 1 10 1ZM10 19C8.87913 19 8.00005 18.089 8.00005 17H12C12 18.089 11.1209 19 10 19Z",
    fill: color
  }));
};
MenuNotificationIcon.category = 'Menu';
MenuNotificationIcon.Types = Types$e;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$f = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuReportsIcon = function MenuReportsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$f.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$f.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.26816 3.21759C8.44409 3.17267 8.59662 3.21591 8.73272 3.34178C8.88225 3.48008 9 3.71698 9 3.99998V7.99998C9 9.65683 10.3431 11 12 11H16C16.283 11 16.5199 11.1177 16.6582 11.2673C16.7841 11.4034 16.8273 11.5559 16.7824 11.7318C16.5872 12.4962 16.2632 13.2261 15.8203 13.889C15.0511 15.0401 13.9579 15.9373 12.6788 16.4671C11.3997 16.9969 9.99224 17.1356 8.63437 16.8655C7.2765 16.5954 6.02922 15.9287 5.05026 14.9497C4.07129 13.9708 3.4046 12.7235 3.13451 11.3656C2.86441 10.0077 3.00303 8.60028 3.53285 7.32119C4.06266 6.04211 4.95987 4.94886 6.11101 4.17969C6.77389 3.73677 7.50382 3.41277 8.26816 3.21759ZM11 3.99998C11 2.43568 9.65075 0.800372 7.77333 1.27977C6.79065 1.5307 5.85215 1.94728 4.99987 2.51675C3.51983 3.50568 2.36628 4.91129 1.68509 6.55583C1.0039 8.20036 0.82567 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.3639C4.89472 17.6226 6.49836 18.4798 8.24419 18.827C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.0527 14.1478 18.4693 13.2093 18.7202 12.2267C19.1996 10.3492 17.5643 8.99998 16 8.99998H12C11.4477 8.99998 11 8.55226 11 7.99998V3.99998ZM14.5002 2.2057C14.0219 1.92956 13.4103 2.09344 13.1341 2.57173C12.858 3.05002 13.0219 3.66161 13.5002 3.93775C14.0288 4.24298 14.5165 4.61671 14.95 5.05021C15.3835 5.48372 15.7572 5.97134 16.0624 6.50001C16.3386 6.9783 16.9502 7.14218 17.4285 6.86604C17.9067 6.58991 18.0706 5.97832 17.7945 5.50002C17.4021 4.82031 16.9216 4.19337 16.3642 3.636C15.8068 3.07863 15.1799 2.59812 14.5002 2.2057Z",
    fill: color
  }), type === Types$f.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 4.00004C11 2.43574 9.65075 0.800433 7.77333 1.27983C6.79065 1.53076 5.85215 1.94734 4.99987 2.51681C3.51983 3.50574 2.36628 4.91135 1.68509 6.55589C1.0039 8.20042 0.82567 10.01 1.17294 11.7559C1.5202 13.5017 2.37737 15.1053 3.63604 16.364C4.89472 17.6227 6.49836 18.4798 8.24419 18.8271C9.99002 19.1744 11.7996 18.9961 13.4442 18.315C15.0887 17.6338 16.4943 16.4802 17.4832 15.0002C18.0527 14.1479 18.4693 13.2094 18.7202 12.2267C19.1996 10.3493 17.5643 9.00004 16 9.00004H12C11.4477 9.00004 11 8.55232 11 8.00004V4.00004ZM14.5002 2.20563C14.0219 1.9295 13.4103 2.09337 13.1341 2.57167C12.858 3.04996 13.0219 3.66155 13.5002 3.93769C14.0288 4.24291 14.5165 4.61665 14.95 5.05015C15.3835 5.48366 15.7572 5.97128 16.0624 6.49995C16.3386 6.97824 16.9502 7.14212 17.4285 6.86598C17.9067 6.58985 18.0706 5.97826 17.7945 5.49996C17.4021 4.82025 16.9216 4.19331 16.3642 3.63594C15.8068 3.07857 15.1799 2.59806 14.5002 2.20563Z",
    fill: color
  }));
};
MenuReportsIcon.category = 'Menu';
MenuReportsIcon.Types = Types$f;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$g = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuSearchIcon = function MenuSearchIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$g.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$g.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 8.5C3 5.46243 5.46243 3 8.5 3C11.5376 3 14 5.46243 14 8.5C14 11.5376 11.5376 14 8.5 14C5.46243 14 3 11.5376 3 8.5ZM8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C9.9527 16 11.3089 15.587 12.4577 14.872L16.2911 18.7072C16.6815 19.0979 17.3147 19.098 17.7053 18.7076C18.0959 18.3172 18.0961 17.684 17.7056 17.2934L14.0063 13.5922C15.2437 12.2548 16 10.4657 16 8.5C16 4.35786 12.6421 1 8.5 1Z",
    fill: color
  }), type === Types$g.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C9.9527 16 11.3089 15.587 12.4577 14.872L16.2911 18.7072C16.6815 19.0979 17.3147 19.098 17.7053 18.7076C18.0959 18.3172 18.0961 17.684 17.7056 17.2934L14.0063 13.5922C15.2437 12.2548 16 10.4657 16 8.5C16 4.35786 12.6421 1 8.5 1Z",
    fill: color
  }));
};
MenuSearchIcon.category = 'Menu';
MenuSearchIcon.Types = Types$g;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$h = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuSettingsIcon = function MenuSettingsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$h.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$h.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 8.12604C17.7252 8.57009 19 10.1362 19 12C19 13.8666 17.7215 15.4346 15.9924 15.876C15.9974 15.9166 16 15.958 16 16V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V16C14 15.958 14.0026 15.9166 14.0076 15.876C12.2785 15.4346 11 13.8666 11 12C11 10.1362 12.2748 8.57009 14 8.12604L14 2C14 1.44771 14.4477 1 15 1C15.5523 1 16 1.44771 16 2V8.12604ZM6 2.00006C6 1.44777 5.55228 1.00006 5 1.00006C4.44772 1.00006 4 1.44777 4 2.00006V4.00006C4 4.04206 4.00259 4.08345 4.00762 4.12409C2.27853 4.56548 1 6.13345 1 8.00003C1 9.86387 2.27477 11.43 4 11.874L4 18.0001C4 18.5523 4.44772 19.0001 5 19.0001C5.55228 19.0001 6 18.5523 6 18.0001L6 11.874C7.72523 11.43 9 9.86387 9 8.00003C9 6.13345 7.72147 4.56548 5.99238 4.12409C5.99741 4.08345 6 4.04206 6 4.00006V2.00006ZM5 6.00003C3.89543 6.00003 3 6.89546 3 8.00003C3 9.1046 3.89543 10 5 10C6.10457 10 7 9.1046 7 8.00003C7 6.89546 6.10457 6.00003 5 6.00003ZM17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8955 13.8954 10 15 10C16.1046 10 17 10.8955 17 12Z",
    fill: color
  }), type === Types$h.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 8.12605C17.7252 8.57009 19 10.1362 19 12C19 13.8666 17.7215 15.4346 15.9924 15.876C15.9974 15.9166 16 15.958 16 16V18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18V16C14 15.958 14.0026 15.9166 14.0076 15.876C12.2785 15.4346 11 13.8666 11 12C11 10.1362 12.2748 8.57009 14 8.12605L14 2C14 1.44772 14.4477 1 15 1C15.5523 1 16 1.44772 16 2V8.12605ZM6 2.00006C6 1.44777 5.55228 1.00006 5 1.00006C4.44772 1.00006 4 1.44777 4 2.00006V4.00006C4 4.04206 4.00259 4.08345 4.00762 4.12409C2.27853 4.56548 1 6.13345 1 8.00003C1 9.86387 2.27477 11.43 4 11.874L4 18.0001C4 18.5523 4.44772 19.0001 5 19.0001C5.55228 19.0001 6 18.5523 6 18.0001L6 11.874C7.72523 11.43 9 9.86387 9 8.00003C9 6.13345 7.72147 4.56548 5.99238 4.12409C5.99741 4.08345 6 4.04206 6 4.00006V2.00006Z",
    fill: color
  }));
};
MenuSettingsIcon.category = 'Menu';
MenuSettingsIcon.Types = Types$h;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$i = {
  DEFAULT: 'default',
  ACTIVE: 'active'
};
var MenuTimesheetIcon = function MenuTimesheetIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$i.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$i.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM11 6.00003C11 5.44774 10.5523 5.00003 10 5.00003C9.44771 5.00003 9 5.44774 9 6.00003V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V6.00003Z",
    fill: color
  }), type === Types$i.ACTIVE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM11 6.00003C11 5.44774 10.5523 5.00003 10 5.00003C9.44771 5.00003 9 5.44774 9 6.00003V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V6.00003Z",
    fill: color
  }));
};
MenuTimesheetIcon.category = 'Menu';
MenuTimesheetIcon.Types = Types$i;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MergeRequestIcon = function MergeRequestIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 12 12",
    fill: "none"
  }, React.createElement("path", {
    d: "M2.5 4.5C2.5 4.22386 2.72386 4 3 4V4C3.27614 4 3.5 4.22386 3.5 4.5V7.5C3.5 7.77614 3.27614 8 3 8V8C2.72386 8 2.5 7.77614 2.5 7.5V4.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 11.5C1.89543 11.5 1 10.6046 1 9.5C1 8.39543 1.89543 7.5 3 7.5C4.10457 7.5 5 8.39543 5 9.5C5 10.6046 4.10457 11.5 3 11.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 11.5C7.89543 11.5 7 10.6046 7 9.5C7 8.39543 7.89543 7.5 9 7.5C10.1046 7.5 11 8.39543 11 9.5C11 10.6046 10.1046 11.5 9 11.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.75019 1.20712C7.75019 0.761666 7.21162 0.538582 6.89664 0.853565L5.62887 2.12133C5.43361 2.31659 5.43361 2.63318 5.62887 2.82844L6.89664 4.09621C7.21162 4.41119 7.75019 4.18811 7.75019 3.74265V3.03152C8.1815 3.14253 8.50019 3.53405 8.50019 4.00001V4.49952V4.50001L8.50019 7.50001C8.50019 7.77615 8.72405 8.00001 9.00019 8.00001C9.27633 8.00001 9.50019 7.77615 9.50019 7.50001V4.50001V4.00001C9.50019 2.98011 8.73677 2.13851 7.75019 2.01548V1.20712Z",
    fill: color
  }), React.createElement("path", {
    d: "M3 4.5C1.89543 4.5 1 3.60457 1 2.5C1 1.39543 1.89543 0.5 3 0.5C4.10457 0.5 5 1.39543 5 2.5C5 3.60457 4.10457 4.5 3 4.5Z",
    fill: color
  }));
};
MergeRequestIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MessageErrorIcon = function MessageErrorIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? FontColorError : _ref$color;
  return React.createElement("svg", {
    width: "44",
    height: "44",
    fill: "none",
    viewBox: "0 0 44 44",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M14.5858 14.5858C15.3668 13.8047 16.6332 13.8047 17.4142 14.5858L22 19.1716L26.5858 14.5858C27.3668 13.8047 28.6332 13.8047 29.4142 14.5858C30.1953 15.3668 30.1953 16.6332 29.4142 17.4142L24.8284 22L29.4142 26.5858C30.1953 27.3668 30.1953 28.6332 29.4142 29.4142C28.6332 30.1953 27.3668 30.1953 26.5858 29.4142L22 24.8284L17.4142 29.4142C16.6332 30.1953 15.3668 30.1953 14.5858 29.4142C13.8047 28.6332 13.8047 27.3668 14.5858 26.5858L19.1716 22L14.5858 17.4142C13.8047 16.6332 13.8047 15.3668 14.5858 14.5858Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.1711 0C12.845 0 11.5732 0.526784 10.6355 1.46447L1.46447 10.6355C0.526784 11.5732 0 12.845 0 14.1711V29.8289C0 31.155 0.526784 32.4268 1.46447 33.3645L10.6355 42.5355C11.5732 43.4732 12.845 44 14.1711 44H29.8289C31.155 44 32.4268 43.4732 33.3645 42.5355L42.5355 33.3645C43.4732 32.4268 44 31.155 44 29.8289V14.1711C44 12.845 43.4732 11.5732 42.5355 10.6355L33.3645 1.46447C32.4268 0.526784 31.155 0 29.8289 0H14.1711ZM30.536 39.7071L39.7071 30.536C39.8946 30.3485 40 30.0941 40 29.8289V14.1711C40 13.9059 39.8946 13.6515 39.7071 13.464L30.536 4.29289C30.3485 4.10536 30.0941 4 29.8289 4H14.1711C13.9059 4 13.6515 4.10536 13.464 4.29289L4.29289 13.464C4.10536 13.6515 4 13.9059 4 14.1711V29.8289C4 30.0942 4.10536 30.3485 4.29289 30.536L13.464 39.7071C13.6515 39.8946 13.9059 40 14.1711 40H29.8289C30.0942 40 30.3485 39.8946 30.536 39.7071Z",
    fill: color
  }));
};
MessageErrorIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MessageNoDataIcon = function MessageNoDataIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "44",
    height: "44",
    fill: "none",
    viewBox: "0 0 44 44",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M38.9065 7.92189C42.0868 11.7369 44 16.645 44 22C44 34.1503 34.1503 44 22 44C16.645 44 11.7369 42.0868 7.92189 38.9065L4.41421 42.4142C3.63317 43.1953 2.36684 43.1953 1.58579 42.4142C0.804738 41.6332 0.804738 40.3668 1.58579 39.5858L5.09346 36.0781C1.91325 32.2631 0 27.355 0 22C0 9.84974 9.84974 0 22 0C27.355 0 32.2631 1.91325 36.0781 5.09346L39.5858 1.58579C40.3668 0.804738 41.6332 0.804738 42.4142 1.58579C43.1953 2.36684 43.1953 3.63317 42.4142 4.41421L38.9065 7.92189ZM40 22C40 31.9411 31.9411 40 22 40C17.75 40 13.844 38.5271 10.7646 36.0638L36.0638 10.7646C38.5271 13.844 40 17.75 40 22ZM7.9362 33.2354L33.2354 7.9362C30.156 5.47295 26.25 4 22 4C12.0589 4 4 12.0589 4 22C4 26.25 5.47295 30.156 7.9362 33.2354Z",
    fill: color
  }));
};
MessageNoDataIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MessageManyFacetsIcon = function MessageManyFacetsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? FontColorError : _ref$color;
  return React.createElement("svg", {
    width: "62",
    height: "44",
    fill: "none",
    viewBox: "0 0 62 44",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M2 0C3.10457 0 4 0.89543 4 2V40H60C61.1046 40 62 40.8954 62 42C62 43.1046 61.1046 44 60 44H0V2C0 0.89543 0.89543 0 2 0Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.775 3H6.825V2H7.775V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M11.575 3H10.625V2H11.575V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.375 3H14.425V2H15.375V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M19.175 3H18.225V2H19.175V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M22.975 2.5V2H22.025V2.5H22V3.04167H23V2.5H22.975Z",
    fill: color
  }), React.createElement("path", {
    d: "M26.775 3H25.825V2H26.775V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M30.575 3H29.625V2H30.575V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M34.375 3H33.425V2H34.375V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M38.175 3H37.225V2H38.175V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M41.95 2.5V2H41.025V2.5H41V3.04167H42V2.5H41.95Z",
    fill: color
  }), React.createElement("path", {
    d: "M45.55 3H44.65V2H45.55V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M49.15 3H48.25V2H49.15V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M52.75 3H51.85V2H52.75V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M56.35 3H55.45V2H56.35V3Z",
    fill: color
  }), React.createElement("path", {
    d: "M59.05 2.5H59V3.04167H60V2H59.05V2.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 7.375V6.29167H23V7.375H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M41 7.375V6.29167H42V7.375H41Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 7.375V6.29167H60V7.375H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 11.7083V10.625H23V11.7083H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M41 11.7083V10.625H42V11.7083H41Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 11.7083V10.625H60V11.7083H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 14.9583H23V15.9375H22.975V16H22.025V15.9375H22V14.9583Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 14.9583H60V15.9375H59.5V16H59.05V15.9375H59V14.9583Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.775 16H6.825V15H7.775V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M11.575 16H10.625V15H11.575V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.2587 15H14.425V15.6638L12.418 17.2617L14.1641 19.4414L16.1328 17.8594C16.3672 17.6719 16.7852 17.2773 17.3867 16.6758L17.3281 18.457L17.293 20.0859V30H20.9141V12.8672H17.9375L15.2587 15Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M26.3924 16H25.825V15H26.775V15.1881C26.8598 15.036 26.9491 14.8913 27.043 14.7539C28.0195 13.3164 29.5234 12.5977 31.5547 12.5977C33.5312 12.5977 35.0234 13.3477 36.0312 14.8477C37.0469 16.3477 37.5547 18.543 37.5547 21.4336C37.5547 24.4258 37.0625 26.6406 36.0781 28.0781C35.6249 28.7453 35.0572 29.2577 34.375 29.6152V30H33.425V29.9924C32.8612 30.1537 32.2377 30.2344 31.5547 30.2344C30.9134 30.2344 30.3231 30.1562 29.7838 30H29.625V29.9513C28.5755 29.6107 27.7266 28.9629 27.0781 28.0078C26.0781 26.5234 25.5781 24.332 25.5781 21.4336C25.5781 19.1794 25.8495 17.3682 26.3924 16ZM30.3095 16H30.575V15.7927C30.8551 15.6158 31.1816 15.5273 31.5547 15.5273C32.3906 15.5273 32.9961 15.9883 33.3711 16.9102C33.7539 17.8242 33.9453 19.332 33.9453 21.4336C33.9453 23.5117 33.7578 25.0117 33.3828 25.9336C33.0078 26.8555 32.3984 27.3164 31.5547 27.3164C30.6953 27.3164 30.082 26.8633 29.7148 25.957C29.3555 25.043 29.1758 23.5352 29.1758 21.4336C29.1758 19.332 29.3594 17.8242 29.7266 16.9102C29.8791 16.5273 30.0734 16.2239 30.3095 16Z",
    fill: color
  }), React.createElement("path", {
    d: "M38.175 16H37.225V15H38.175V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M52.75 16H51.85V15H52.75V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M56.35 16H55.45V15H56.35V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 19.4375V18.5625H23V19.4375H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 19.4375V18.5625H60V19.4375H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 22.9375V22.0625H23V22.9375H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 22.9375V22.0625H60V22.9375H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 26.4375V25.5625H23V26.4375H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 26.4375V25.5625H60V26.4375H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.775 30H6.825V29H7.775V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M11.575 30H10.625V29H11.575V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M15.375 30H14.425V29H15.375V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M22.975 29.0625V29H22.025V29.0625H22V30.0208H23V29.0625H22.975Z",
    fill: color
  }), React.createElement("path", {
    d: "M26.775 30H25.825V29H26.775V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M38.175 30H37.225V29H38.175V30Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M41.6561 29C41.3355 28.7177 41.0465 28.387 40.7891 28.0078C39.7891 26.5234 39.2891 24.332 39.2891 21.4336C39.2891 18.4102 39.7773 16.1836 40.7539 14.7539C41.7305 13.3164 43.2344 12.5977 45.2656 12.5977C47.2422 12.5977 48.7344 13.3477 49.7422 14.8477C50.7578 16.3477 51.2656 18.543 51.2656 21.4336C51.2656 24.4258 50.7734 26.6406 49.7891 28.0781C49.5514 28.428 49.2822 28.7353 48.9816 29H49.15V30H48.25V29.525C47.43 29.9979 46.4352 30.2344 45.2656 30.2344C43.9685 30.2344 42.8799 29.9147 42 29.2754V30.0208H41V29.0625H41.025V29H41.6561ZM45.55 16H44.65V15.621C44.1133 15.7985 43.7091 16.2282 43.4375 16.9102C43.0703 17.8242 42.8867 19.332 42.8867 21.4336C42.8867 23.5352 43.0664 25.043 43.4258 25.957C43.793 26.8633 44.4062 27.3164 45.2656 27.3164C46.1094 27.3164 46.7188 26.8555 47.0938 25.9336C47.4688 25.0117 47.6562 23.5117 47.6562 21.4336C47.6562 19.332 47.4648 17.8242 47.082 16.9102C46.751 16.0963 46.2403 15.6417 45.55 15.5463V16Z",
    fill: color
  }), React.createElement("path", {
    d: "M52.75 30H51.85V29H52.75V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M56.35 30H55.45V29H56.35V30Z",
    fill: color
  }), React.createElement("path", {
    d: "M59.5 29.0625V29H59.05V29.0625H59V30.0208H60V29.0625H59.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 34.1875V33.1458H23V34.1875H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M41 34.1875V33.1458H42V34.1875H41Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 34.1875V33.1458H60V34.1875H59Z",
    fill: color
  }), React.createElement("path", {
    d: "M22 38.3542V37.3125H23V38.3542H22Z",
    fill: color
  }), React.createElement("path", {
    d: "M41 38.3542V37.3125H42V38.3542H41Z",
    fill: color
  }), React.createElement("path", {
    d: "M59 38.3542V37.3125H60V38.3542H59Z",
    fill: color
  }));
};
MessageManyFacetsIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MetricsIcon = function MetricsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M4.46448 11.5355C2.51184 9.58289 2.51184 6.41711 4.46448 4.46448C6.41711 2.51184 9.58289 2.51184 11.5355 4.46448C13.4882 6.41711 13.4882 9.58289 11.5355 11.5355C11.1451 11.9261 11.1451 12.5592 11.5355 12.9498C11.9261 13.3403 12.5592 13.3403 12.9498 12.9498C15.6835 10.2161 15.6835 5.78394 12.9498 3.05023C10.2162 0.316589 5.78406 0.316589 3.05042 3.05023C0.316528 5.78394 0.316528 10.2161 3.05042 12.9498C3.4408 13.3403 4.0741 13.3403 4.46448 12.9498C4.8551 12.5592 4.8551 11.9261 4.46448 11.5355Z",
    fill: color
  }), React.createElement("path", {
    d: "M9.00012 5.5C9.00012 4.94769 8.55237 4.5 8.00012 4.5C7.44788 4.5 7.00012 4.94769 7.00012 5.5V8C7.00012 8.55231 7.44788 9 8.00012 9C8.55237 9 9.00012 8.55231 9.00012 8V5.5Z",
    fill: color
  }));
};
MetricsIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MoreCardsIcon = function MoreCardsIcon() {
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 11.5C9 10.1193 10.1193 9 11.5 9C12.8807 9 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5Z",
    fill: "#007EFF"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 11.5C2 10.1193 3.11929 9 4.5 9C5.88071 9 7 10.1193 7 11.5C7 12.8807 5.88071 14 4.5 14C3.11929 14 2 12.8807 2 11.5Z",
    fill: "#5FA253"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4.5C9 3.11929 10.1193 2 11.5 2C12.8807 2 14 3.11929 14 4.5C14 5.88071 12.8807 7 11.5 7C10.1193 7 9 5.88071 9 4.5Z",
    fill: "#E6961E"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.5C2 3.11929 3.11929 2 4.5 2C5.88071 2 7 3.11929 7 4.5C7 5.88071 5.88071 7 4.5 7C3.11929 7 2 5.88071 2 4.5Z",
    fill: "#AE304A"
  }));
};
MoreCardsIcon.category = 'Navigation';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var MultiSelectIcon = function MultiSelectIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M13.707 2.70718C14.0977 2.31656 14.0977 1.6835 13.707 1.29288C13.3167 0.902374 12.6833 0.902374 12.293 1.29288L6.5 7.08585L3.70703 4.29288C3.31665 3.90237 2.68335 3.90237 2.29297 4.29288C1.90234 4.6835 1.90234 5.31656 2.29297 5.70718L5.79297 9.20718C6.18335 9.59769 6.81665 9.59769 7.20703 9.20718L13.707 2.70718Z",
    fill: color
  }), React.createElement("path", {
    d: "M13.707 8.20718C14.0977 7.81656 14.0977 7.1835 13.707 6.79288C13.3167 6.40237 12.6833 6.40237 12.293 6.79288L6.5 12.5858L3.70703 9.79288C3.31665 9.40237 2.68335 9.40237 2.29297 9.79288C1.90234 10.1835 1.90234 10.8166 2.29297 11.2072L5.79297 14.7072C6.18335 15.0977 6.81665 15.0977 7.20703 14.7072L13.707 8.20718Z",
    fill: color
  }));
};
MultiSelectIcon.category = 'Common Actions';

var _Rotations$3;
var Directions$3 = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};
var Rotations$3 = (_Rotations$3 = {}, _defineProperty(_Rotations$3, Directions$3.LEFT, 0), _defineProperty(_Rotations$3, Directions$3.TOP, -270), _defineProperty(_Rotations$3, Directions$3.BOTTOM, 270), _defineProperty(_Rotations$3, Directions$3.RIGHT, -180), _Rotations$3);
var NavIcon = function NavIcon(_ref) {
  var direction = _ref.direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  var rotationDegrees = Rotations$3.hasOwnProperty(direction) ?
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  Rotations$3[direction] : Rotations$3[Directions$3.LEFT];
  return React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    style: {
      transform: "rotate(".concat(rotationDegrees, "deg)"),
      display: 'block'
    }
  }, React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M23,11.5005846 C22.9914414,10.1422883 21.8623902,9.04117159 20.5,9.04117159 L8.53635362,9.04117159 L12.7479223,4.89797684 C13.7275168,3.93428588 14.9003143,2.1548151 13.4003143,0.679167296 C11.9003143,-0.796480512 10.1973818,0.45083931 9.21238839,1.41984158 L0.738998499,9.75566777 C0.248210307,10.2384881 0.000935939411,10.8692668 0,11.500182 C-4.85966393e-05,12.1275824 0.245511772,12.7600264 0.738998499,13.2455015 L9.21238839,21.5813277 C10.1919829,22.5450186 11.9003143,23.79765 13.4003143,22.3220022 C14.9003143,20.8463543 13.7329157,19.0721947 12.7479223,18.1031924 L8.53635362,13.9599976 L20.5,13.9599976 C21.8759851,13.9599976 22.9914414,12.8683507 23,11.5005846 L23,11.5005846 Z"
  }));
};
NavIcon.category = 'Navigation';
NavIcon.Directions = Directions$3;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var NewFieldIcon = function NewFieldIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H13V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V5H10C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3H11V2ZM3 6C3 5.44772 3.44772 5 4 5H6C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3H4C2.34315 3 1 4.34315 1 6V12C1 13.6569 2.34315 15 4 15H10C11.6569 15 13 13.6569 13 12V10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10V12C11 12.5523 10.5523 13 10 13H4C3.44772 13 3 12.5523 3 12V6Z",
    fill: color
  }));
};
NewFieldIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var NewWindowIcon = function NewWindowIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 3C4 1.89543 4.89551 1 6 1H13C14.1045 1 15 1.89543 15 3V8C15 9.10457 14.1045 10 13 10V13C13 14.1046 12.1045 15 11 15H3C1.89551 15 1 14.1046 1 13V7C1 5.89543 1.89551 5 3 5H4V3ZM6 5V8H13V5H6ZM11 10H6C4.89551 10 4 9.10457 4 8V7H3V13H11V10Z",
    fill: color
  }));
};
NewWindowIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$j = {
  DEFAULT: 'default',
  ON: 'on',
  DISABLED: 'disabled'
};
var NotificationIcon = function NotificationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$j.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$j.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M6.97314 2.55225V2C6.97314 1.44775 7.42065 1 7.97314 1H8.02539C8.57763 1 9.02539 1.44775 9.02539 2V2.55225L10.7786 3.54169C11.2935 3.83221 11.6533 4.33557 11.7617 4.91669L12.5488 9.1347C12.5937 9.37616 12.6829 9.6073 12.8118 9.81647L13.9685 11.6951C14.0505 11.8284 13.9546 12 13.7981 12H2.20019C2.0437 12 1.948 11.8284 2.03003 11.6951L3.18676 9.81647C3.31543 9.6073 3.40454 9.37616 3.4497 9.1347L4.23657 4.91669C4.34497 4.33557 4.70508 3.83221 5.21972 3.54169L6.97314 2.55225Z",
    fill: color
  }), React.createElement("path", {
    d: "M6.78027 14.2485L6.62011 13.6243C6.53906 13.3079 6.77783 13 7.10449 13H8.89404C9.22046 13 9.45947 13.3079 9.37817 13.6243L9.21801 14.2485C9.10473 14.6907 8.70605 15 8.24951 15H7.74878C7.29223 15 6.8938 14.6907 6.78027 14.2485Z",
    fill: color
  })), type === Types$j.ON && React.createElement("g", null, React.createElement("path", {
    d: "M11.6347 2.30415L12.0251 1.91371C12.4157 1.52315 13.0488 1.52315 13.4394 1.91371C13.8298 2.30421 13.8298 2.93739 13.4394 3.3279L13.0488 3.7184L13.519 5.72029C13.6479 6.26881 13.5393 6.84621 13.2202 7.31056L10.8156 10.8085C10.7419 10.9155 10.6792 11.0293 10.6276 11.1481C10.5847 11.2476 10.5498 11.3507 10.5234 11.4564L9.98945 13.5918C9.95186 13.7426 9.76387 13.7946 9.654 13.6847L1.66841 5.69899C1.5583 5.58907 1.61055 5.40126 1.76118 5.36354L3.89668 4.82967C4.12837 4.77174 4.34785 4.67281 4.54463 4.53755L8.04243 2.13295C8.50679 1.81374 9.08418 1.70522 9.63276 1.834L11.6347 2.30415Z",
    fill: FontColorSelected
  }), React.createElement("path", {
    d: "M6.06294 13.265L6.39229 12.7159C6.55977 12.437 6.94478 12.3896 7.17476 12.6196L8.39033 13.8353C8.62031 14.0653 8.57295 14.4502 8.29414 14.6176L7.74482 14.947C7.35151 15.1831 6.84785 15.1211 6.52339 14.7966L6.21333 14.4866C5.88887 14.1621 5.82686 13.6585 6.06294 13.265Z",
    fill: FontColorSelected
  })), type === Types$j.DISABLED && React.createElement("g", null, React.createElement("path", {
    d: "M2.70711 1.29289C2.31658 0.902369 1.68342 0.902369 1.29289 1.29289C0.902369 1.68342 0.902369 2.31658 1.29289 2.70711L4.12116 5.53537L3.4497 9.1347C3.40454 9.37616 3.31543 9.6073 3.18676 9.81647L2.03003 11.6951C1.948 11.8284 2.0437 12 2.20019 12H10.5858L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L2.70711 1.29289Z",
    fill: color
  }), React.createElement("path", {
    d: "M11.7617 4.91669L12.3588 8.11648L6.859 2.61666L6.97314 2.55225V2C6.97314 1.44775 7.42065 1 7.97314 1H8.02539C8.57763 1 9.02539 1.44775 9.02539 2V2.55225L10.7786 3.54169C11.2935 3.83221 11.6533 4.33557 11.7617 4.91669Z",
    fill: color
  }), React.createElement("path", {
    d: "M6.78027 14.2485L6.62011 13.6243C6.53906 13.3079 6.77783 13 7.10449 13H8.89404C9.22046 13 9.45947 13.3079 9.37817 13.6243L9.21801 14.2485C9.10473 14.6907 8.70605 15 8.24951 15H7.74878C7.29223 15 6.8938 14.6907 6.78027 14.2485Z",
    fill: color
  })));
};
NotificationIcon.category = 'Entity';
NotificationIcon.Types = Types$j;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var OneByOneIcon = function OneByOneIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M2 3C1.44775 3 1 3.44772 1 4V12C1 12.5523 1.44775 13 2 13H4C4.55225 13 5 12.5523 5 12V4C5 3.44772 4.55225 3 4 3H2Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 3C7.44775 3 7 3.44772 7 4C7 4.55228 7.44775 5 8 5H14C14.5522 5 15 4.55228 15 4C15 3.44772 14.5522 3 14 3H8Z",
    fill: color
  }), React.createElement("path", {
    d: "M7 12C7 11.4477 7.44775 11 8 11H14C14.5522 11 15 11.4477 15 12C15 12.5523 14.5522 13 14 13H8C7.44775 13 7 12.5523 7 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 7C7.44775 7 7 7.44772 7 8C7 8.55228 7.44775 9 8 9H14C14.5522 9 15 8.55228 15 8C15 7.44772 14.5522 7 14 7H8Z",
    fill: color
  }));
};
OneByOneIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$k = {
  DEFAULT: 'default',
  CROSSOUT: 'crossout'
};
var Sizes$9 = {
  DEFAULT: 'default',
  BIG: 'big'
};
var defaultColor = '#B4900E';
var OwnerIcon = function OwnerIcon(_ref) {
  var color = _ref.color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$k.DEFAULT : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$9.DEFAULT : _ref$size;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$k.DEFAULT && size === Sizes$9.DEFAULT && React.createElement("path", {
    d: "M3.0296 6.55512C3.01356 6.29594 3.21943 6.07692 3.47911 6.07692C3.62645 6.07692 3.76448 6.149 3.84869 6.26991L5.25855 8.29432C5.49885 8.63938 6.03186 8.55175 6.14904 8.14792L7.54333 3.34299C7.60229 3.1398 7.78842 3 8 3C8.21158 3 8.39771 3.1398 8.45667 3.34299L9.85096 8.14792C9.96814 8.55175 10.5011 8.63938 10.7415 8.29432L12.1513 6.26991C12.2355 6.149 12.3735 6.07692 12.5209 6.07692C12.7806 6.07692 12.9864 6.29594 12.9704 6.55512L12.6295 12.0618C12.5969 12.5891 12.1597 13 11.6314 13H4.36858C3.84029 13 3.40313 12.5891 3.37049 12.0618L3.0296 6.55512Z",
    fill: color === undefined ? defaultColor : color
  }), type === Types$k.DEFAULT && size === Sizes$9.BIG && React.createElement("path", {
    d: "M1.15483 5.69674C1.07537 5.33918 1.34745 5 1.71373 5C1.89394 5 2.06363 5.08485 2.17176 5.22901L4.41405 8.21873C4.65863 8.54484 5.1697 8.45695 5.29129 8.06787L7.35086 1.47724C7.43959 1.19332 7.70254 1 8 1C8.29746 1 8.56041 1.19332 8.64914 1.47724L10.7087 8.06787C10.8303 8.45695 11.3414 8.54484 11.5859 8.21873L13.8282 5.22901C13.9364 5.08485 14.1061 5 14.2863 5C14.6525 5 14.9246 5.33918 14.8452 5.69674L13.174 13.2169C13.0723 13.6745 12.6665 14 12.1978 14H3.80217C3.33347 14 2.92766 13.6745 2.82598 13.2169L1.15483 5.69674Z",
    fill: color === undefined ? defaultColor : color
  }), type === Types$k.CROSSOUT && size === Sizes$9.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.02969 6.55512C3.01364 6.29594 3.21952 6.07692 3.4792 6.07692C3.62654 6.07692 3.76456 6.149 3.84877 6.26991L5.25863 8.29432C5.26314 8.30081 5.26776 8.30713 5.27248 8.31331L3.26293 10.3229L3.02969 6.55512ZM3.6847 12.7295C3.86401 12.8976 4.10498 13 4.36867 13H5.82651H5.8299H11.6315C12.1598 13 12.597 12.5891 12.6296 12.0618L12.9705 6.55512C12.9757 6.47077 12.9574 6.39067 12.9214 6.321L13.5353 5.70711C13.9258 5.31658 13.9258 4.68342 13.5353 4.29289C13.1448 3.90237 12.5116 3.90237 12.1211 4.29289L11.7195 4.69446C11.7154 4.6987 11.7113 4.70292 11.7071 4.70711L3.6847 12.7295ZM8.85846 4.72733L8.45676 3.34299C8.39779 3.1398 8.21166 3 8.00008 3C7.7885 3 7.60238 3.1398 7.54341 3.34299L6.43989 7.1459L8.85846 4.72733Z",
    fill: color === undefined ? IconsGeneralColor : color
  }), type === Types$k.CROSSOUT && size === Sizes$9.BIG && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.79952 2.95799L8.64929 2.47724C8.56056 2.19332 8.29762 2 8.00015 2C7.70269 2 7.43974 2.19332 7.35101 2.47724L6.47408 5.28343L8.79952 2.95799ZM3.61045 8.14706L2.17191 6.22901C2.06379 6.08485 1.89409 6 1.71388 6C1.34761 6 1.07552 6.33918 1.15498 6.69674L1.86513 9.89238L3.61045 8.14706ZM1.28252 13.3034L12.8788 1.70711C12.8823 1.70362 12.8858 1.70012 12.8892 1.69659L13.2929 1.29289C13.6834 0.902369 14.3166 0.902369 14.7071 1.29289C15.0976 1.68342 15.0976 2.31658 14.7071 2.70711L10.1464 7.26786L10.7089 9.06787C10.8305 9.45695 11.3415 9.54484 11.5861 9.21873L13.8284 6.22901C13.9365 6.08485 14.1062 6 14.2864 6C14.6527 6 14.9248 6.33918 14.8453 6.69674L13.1742 14.2169C13.0725 14.6745 12.6667 15 12.198 15H3.80232C3.43208 15 3.10107 14.7969 2.92823 14.486L2.70711 14.7071C2.31658 15.0976 1.68342 15.0976 1.29289 14.7071C0.905856 14.3201 0.9024 13.6947 1.28252 13.3034Z",
    fill: color === undefined ? IconsGeneralColor : color
  }));
};
OwnerIcon.category = 'Entity';
OwnerIcon.Types = Types$k;
OwnerIcon.Sizes = Sizes$9;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$a = {
  DEFAULT: 'default',
  BIG: 'big'
};
var PhabricatorIcon = function PhabricatorIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$a.DEFAULT : _ref$size;
  var numericSize = size === Sizes$a.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$a.BIG ? {} : {
      transform: 'scale(0.7)',
      transformOrigin: '0 0'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0929 8.45043L14.144 9.59944C14.2973 9.71985 14.439 9.85278 14.5672 9.99653L15.8022 10.0443L16.1627 10.8328L15.3302 11.7118C15.3398 11.8082 15.3446 11.9058 15.3446 12.0045C15.3446 12.1254 15.3373 12.2448 15.323 12.3622L16.1627 13.2488L15.8022 14.0373L14.4979 14.0877C14.3895 14.2018 14.2723 14.3085 14.1473 14.4069L14.0929 15.6311L13.2473 15.9673L12.2399 15.1377C12.1522 15.1441 12.0636 15.1473 11.9742 15.1473C11.8708 15.1473 11.7686 15.143 11.6676 15.1345L10.6563 15.9673L9.81072 15.6311L9.75463 14.3697C9.64761 14.2823 9.54657 14.1887 9.45216 14.0895L8.10143 14.0373L7.74095 13.2488L8.62048 12.3201C8.60937 12.2163 8.60369 12.111 8.60369 12.0045C8.60369 11.9204 8.60723 11.8372 8.61417 11.7548L7.74095 10.8328L8.10143 10.0443L9.38276 9.99474C9.49748 9.86626 9.62299 9.74644 9.75798 9.6365L9.81071 8.45043L10.6563 8.11429L11.5886 8.88197C11.7151 8.86853 11.8438 8.86162 11.9742 8.86162C12.0909 8.86162 12.2063 8.86716 12.3199 8.87796L13.2473 8.11429L14.0929 8.45043ZM13.3175 12.0571C13.3175 12.7514 12.7139 13.3143 11.9694 13.3143C11.2248 13.3143 10.6212 12.7514 10.6212 12.0571C10.6212 11.3628 11.2248 10.8 11.9694 10.8C12.7139 10.8 13.3175 11.3628 13.3175 12.0571Z",
    fill: "#404F6E"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9694 20C9.90129 20 8.00412 19.3177 6.52264 18.1813L6.51532 18.2L1.87993 13.8226C1.34098 13.3878 1 12.7453 1 12.0286C1 11.3119 1.34098 10.6694 1.87993 10.2346C2.33725 9.80269 2.78835 9.3519 3.24166 8.89891C5.66144 6.48082 8.144 4 11.9694 4C16.2865 4 19.1072 7.01487 21.7291 9.81722C21.8599 9.95699 21.9901 10.0962 22.1201 10.2346C22.659 10.6694 23 11.3119 23 12.0286C23 12.7453 22.659 13.3878 22.1201 13.8226C21.6683 14.2419 21.2215 14.6792 20.7721 15.1191L20.7721 15.1191C18.3163 17.5229 15.7856 20 11.9694 20ZM18.8329 12C18.8329 15.5031 15.7874 18.3429 12.0306 18.3429C8.27387 18.3429 5.22841 15.5031 5.22841 12C5.22841 8.49694 8.27387 5.65714 12.0306 5.65714C15.7874 5.65714 18.8329 8.49694 18.8329 12Z",
    fill: "#404F6E"
  })));
};
PhabricatorIcon.category = 'Tool';
PhabricatorIcon.Sizes = Sizes$a;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PhoneIcon = function PhoneIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5.68712 7.73808C5.98879 8.15101 6.41455 8.67306 6.98472 9.24323C7.55489 9.8134 8.07694 10.2392 8.48987 10.5408C9.02098 10.9288 9.72961 10.8205 10.1947 10.3554L10.9453 9.6048C11.4675 9.08261 12.2884 9.00858 12.8955 9.42893L14.3219 10.4164C14.9238 10.8331 15.1435 11.6226 14.6931 12.1997C13.4678 13.7696 10.4988 15.9988 5.36398 10.864C0.229195 5.7292 2.45833 2.76017 4.02829 1.53483C4.60538 1.08442 5.39487 1.30417 5.81156 1.90606L6.79901 3.3324C7.21936 3.93958 7.14534 4.76049 6.62315 5.28268L5.87258 6.03324C5.4075 6.49833 5.29912 7.20697 5.68712 7.73808Z",
    fill: color
  }));
};
PhoneIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PinnedIcon = function PinnedIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M9.23101 1.33147C9.62154 0.940943 10.2547 0.940943 10.6452 1.33147L14.6686 5.35485C15.0591 5.74537 15.0591 6.37854 14.6686 6.76906C14.2781 7.15959 13.6449 7.15959 13.2544 6.76906L13.0004 6.5151C12.5543 6.69974 11.9233 7.05333 11.2541 7.72259C10.2956 8.68104 9.98457 9.56109 9.89004 9.93183C10.3387 11.1372 10.0786 12.5466 9.10964 13.5155L6.50419 10.9101L2.80798 14.6063L1.34326 14.6568L1.39377 13.1921L5.08998 9.49588L2.48463 6.89054C3.45351 5.92166 4.86272 5.66149 6.06808 6.11003C6.43874 6.01555 7.31888 5.70455 8.27745 4.74598C8.94671 4.07672 9.3003 3.44569 9.48493 2.9996L9.23101 2.74568C8.84049 2.35516 8.84049 1.72199 9.23101 1.33147Z",
    fill: color
  }));
};
PinnedIcon.category = 'Info';

var _Color, _Path;
var Types$l = {
  passed: 'passed',
  failed: 'failed',
  pending: 'pending',
  running: 'running',
  skipped: 'skipped',
  warning: 'warning',
  cancelled: 'cancelled'
};
var Color = (_Color = {}, _defineProperty(_Color, Types$l.passed, FontColorSuccess), _defineProperty(_Color, Types$l.failed, FontColorError), _defineProperty(_Color, Types$l.pending, FontColorWarning), _defineProperty(_Color, Types$l.running, Third), _defineProperty(_Color, Types$l.skipped, Second), _defineProperty(_Color, Types$l.warning, FontColorWarning), _defineProperty(_Color, Types$l.cancelled, Second), _Color);
var Path = (_Path = {}, _defineProperty(_Path, Types$l.passed, function (color) {
  return React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00012 15C11.8661 15 15.0001 11.866 15.0001 8C15.0001 4.13403 11.8661 1 8.00012 1C4.13416 1 1.00012 4.13403 1.00012 8C1.00012 11.866 4.13416 15 8.00012 15ZM8.00012 13C10.7615 13 13.0001 10.7614 13.0001 8C13.0001 5.2386 10.7615 3 8.00012 3C5.23872 3 3.00012 5.2386 3.00012 8C3.00012 10.7614 5.23872 13 8.00012 13ZM11.2072 5.79292C11.5978 6.18343 11.5978 6.8166 11.2072 7.20711L8.20715 10.2071C7.81677 10.5977 7.18347 10.5977 6.79309 10.2071L5.29309 8.70711C4.90247 8.31661 4.90247 7.68343 5.29309 7.29292C5.68347 6.90236 6.31677 6.90236 6.70715 7.29292L7.50012 8.08583L9.79309 5.79292C10.1835 5.40236 10.8168 5.40236 11.2072 5.79292Z",
    fill: color
  });
}), _defineProperty(_Path, Types$l.failed, function (color) {
  return React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM8 13C10.7614 13 13 10.7614 13 8C13 5.2386 10.7614 3 8 3C5.2386 3 3 5.2386 3 8C3 10.7614 5.2386 13 8 13ZM5.17188 5.17154C5.56226 4.78104 6.19556 4.78104 6.58594 5.17154L8.00024 6.58585L9.41455 5.17154C9.80518 4.78104 10.4382 4.78104 10.8289 5.17154C11.2192 5.56204 11.2192 6.19522 10.8289 6.58572L9.41455 8.00009L10.8286 9.41422C11.2192 9.80472 11.2192 10.4379 10.8286 10.8284C10.4382 11.2189 9.80493 11.2189 9.41455 10.8284L8.00024 9.41422L6.58618 10.8284C6.19556 11.2189 5.5625 11.2189 5.17188 10.8284C4.78149 10.4378 4.78149 9.80466 5.17188 9.41415L6.58618 7.99997L5.17188 6.58578C4.78125 6.19528 4.78125 5.56204 5.17188 5.17154Z",
    fill: color
  });
}), _defineProperty(_Path, Types$l.pending, function (color) {
  return React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM13 8C13 10.7614 10.7614 13 8 13C5.2386 13 3 10.7614 3 8C3 5.2386 5.2386 3 8 3C10.7614 3 13 5.2386 13 8ZM8.5 6.5C8.5 5.94772 8.94772 5.5 9.5 5.5C10.0523 5.5 10.5 5.94772 10.5 6.5V9.5C10.5 10.0523 10.0523 10.5 9.5 10.5C8.94772 10.5 8.5 10.0523 8.5 9.5V6.5ZM6.5 5.5C5.94772 5.5 5.5 5.94772 5.5 6.5V9.5C5.5 10.0523 5.94772 10.5 6.5 10.5C7.05228 10.5 7.5 10.0523 7.5 9.5V6.5C7.5 5.94772 7.05228 5.5 6.5 5.5Z",
    fill: color
  });
}), _defineProperty(_Path, Types$l.running, function (color) {
  return React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM13 8C13 10.7614 10.7614 13 8 13C5.2386 13 3 10.7614 3 8C3 5.2386 5.2386 3 8 3C10.7614 3 13 5.2386 13 8ZM8.0003 12C6.89573 12 5.89573 11.5523 5.17188 10.8284L5.5003 10.5L8.0003 8V4C10.2094 4 12.0003 5.79086 12.0003 8C12.0003 10.2091 10.2094 12 8.0003 12Z",
    fill: color
  });
}), _defineProperty(_Path, Types$l.skipped, function (color) {
  return [React.createElement("path", {
    key: "Thoth",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM13 8C13 10.7614 10.7614 13 8 13C5.2386 13 3 10.7614 3 8C3 5.2386 5.2386 3 8 3C10.7614 3 13 5.2386 13 8ZM8.12204 5.79455C7.95932 5.63183 7.95932 5.36801 8.12204 5.20529C8.28476 5.04257 8.54858 5.04257 8.71129 5.20529L11.2113 7.70529C11.369 7.86303 11.3746 8.11703 11.2238 8.28147L8.93215 10.7815C8.77665 10.9511 8.51308 10.9626 8.34345 10.8071C8.17382 10.6516 8.16236 10.388 8.31785 10.2184L10.3399 8.01245L8.12204 5.79455ZM5.2057 5.20529C5.04298 5.36801 5.04298 5.63183 5.2057 5.79455L7.4236 8.01245L5.40151 10.2184C5.24601 10.388 5.25747 10.6516 5.42711 10.8071C5.59674 10.9626 5.86031 10.9511 6.01581 10.7815L8.30747 8.28147C8.45821 8.11703 8.45269 7.86303 8.29495 7.70529L5.79495 5.20529C5.63223 5.04257 5.36842 5.04257 5.2057 5.20529Z",
    fill: color
  }), React.createElement("path", {
    key: "Trismegistus",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM13 8C13 10.7614 10.7614 13 8 13C5.2386 13 3 10.7614 3 8C3 5.2386 5.2386 3 8 3C10.7614 3 13 5.2386 13 8ZM8.12204 5.79455C7.95932 5.63183 7.95932 5.36801 8.12204 5.20529C8.28476 5.04257 8.54858 5.04257 8.71129 5.20529L11.2113 7.70529C11.369 7.86303 11.3746 8.11703 11.2238 8.28147L8.93215 10.7815C8.77665 10.9511 8.51308 10.9626 8.34345 10.8071C8.17382 10.6516 8.16236 10.388 8.31785 10.2184L10.3399 8.01245L8.12204 5.79455ZM5.2057 5.20529C5.04298 5.36801 5.04298 5.63183 5.2057 5.79455L7.4236 8.01245L5.40151 10.2184C5.24601 10.388 5.25747 10.6516 5.42711 10.8071C5.59674 10.9626 5.86031 10.9511 6.01581 10.7815L8.30747 8.28147C8.45821 8.11703 8.45269 7.86303 8.29495 7.70529L5.79495 5.20529C5.63223 5.04257 5.36842 5.04257 5.2057 5.20529Z",
    fill: "white",
    fillOpacity: "0.45"
  })];
}), _defineProperty(_Path, Types$l.warning, function (color) {
  return React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM8 13C10.7614 13 13 10.7614 13 8C13 5.2386 10.7614 3 8 3C5.2386 3 3 5.2386 3 8C3 10.7614 5.2386 13 8 13ZM7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8V5ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10Z",
    fill: color
  });
}), _defineProperty(_Path, Types$l.cancelled, function (color) {
  return [React.createElement("path", {
    key: "Ishtar",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM8 13C10.7614 13 13 10.7614 13 8C13 5.2386 10.7614 3 8 3C5.2386 3 3 5.2386 3 8C3 10.7614 5.2386 13 8 13ZM5.17195 5.17156C4.78143 5.56208 4.78143 6.19524 5.17195 6.58577L9.41459 10.8284C9.80512 11.2189 10.4383 11.2189 10.8288 10.8284C11.2193 10.4379 11.2193 9.80472 10.8288 9.4142L6.58616 5.17156C6.19564 4.78103 5.56247 4.78103 5.17195 5.17156Z",
    fill: color
  }), React.createElement("path", {
    key: "Venus",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM8 13C10.7614 13 13 10.7614 13 8C13 5.2386 10.7614 3 8 3C5.2386 3 3 5.2386 3 8C3 10.7614 5.2386 13 8 13ZM5.17195 5.17156C4.78143 5.56208 4.78143 6.19524 5.17195 6.58577L9.41459 10.8284C9.80512 11.2189 10.4383 11.2189 10.8288 10.8284C11.2193 10.4379 11.2193 9.80472 10.8288 9.4142L6.58616 5.17156C6.19564 4.78103 5.56247 4.78103 5.17195 5.17156Z",
    fill: "white",
    fillOpacity: "0.45"
  })];
}), _Path);
var PipelineIcon = function PipelineIcon(props) {
  var iconColor = props.color || Color[props.type];
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Path[props.type] && Path[props.type](iconColor));
};
PipelineIcon.category = 'Messages';
PipelineIcon.Types = Types$l;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PlayIcon = function PlayIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M4 4.6995C4 3.93701 4.81911 3.45505 5.48564 3.82534L11.4265 7.12583C12.1123 7.50683 12.1123 8.49313 11.4265 8.87414L5.48564 12.1746C4.81911 12.5449 4 12.063 4 11.3005V4.6995Z",
    fill: color
  }));
};
PlayIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PluginIcon = function PluginIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M4 2C4 0.895447 4.89551 0 6 0C7.10449 0 8 0.895447 8 2V3H10.5C11.3284 3 12 3.67157 12 4.5V7H13C14.1045 7 15 7.89545 15 9C15 10.1046 14.1045 11 13 11H12V13.5C12 14.3284 11.3284 15 10.5 15H8V13C8 11.8954 7.10449 11 6 11C4.89551 11 4 11.8954 4 13V15H1.5C0.671631 15 0 14.3284 0 13.5V4.5C0 3.67157 0.671631 3 1.5 3H4V2Z",
    fill: color
  }));
};
PluginIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$b = {
  DEFAULT: 'default',
  SMALL: 'small'
};
var PlusIcon = function PlusIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$b.DEFAULT : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, size === Sizes$b.DEFAULT && React.createElement("path", {
    d: "M8 2C7.44775 2 7 2.44772 7 3V7H3C2.44775 7 2 7.44772 2 8C2 8.55228 2.44775 9 3 9H7V13C7 13.5523 7.44775 14 8 14C8.55225 14 9 13.5523 9 13V9H13C13.5522 9 14 8.55228 14 8C14 7.44772 13.5522 7 13 7H9V3C9 2.44772 8.55225 2 8 2Z",
    fill: color
  }), size === Sizes$b.SMALL && React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 4C9 3.44775 8.55225 3 8 3C7.44775 3 7 3.44775 7 4V7H4C3.44775 7 3 7.44775 3 8C3 8.55225 3.44775 9 4 9H7V12C7 12.5522 7.44775 13 8 13C8.55225 13 9 12.5522 9 12V9H12C12.5522 9 13 8.55225 13 8C13 7.44775 12.5522 7 12 7H9V4Z",
    fill: color
  }));
};
PlusIcon.category = 'Common Actions';
PlusIcon.Sizes = Sizes$b;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PresentIcon = function PresentIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    version: "1.1",
    fill: color,
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 6C7.44775 6 7 6.44769 7 7H1V6C1 5.44769 1.44775 5 2 5H3.17065C3.06006 4.68719 3 4.35065 3 4C3 2.34314 4.34326 1 6 1C7.20703 1 8.24756 1.71295 8.72363 2.74078C9.17676 2.28333 9.80542 2 10.5 2C11.8806 2 13 3.11926 13 4.5C13 4.6712 12.9827 4.83844 12.95 5H14C14.5522 5 15 5.44769 15 6V7H9C9 6.44769 8.55225 6 8 6ZM7 4C7 4.55231 6.55225 5 6 5C5.44775 5 5 4.55231 5 4C5 3.44769 5.44775 3 6 3C6.55225 3 7 3.44769 7 4ZM10.5 5C10.7761 5 11 4.77612 11 4.5C11 4.22388 10.7761 4 10.5 4C10.2239 4 10 4.22388 10 4.5C10 4.77612 10.2239 5 10.5 5Z"
  }), React.createElement("path", {
    d: "M1 8H7V15H3C1.89551 15 1 14.1046 1 13V8Z"
  }), React.createElement("path", {
    d: "M15 13C15 14.1046 14.1045 15 13 15H9V8H15V13Z"
  }));
};
PresentIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PrivateIcon = function PrivateIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 7V6C3 3.23857 5.23853 1 8 1C10.7615 1 13 3.23857 13 6V7C14.1045 7 15 7.89543 15 9V13C15 14.1046 14.1045 15 13 15H3C1.89551 15 1 14.1046 1 13V9C1 7.89543 1.89551 7 3 7ZM5 6C5 4.34314 6.34326 3 8 3C9.65674 3 11 4.34314 11 6V7H5V6ZM6 11C6 9.89543 6.89551 9 8 9C9.10449 9 10 9.89543 10 11C10 12.1046 9.10449 13 8 13C6.89551 13 6 12.1046 6 11Z",
    fill: color
  }));
};
PrivateIcon.category = 'Permissions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PrintIcon = function PrintIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.00004V3.00004C3 1.89547 3.89543 1.00004 5 1.00004H11C12.1046 1.00004 13 1.89547 13 3.00004V5.00004C14.1046 5.00004 15 5.89547 15 7.00004V9.00004C15 10.1046 14.1046 11 13 11V12C13 13.6569 11.6569 15 10 15H6C4.34315 15 3 13.6569 3 12L3 11C1.89543 11 1 10.1046 1 9.00004V7.00004C1 5.89547 1.89543 5.00004 3 5.00004ZM5 3.00004H11V5.00004H5V3.00004ZM6 13C5.44772 13 5 12.5523 5 12V10H11V12C11 12.5523 10.5523 13 10 13H6Z",
    fill: color
  }));
};
PrintIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ProcessIcon = function ProcessIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M4.73242 4C4.38672 4.59778 3.74023 5 3 5C1.89551 5 1 4.10461 1 3C1 1.89539 1.89551 1 3 1C3.74023 1 4.38672 1.40222 4.73242 2H11.5C13.4331 2 15 3.56702 15 5.5C15 7.43298 13.4331 9 11.5 9H9.73242C9.38672 9.59778 8.74023 10 8 10C7.25977 10 6.61328 9.59778 6.26758 9H4.5C3.67139 9 3 9.67163 3 10.5C3 11.3284 3.67139 12 4.5 12H11.2676C11.6133 11.4022 12.2598 11 13 11C14.1045 11 15 11.8954 15 13C15 14.1046 14.1045 15 13 15C12.2598 15 11.6133 14.5978 11.2676 14H4.5C2.56689 14 1 12.433 1 10.5C1 8.56702 2.56689 7 4.5 7H6.26758C6.61328 6.40222 7.25977 6 8 6C8.74023 6 9.38672 6.40222 9.73242 7H11.5C12.3286 7 13 6.32837 13 5.5C13 4.67163 12.3286 4 11.5 4H4.73242Z",
    fill: color
  }));
};
ProcessIcon.category = 'Entity';

var _sizeToParams;
var Sizes$c = {
  DEFAULT: 'default',
  BIG: 'big'
};
var sizeToParams = (_sizeToParams = {}, _defineProperty(_sizeToParams, Sizes$c.DEFAULT, {
  numericSize: 16
}), _defineProperty(_sizeToParams, Sizes$c.BIG, {
  numericSize: 48
}), _sizeToParams);
var ProjectIcon = function ProjectIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$c.DEFAULT : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  var _ref2 = sizeToParams.hasOwnProperty(size) ?
    // hasOwnProperty explicitly called here
    // eslint-disable-next-line security/detect-object-injection
    sizeToParams[size] : sizeToParams[Sizes$c.DEFAULT],
    numericSize = _ref2.numericSize;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    style: size === Sizes$c.BIG ? {
      transform: 'scale(3)',
      transformOrigin: '0 0'
    } : {}
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4H3C1.89551 4 1 4.89543 1 6V13C1 14.1046 1.89551 15 3 15H13C14.1045 15 15 14.1046 15 13V6C15 4.89543 14.1045 4 13 4H12V3C12 1.89543 11.1045 1 10 1H6C4.89551 1 4 1.89543 4 3V4ZM6 4H10V3H6V4ZM6 11C6 10.4477 6.44775 10 7 10H9C9.55225 10 10 10.4477 10 11C10 11.5523 9.55225 12 9 12H7C6.44775 12 6 11.5523 6 11Z",
    fill: color
  })));
};
ProjectIcon.category = 'Entity';
ProjectIcon.Sizes = Sizes$c;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var PublicIcon = function PublicIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM5.47748 11.764L5.11813 11.189C5.04093 11.0655 5 10.9228 5 10.7771C5 10.3479 5.34793 10 5.77713 10H5.92539C6.13552 10 6.3394 9.92848 6.50348 9.79722L7.04497 9.36403C7.32619 9.13905 7.70667 9.08267 8.04105 9.21642L9.37139 9.74856C9.75105 9.90042 10 10.2681 10 10.677V11.0004C11.2144 10.0882 12 8.63582 12 7C12 4.38553 9.99334 2.23973 7.43615 2.01876C7.64612 2.07804 7.8 2.27105 7.8 2.5C7.8 2.77614 8.02386 3 8.3 3H8.4C8.73137 3 9 3.26863 9 3.6V5.53162C9 5.8284 8.86818 6.10985 8.64019 6.29985L6.87814 7.76822C6.69842 7.91798 6.47189 8 6.23795 8H5.76205C5.52812 8 5.30158 7.91798 5.12187 7.76822L4.55982 7.29985C4.33183 7.10985 4.2 6.8284 4.2 6.53162V5.46838C4.2 5.1716 4.06818 4.89015 3.84019 4.70015L3.65796 4.5483C3.38106 4.31755 3.25732 3.96442 3.30996 3.626C2.49637 4.51531 2 5.69969 2 7C2 9.23053 3.46057 11.1199 5.47748 11.764Z",
    fill: color
  }));
};
PublicIcon.category = 'Permissions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Statuses = {
  PASSED: 'passed',
  FAILED: 'failed',
  BLOCKED: 'blocked',
  ONHOLD: 'onhold',
  NOTRUN: 'notrun'
};
var QAIcon = function QAIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? Statuses.PASSED : _ref$status;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    fill: "none",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, status === Statuses.PASSED && React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.7071 3.29289C15.0976 3.68342 15.0976 4.31658 14.7071 4.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L1.29289 8.70711C0.902369 8.31658 0.902369 7.68342 1.29289 7.29289C1.68342 6.90237 2.31658 6.90237 2.70711 7.29289L6 10.5858L13.2929 3.29289C13.6834 2.90237 14.3166 2.90237 14.7071 3.29289Z",
    fill: FontColorSuccess
  }), status === Statuses.FAILED && React.createElement("path", {
    d: "M11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L9.41421 8L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8 9.41421L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.58579 8L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L8 6.58579L11.2929 3.29289Z",
    fill: FontColorError
  }), status === Statuses.BLOCKED && React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8ZM13 8C13 10.7614 10.7615 13 8 13C6.98096 13 6.0332 12.6951 5.24268 12.1716L12.1716 5.24255C12.6951 6.03299 13 6.9809 13 8ZM10.7573 3.82841C9.9668 3.30489 9.01904 3 8 3C5.23853 3 3 5.23857 3 8C3 9.0191 3.30493 9.96701 3.82837 10.7574L10.7573 3.82841Z",
    fill: FontColorError
  }), status === Statuses.ONHOLD && React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 8C4 5.79086 5.79086 4 8 4V2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 6.34315 13.3284 4.84315 12.2426 3.75736L10.8284 5.17157C11.5523 5.89543 12 6.89543 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z",
    fill: Third300
  }), status === Statuses.NOTRUN && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z",
    fill: color
  }));
};
QAIcon.category = 'QA';
QAIcon.Statuses = Statuses;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Statuses$1 = {
  PASSED: 'passed',
  FAILED: 'failed',
  SKIPPED: 'skipped',
  BLOCKED: 'blocked',
  NOTRUN: 'notrun',
  ONHOLD: 'onhold'
};
var QAStatusIcon = function QAStatusIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? Statuses$1.PASSED : _ref$status;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    fill: "none",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, status === Statuses$1.PASSED && React.createElement("path", {
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 6.96404 13.7375 5.98938 13.2753 5.13896L8 10.4142L5.29289 7.70711C4.90237 7.31659 4.90237 6.68341 5.29289 6.29289C5.68341 5.90237 6.31659 5.90237 6.70711 6.29289L8 7.58578L12.0305 3.55528C10.9654 2.58887 9.55147 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z",
    fill: FontColorSuccess
  }), status === Statuses$1.FAILED && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM10.7071 5.29289C11.0976 5.68341 11.0976 6.31659 10.7071 6.70711L9.41422 8L10.7071 9.29289C11.0976 9.68341 11.0976 10.3166 10.7071 10.7071C10.3166 11.0976 9.68341 11.0976 9.29289 10.7071L8 9.41422L6.70711 10.7071C6.31659 11.0976 5.68341 11.0976 5.29289 10.7071C4.90237 10.3166 4.90237 9.68341 5.29289 9.29289L6.58578 8L5.29289 6.70711C4.90237 6.31659 4.90237 5.68341 5.29289 5.29289C5.68341 4.90237 6.31659 4.90237 6.70711 5.29289L8 6.58578L9.29289 5.29289C9.68341 4.90237 10.3166 4.90237 10.7071 5.29289Z",
    fill: FontColorError
  }), status === Statuses$1.SKIPPED && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
    fill: color
  }), status === Statuses$1.ONHOLD && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z",
    fill: Third300
  }), status === Statuses$1.BLOCKED && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 2C6.36507 2 4.88118 2.65524 3.79996 3.71518C2.69032 4.80297 2 6.32177 2 8C2 11.3137 4.68629 14 8 14C9.67823 14 11.197 13.3097 12.2848 12.2C13.3448 11.1188 14 9.63493 14 8C14 4.68629 11.3137 2 8 2ZM11.4724 9.98743L6.01257 4.52764C6.59807 4.19165 7.27621 4 8 4C10.2091 4 12 5.79086 12 8C12 8.72379 11.8083 9.40193 11.4724 9.98743ZM4.58019 5.92368L10.0763 11.4198C9.47098 11.7883 8.76063 12 8 12C5.79086 12 4 10.2091 4 8C4 7.23937 4.2117 6.52903 4.58019 5.92368Z",
    fill: FontColorError
  }), status === Statuses$1.NOTRUN && React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z",
    fill: color
  }));
};
QAStatusIcon.category = 'QA';
QAStatusIcon.Statuses = Statuses$1;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var RecentIcon = function RecentIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 15C11.8662 15 15 11.866 15 8C15 4.13403 11.8662 1 8 1C4.13379 1 1 4.13403 1 8C1 11.866 4.13379 15 8 15ZM9 5C9 4.44775 8.55225 4 8 4C7.44775 4 7 4.44775 7 5V7.58582L5.29297 9.29285C4.90234 9.68335 4.90234 10.3167 5.29297 10.7072C5.68359 11.0977 6.31641 11.0977 6.70703 10.7072L8.7002 8.71375L8.70703 8.70715C8.8877 8.52612 9 8.27612 9 8V5Z",
    fill: color
  }));
};
RecentIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var RectangleIcon = function RectangleIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    version: "1.1",
    fill: color,
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5 6C5 5.44772 5.44772 5 6 5H10C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11H6C5.44772 11 5 10.5523 5 10V6Z",
    fill: color
  }));
};
RectangleIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$m = {
  RELATION: 'relation',
  DEPENDENCY: 'dependency',
  DUPLICATE: 'duplicate',
  BLOCKER: 'blocker',
  LINK: 'link'
};
var RelationIcon = function RelationIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$m.RELATION : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$m.RELATION && React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.3667 11.8831C2.8728 11.3608 1 9.1491 1 6.5C1 3.46243 3.4624 1 6.5 1C9.14917 1 11.3606 2.87286 11.8831 5.36674C13.7112 6.11049 15 7.90473 15 10C15 12.7614 12.7615 15 10 15C7.90479 15 6.11035 13.7112 5.3667 11.8831ZM3 6.5C3 4.56701 4.56689 3 6.5 3C7.90063 3 9.10864 3.82252 9.66821 5.01083C7.1709 5.17436 5.17432 7.17116 5.01074 9.66833C3.82251 9.10883 3 7.90047 3 6.5ZM11.8774 7.66C12.5618 8.20984 13 9.05376 13 10C13 11.6569 11.6567 13 10 13C9.05371 13 8.20972 12.5619 7.65991 11.8775C9.76636 11.4252 11.4253 9.76655 11.8774 7.66ZM7.00024 9.96453C8.53296 9.74521 9.74536 8.5329 9.9646 7.00021C8.33594 7.01908 7.01904 8.33583 7.00024 9.96453Z",
    fill: color
  }), type === Types$m.DEPENDENCY && React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.82935 13H9.17065C9.58252 14.1652 10.6938 15 12 15C13.6567 15 15 13.6569 15 12C15 10.3431 13.6567 9 12 9C11.928 9 11.8564 9.00244 11.7859 9.00745C11.7219 9.01196 11.6584 9.01855 11.5957 9.02698L10.356 6.85742C10.7593 6.34656 11 5.70142 11 5C11 3.34314 9.65674 2 8 2C6.34326 2 5 3.34314 5 5C5 5.70142 5.24072 6.34656 5.64404 6.85742L4.4043 9.02698C4.27197 9.00916 4.13721 9 4 9C2.34326 9 1 10.3431 1 12C1 13.6569 2.34326 15 4 15C5.30615 15 6.41748 14.1652 6.82935 13ZM9 5C9 5.55225 8.55225 6 8 6C7.44775 6 7 5.55225 7 5C7 4.44775 7.44775 4 8 4C8.55225 4 9 4.44775 9 5ZM8.66333 7.92639C8.58179 7.94482 8.49902 7.95984 8.41528 7.97144C8.27954 7.99023 8.14087 8 8 8C7.77197 8 7.55005 7.97461 7.33667 7.92639L6.18408 9.94336C6.46704 10.2439 6.68896 10.6027 6.82935 11H9.17065C9.31104 10.6027 9.53296 10.2439 9.81592 9.94336L8.66333 7.92639ZM12 13C12.5522 13 13 12.5522 13 12C13 11.4478 12.5522 11 12 11C11.4478 11 11 11.4478 11 12C11 12.5522 11.4478 13 12 13ZM5 12C5 12.5522 4.55225 13 4 13C3.44775 13 3 12.5522 3 12C3 11.4478 3.44775 11 4 11C4.55225 11 5 11.4478 5 12Z",
    fill: color
  }), type === Types$m.BLOCKER && React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.134 4.13403 1 8 1C11.866 1 15 4.134 15 8ZM13 8C13 10.7614 10.7615 13 8 13C6.98096 13 6.0332 12.6951 5.24268 12.1716L12.1716 5.24255C12.6951 6.03299 13 6.9809 13 8ZM10.7573 3.82841C9.9668 3.30489 9.01904 3 8 3C5.23853 3 3 5.23857 3 8C3 9.0191 3.30493 9.96701 3.82837 10.7574L10.7573 3.82841Z",
    fill: Impediment
  }), type === Types$m.DUPLICATE && React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 1C5.89453 1 5 1.89539 5 3V5H3C1.89453 5 1 5.89539 1 7V13C1 14.1046 1.89453 15 3 15H9C10.1055 15 11 14.1046 11 13V11H13C14.1055 11 15 10.1046 15 9V3C15 1.89539 14.1055 1 13 1H7ZM11 9H13V3H7V5H9C10.1055 5 11 5.89539 11 7V9ZM7 7H9V9H7V7ZM5 7V9C5 10.1046 5.89453 11 7 11H9V13H3V7H5Z",
    fill: color
  }), type === Types$m.LINK && React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.29297 1.29288C1.68335 0.902374 2.31665 0.902374 2.70703 1.29288L5.24268 3.8284C6.0332 3.30484 6.98096 3.00003 8 3.00003C9.01904 3.00003 9.9668 3.30484 10.7573 3.8284L13.293 1.29288C13.6833 0.902374 14.3167 0.902374 14.707 1.29288C15.0977 1.6835 15.0977 2.31656 14.707 2.70718L12.1716 5.24271C12.6951 6.03311 13 6.98099 13 8.00003C13 9.01907 12.6951 9.96695 12.1716 10.7574L14.707 13.2929C15.0977 13.6835 15.0977 14.3166 14.707 14.7072C14.3167 15.0977 13.6833 15.0977 13.293 14.7072L10.7573 12.1717C9.9668 12.6952 9.01904 13 8 13C6.98096 13 6.0332 12.6952 5.24268 12.1717L2.70703 14.7072C2.31665 15.0977 1.68335 15.0977 1.29297 14.7072C0.902344 14.3166 0.902344 13.6835 1.29297 13.2929L3.82837 10.7574C3.30493 9.96695 3 9.01907 3 8.00003C3 6.98099 3.30493 6.03311 3.82837 5.24271L1.29297 2.70718C0.902344 2.31656 0.902344 1.6835 1.29297 1.29288ZM11 8.00003C11 9.65689 9.65674 11 8 11C6.34326 11 5 9.65689 5 8.00003C5 6.34317 6.34326 5.00003 8 5.00003C9.65674 5.00003 11 6.34317 11 8.00003Z",
    fill: color
  }));
};
RelationIcon.category = 'Entity';
RelationIcon.Types = Types$m;

var _SizeOptions$1;
var Sizes$d = {
  DEFAULT: 'default',
  BIG: 'big'
};
var SizeOptions$1 = (_SizeOptions$1 = {}, _defineProperty(_SizeOptions$1, Sizes$d.DEFAULT, {
  width: 26,
  height: 16
}), _defineProperty(_SizeOptions$1, Sizes$d.BIG, {
  width: 48,
  height: 16
}), _SizeOptions$1);
var RelationsIcon = function RelationsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$d.DEFAULT : _ref$size;
  var _ref2 = SizeOptions$1.hasOwnProperty(size) ?
    // hasOwnProperty explicitly called here
    // eslint-disable-next-line security/detect-object-injection
    SizeOptions$1[size] : SizeOptions$1[Sizes$d.DEFAULT],
    width = _ref2.width,
    height = _ref2.height;
  return React.createElement("svg", {
    style: {
      display: 'block',
      transition: 'transform 0.3s'
    },
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, size === Sizes$d.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M13 12C15.2091 12 17 10.2091 17 8C17 5.79086 15.2091 4 13 4C10.7909 4 9 5.79086 9 8C9 10.2091 10.7909 12 13 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M3.29291 5.29289C3.68341 4.90237 4.31659 4.90237 4.70709 5.29289L6.70709 7.29289C7.09763 7.68341 7.09763 8.31659 6.70709 8.70711L4.70709 10.7071C4.31659 11.0976 3.68341 11.0976 3.29291 10.7071C2.90237 10.3166 2.90237 9.68341 3.29291 9.29289L3.58578 9H1C0.447723 9 0 8.55229 0 8C0 7.44771 0.447723 7 1 7H3.58578L3.29291 6.70711C2.90237 6.31659 2.90237 5.68341 3.29291 5.29289Z",
    fill: color
  }), React.createElement("path", {
    d: "M22.2929 5.29289C22.6834 4.90237 23.3166 4.90237 23.7071 5.29289L25.7071 7.29289C26.0976 7.68341 26.0976 8.31659 25.7071 8.70711L23.7071 10.7071C23.3166 11.0976 22.6834 11.0976 22.2929 10.7071C21.9024 10.3166 21.9024 9.68341 22.2929 9.29289L22.5858 9H20C19.4477 9 19 8.55229 19 8C19 7.44771 19.4477 7 20 7H22.5858L22.2929 6.70711C21.9024 6.31659 21.9024 5.68341 22.2929 5.29289Z",
    fill: color
  })), size === Sizes$d.BIG && React.createElement("g", null, React.createElement("path", {
    d: "M24 14C27.3137 14 30 11.3137 30 8C30 4.68629 27.3137 2 24 2C20.6863 2 18 4.68629 18 8C18 11.3137 20.6863 14 24 14Z",
    fill: color
  }), React.createElement("path", {
    d: "M9.29291 4.29289C9.68341 3.90237 10.3166 3.90237 10.7071 4.29289L13.7071 7.29289C14.0976 7.68341 14.0976 8.31659 13.7071 8.70711L10.7071 11.7071C10.3166 12.0976 9.68341 12.0976 9.29291 11.7071C8.90237 11.3166 8.90237 10.6834 9.29291 10.2929L10.5858 9H1C0.447723 9 0 8.55229 0 8C0 7.44771 0.447723 7 1 7H10.5858L9.29291 5.70711C8.90237 5.31659 8.90237 4.68341 9.29291 4.29289Z",
    fill: color
  }), React.createElement("path", {
    d: "M43.2929 4.29289C43.6834 3.90237 44.3166 3.90237 44.7071 4.29289L47.7071 7.29289C48.0976 7.68341 48.0976 8.31659 47.7071 8.70711L44.7071 11.7071C44.3166 12.0976 43.6834 12.0976 43.2929 11.7071C42.9024 11.3166 42.9024 10.6834 43.2929 10.2929L44.5858 9H35C34.4477 9 34 8.55229 34 8C34 7.44771 34.4477 7 35 7H44.5858L43.2929 5.70711C42.9024 5.31659 42.9024 4.68341 43.2929 4.29289Z",
    fill: color
  })));
};
RelationsIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ReloadIcon = function ReloadIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.0001 4.53592C7.91319 3.43135 10.3595 4.08686 11.4642 6.00002H10.0001C9.44785 6.00002 9.0001 6.44773 9.0001 7.00002C9.0001 7.55231 9.44785 8.00002 10.0001 8.00002H14.0001C14.5523 8.00002 15.0001 7.55231 15.0001 7.00002V3.00002C15.0001 2.44773 14.5523 2.00002 14.0001 2.00002C13.4479 2.00002 13.0001 2.44773 13.0001 3.00002V4.68319C11.2635 2.05982 7.76133 1.20955 5.0001 2.80387C2.13023 4.46073 1.14707 8.13027 2.80381 11C4.46079 13.8698 8.13023 14.853 11.0001 13.1962C11.4784 12.92 11.6422 12.3084 11.3661 11.8301C11.0899 11.3519 10.4784 11.188 10.0001 11.4641C8.08677 12.5687 5.64048 11.9132 4.53599 10C3.4315 8.08686 4.08677 5.64049 6.0001 4.53592Z",
    fill: color
  }));
};
ReloadIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var RemoveIcon = function RemoveIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13403 11.866 1 8 1C4.13403 1 1 4.13403 1 8C1 11.866 4.13403 15 8 15ZM6.58569 5.17157C6.19531 4.78107 5.56201 4.78107 5.17163 5.17157C4.78101 5.56207 4.78101 6.19531 5.17163 6.58582L6.58594 8L5.17163 9.41418C4.78125 9.80469 4.78125 10.4379 5.17163 10.8284C5.56226 11.2189 6.19531 11.2189 6.58594 10.8284L8 9.41425L9.41431 10.8284C9.80469 11.2189 10.438 11.2189 10.8284 10.8284C11.219 10.4379 11.219 9.80475 10.8284 9.41425L9.41431 8.00012L10.8286 6.58575C11.219 6.19525 11.219 5.56207 10.8286 5.17157C10.438 4.78107 9.80493 4.78107 9.41431 5.17157L8 6.58588L6.58569 5.17157Z",
    fill: color
  }));
};
RemoveIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ReplyIcon = function ReplyIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5.20703 5.20718C5.59766 4.81656 5.59766 4.1835 5.20703 3.79288C4.81665 3.40237 4.18335 3.40237 3.79297 3.79288L1.29297 6.29288C0.902344 6.6835 0.902344 7.31656 1.29297 7.70718L3.79297 10.2072C4.18335 10.5977 4.81665 10.5977 5.20703 10.2072C5.59766 9.81656 5.59766 9.1835 5.20703 8.79288L4.41431 8.00003H10C11.6567 8.00003 13 9.34317 13 11C13 11.5523 13.4478 12 14 12C14.5522 12 15 11.5523 15 11C15 8.23856 12.7615 6.00003 10 6.00003H4.41431L5.20703 5.20718Z",
    fill: color
  }));
};
ReplyIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var RequestIcon = function RequestIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 1C1.89543 1 1 1.89543 1 3V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V3C15 1.89543 14.1046 1 13 1H3ZM6 4H8.4C10.0326 4 11 5.56291 11 7C11 7.8628 10.6513 8.77095 10.0193 9.359L10.8001 10.4C11.1314 10.8419 11.0419 11.4687 10.6001 11.8C10.1582 12.1314 9.53145 12.0419 9.20008 11.6L8.00006 10H7V11C7 11.5523 6.55228 12 6 12C5.44772 12 5 11.5523 5 11V9V5C5 4.44772 5.44772 4 6 4ZM7 6V8H8.4C8.48363 8 8.61392 7.96025 8.7505 7.78952C8.88856 7.61695 9 7.34113 9 7C9 6.65887 8.88856 6.38305 8.7505 6.21048C8.61392 6.03975 8.48363 6 8.4 6H7Z",
    fill: color
  }));
};
RequestIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ReturnIcon = function ReturnIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M6.80005 2C6.2478 2 5.80005 2.44769 5.80005 3C5.80005 3.55231 6.2478 4 6.80005 4H12C12.5522 4 13 4.44769 13 5V9C13 9.55231 12.5522 10 12 10H4.48779L5.53564 8.95215C5.92603 8.56165 5.92603 7.92847 5.53564 7.53796C5.14502 7.1474 4.51196 7.1474 4.12134 7.53796L1.55518 10.1041C1.22607 10.2678 1 10.6075 1 11C1 11.0123 1.00024 11.0246 1.00073 11.0369C0.990967 11.3049 1.08838 11.576 1.29297 11.7806L4.12134 14.609C4.51196 14.9995 5.14502 14.9995 5.53564 14.609C5.92603 14.2185 5.92603 13.5853 5.53564 13.1948L4.34082 12H12C13.657 12 15 10.6569 15 9V5C15 3.34314 13.657 2 12 2H6.80005Z",
    fill: color
  }));
};
ReturnIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var RevertIcon = function RevertIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5.20703 4.20718C5.59766 3.81656 5.59766 3.1835 5.20703 2.79288C4.81665 2.40237 4.18335 2.40237 3.79297 2.79288L1.29297 5.29288C0.902344 5.6835 0.902344 6.31656 1.29297 6.70718L3.79297 9.20718C4.18335 9.59769 4.81665 9.59769 5.20703 9.20718C5.59766 8.81656 5.59766 8.1835 5.20703 7.79288L4.41431 7.00003H10C11.6567 7.00003 13 8.34317 13 10C13 11.6569 11.6567 13 10 13C9.44775 13 9 13.4478 9 14C9 14.5523 9.44775 15 10 15C12.7615 15 15 12.7615 15 10C15 7.23856 12.7615 5.00003 10 5.00003H4.41431L5.20703 4.20718Z",
    fill: color
  }));
};
RevertIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$n = {
  DEFAULT: 'default',
  ADDITIONAL: 'additional'
};
var SearchIcon = function SearchIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$n.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$n.DEFAULT && React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 7C1 10.3137 3.68628 13 6.99999 13C8.29583 13 9.49572 12.5892 10.4766 11.8907L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L11.8907 10.4765C12.5892 9.49573 13 8.29584 13 7C13 3.68629 10.3137 1 6.99999 1C3.68628 1 1 3.68629 1 7ZM3 7C3 9.20914 4.79083 11 6.99999 11C9.20916 11 11 9.20914 11 7C11 4.79086 9.20916 3 6.99999 3C4.79083 3 3 4.79086 3 7Z",
    fill: color
  }), type === Types$n.ADDITIONAL && React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 7C15 10.3137 12.3137 13 9.00002 13C7.70418 13 6.50429 12.5892 5.52345 11.8907L2.70711 14.7071C2.3166 15.0976 1.68343 15.0976 1.29292 14.7071C0.902359 14.3166 0.902359 13.6834 1.29292 13.2929L4.10927 10.4765C3.41078 9.49573 3.00002 8.29584 3.00002 7C3.00002 3.68629 5.68629 1 9.00002 1C12.3137 1 15 3.68629 15 7ZM13 7C13 9.20914 11.2092 11 9.00002 11C6.79085 11 5.00002 9.20914 5.00002 7C5.00002 4.79086 6.79085 3 9.00002 3C11.2092 3 13 4.79086 13 7Z",
    fill: color
  }));
};
SearchIcon.category = 'Common Actions';
SearchIcon.Types = Types$n;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var SelectIcon = function SelectIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.6823 3.26895C15.0861 3.64578 15.1079 4.27857 14.7311 4.68232L6.33105 13.6823C6.14192 13.885 5.87718 14 5.6 14C5.32281 14 5.05807 13.885 4.86894 13.6823L1.26894 9.82518C0.892106 9.42143 0.913927 8.78864 1.31768 8.41181C1.72143 8.03497 2.35422 8.05679 2.73105 8.46054L5.6 11.5344L13.2689 3.31769C13.6458 2.91393 14.2786 2.89211 14.6823 3.26895Z",
    fill: color
  }));
};
SelectIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var SettingsIcon = function SettingsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 2C9 1.44772 8.55228 1 8 1C7.44772 1 7 1.44772 7 2V3.10002C6.3616 3.22961 5.7674 3.48082 5.24258 3.82841L4.46442 3.05025C4.07391 2.65972 3.44073 2.65972 3.05023 3.05025C2.6597 3.44077 2.6597 4.07394 3.05023 4.46446L3.8284 5.24262C3.4808 5.76743 3.22958 6.36163 3.10001 7H2C1.44772 7 1 7.44772 1 8C1 8.55228 1.44772 9 2 9H3.10001C3.22958 9.63837 3.48077 10.2326 3.82837 10.7574L3.05023 11.5355C2.65973 11.926 2.65973 12.5592 3.05023 12.9497C3.44077 13.3402 4.07394 13.3402 4.46445 12.9497L5.24258 12.1716C5.7674 12.5192 6.3616 12.7704 7 12.9V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V12.9C9.63837 12.7704 10.2325 12.5192 10.7574 12.1716L11.5355 12.9497C11.926 13.3403 12.5592 13.3403 12.9497 12.9497C13.3402 12.5592 13.3402 11.926 12.9497 11.5355L12.1716 10.7574C12.5192 10.2326 12.7704 9.63838 12.9 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H12.9C12.7704 6.36162 12.5192 5.7674 12.1716 5.24259L12.9497 4.46444C13.3403 4.07391 13.3403 3.44075 12.9497 3.05022C12.5592 2.65971 11.9261 2.65971 11.5355 3.05022L10.7574 3.82838C10.2325 3.4808 9.63837 3.22961 9 3.10002V2ZM8 10C9.10458 10 10 9.10457 10 8C10 6.89543 9.10458 6 8 6C6.89542 6 6 6.89543 6 8C6 9.10457 6.89542 10 8 10Z",
    fill: color
  }));
};
SettingsIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$o = {
  DEFAULT: 'default',
  OFF: 'off'
};
var ShareIcon = function ShareIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$o.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$o.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M8.70711 1.29289C8.31658 0.902369 7.68342 0.902369 7.29289 1.29289L5.29289 3.29289C4.90237 3.68342 4.90237 4.31658 5.29289 4.70711C5.68342 5.09763 6.31658 5.09763 6.70711 4.70711L7 4.41421V9.5C7 10.0523 7.44772 10.5 8 10.5C8.55228 10.5 9 10.0523 9 9.5V4.41421L9.29289 4.70711C9.68342 5.09763 10.3166 5.09763 10.7071 4.70711C11.0976 4.31658 11.0976 3.68342 10.7071 3.29289L8.70711 1.29289Z",
    fill: color
  }), React.createElement("path", {
    d: "M13 8H12C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6H13C14.1046 6 15 6.89543 15 8V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V8C1 6.89543 1.89543 6 3 6H4C4.55228 6 5 6.44772 5 7C5 7.55228 4.55228 8 4 8H3L3 13H13V8Z",
    fill: color
  })), type === Types$o.OFF && React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.003 15C13.6611 14.999 14.2447 14.6802 14.6085 14.1888C14.5956 14.1772 14.583 14.1652 14.5706 14.1528L13 12.5837V12.5858L2.70711 2.29289C2.31658 1.90237 1.68342 1.90237 1.29289 2.29289C0.902369 2.68342 0.902369 3.31658 1.29289 3.70711L3.58579 6H3C1.89543 6 1 6.89543 1 8V13C1 14.1046 1.89543 15 3 15H12.9993C13.0003 15 13.002 15 13.003 15ZM4.9367 7.35091C4.79458 7.7301 4.42881 8 4 8H3L3 13H10.5858L4.9367 7.35091Z",
    fill: color
  }), React.createElement("path", {
    d: "M13 9.7566L15 11.7547V8C15 6.89543 14.1046 6 13 6H12C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8H13V9.7566Z",
    fill: color
  }), React.createElement("path", {
    d: "M5.91121 2.67458L9 5.76042V4.41421L9.29289 4.70711C9.68342 5.09763 10.3166 5.09763 10.7071 4.70711C11.0976 4.31658 11.0976 3.68342 10.7071 3.29289L8.70711 1.29289C8.31658 0.902369 7.68342 0.902369 7.29289 1.29289L5.91121 2.67458Z",
    fill: color
  })));
};
ShareIcon.category = 'Common Actions';
ShareIcon.Types = Types$o;

var _Rotations$4;
var Directions$4 = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var Rotations$4 = (_Rotations$4 = {}, _defineProperty(_Rotations$4, Directions$4.HORIZONTAL, 0), _defineProperty(_Rotations$4, Directions$4.VERTICAL, 90), _Rotations$4);
var ShowMoreIcon = function ShowMoreIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? Directions$4.HORIZONTAL : _ref$direction;
  var rotationDegrees = Rotations$4.hasOwnProperty(direction) ?
  // hasOwnProperty explicitly checked here
  // eslint-disable-next-line security/detect-object-injection
  Rotations$4[direction] : Rotations$4[Directions$4.HORIZONTAL];
  return React.createElement("svg", {
    style: {
      transform: "rotate(".concat(rotationDegrees, "deg)"),
      display: 'block',
      transition: 'transform 0.3s'
    },
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, React.createElement("path", {
    d: "M5 8.5C5 9.32843 4.32837 10 3.5 10C2.67163 10 2 9.32843 2 8.5C2 7.67157 2.67163 7 3.5 7C4.32837 7 5 7.67157 5 8.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M10 8.5C10 9.32843 9.32837 10 8.5 10C7.67163 10 7 9.32843 7 8.5C7 7.67157 7.67163 7 8.5 7C9.32837 7 10 7.67157 10 8.5Z",
    fill: color
  }), React.createElement("path", {
    d: "M13.5 10C14.3284 10 15 9.32843 15 8.5C15 7.67157 14.3284 7 13.5 7C12.6716 7 12 7.67157 12 8.5C12 9.32843 12.6716 10 13.5 10Z",
    fill: color
  }));
};
ShowMoreIcon.category = 'Navigation';
ShowMoreIcon.Directions = Directions$4;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var SolutionsIcon = function SolutionsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.78784 1.33767C8.28474 1.12206 7.71526 1.12206 7.21216 1.33767L2.36369 3.41559L8.00012 5.83121L13.6364 3.41564L8.78784 1.33767ZM14.9772 5.01698L9 7.57862V14.5715L13.7878 12.5195C14.5232 12.2044 15 11.4813 15 10.6812V5.31882C15 5.21673 14.9922 5.11588 14.9772 5.01698ZM7 14.5715V7.57852L1.02285 5.01688C1.00777 5.11582 1 5.21669 1 5.31882V10.6812C1 11.4813 1.47679 12.2044 2.21216 12.5195L7 14.5715Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.78784 1.33761C8.28474 1.122 7.71526 1.122 7.21216 1.33761L2.36369 3.41553L8.00012 5.83115L13.6364 3.41558L8.78784 1.33761ZM14.9772 5.01692L9 7.57856V14.5714L13.7878 12.5195C14.5232 12.2043 15 11.4812 15 10.6812V5.31876C15 5.21666 14.9922 5.11582 14.9772 5.01692ZM7 14.5714V7.57846L1.02285 5.01682C1.00777 5.11576 1 5.21663 1 5.31876V10.6812C1 11.4812 1.47679 12.2043 2.21216 12.5195L7 14.5714Z",
    fill: color
  }));
};
SolutionsIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Directions$5 = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending'
};
var SortIcon = function SortIcon(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? Directions$5.ASCENDING : _ref$direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, direction === Directions$5.DESCENDING && React.createElement("g", null, React.createElement("path", {
    d: "M8.70711 11.7071L5.70711 14.7071C5.31658 15.0976 4.68342 15.0976 4.29289 14.7071L1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929C1.68342 9.90237 2.31658 9.90237 2.70711 10.2929L4 11.5858V2C4 1.44771 4.44772 1 5 1C5.55228 1 6 1.44771 6 2V11.5858L7.29289 10.2929C7.68342 9.90237 8.31658 9.90237 8.70711 10.2929C9.09763 10.6834 9.09763 11.3166 8.70711 11.7071Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H11Z",
    fill: color
  }), React.createElement("path", {
    d: "M10 12C10 11.4477 10.4477 11 11 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H11C10.4477 13 10 12.5523 10 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M13 3C12.4477 3 12 3.44772 12 4C12 4.55228 12.4477 5 13 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H13Z",
    fill: color
  })), direction === Directions$5.ASCENDING && React.createElement("g", null, React.createElement("path", {
    d: "M5.70711 1.29289C5.31658 0.902369 4.68342 0.902369 4.29289 1.29289L1.29289 4.29289C0.902369 4.68342 0.902369 5.31658 1.29289 5.70711C1.68342 6.09763 2.31658 6.09763 2.70711 5.70711L4 4.41421V14C4 14.5523 4.44772 15 5 15C5.55228 15 6 14.5523 6 14V4.41421L7.29289 5.70711C7.68342 6.09763 8.31658 6.09763 8.70711 5.70711C9.09763 5.31658 9.09763 4.68342 8.70711 4.29289L5.70711 1.29289Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 7C10.4477 7 10 7.44772 10 8C10 8.55228 10.4477 9 11 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H11Z",
    fill: color
  }), React.createElement("path", {
    d: "M12 12C12 11.4477 12.4477 11 13 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H13C12.4477 13 12 12.5523 12 12Z",
    fill: color
  }), React.createElement("path", {
    d: "M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H14C14.5523 5 15 4.55228 15 4C15 3.44772 14.5523 3 14 3H11Z",
    fill: color
  })));
};
SortIcon.category = 'Common Actions';
SortIcon.Directions = Directions$5;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var StopIcon = function StopIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.134 11.866 1 8 1C4.13403 1 1 4.134 1 8C1 11.866 4.13403 15 8 15ZM5 7C4.44775 7 4 7.44772 4 8C4 8.55228 4.44775 9 5 9H11C11.5522 9 12 8.55228 12 8C12 7.44772 11.5522 7 11 7H5Z",
    fill: color
  }));
};
StopIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Directions$6 = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};
var SwapIcon = function SwapIcon(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? Directions$6.VERTICAL : _ref$direction,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, direction === Directions$6.VERTICAL && React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0828 1.00007C8.34804 1.00321 8.60117 1.1116 8.78649 1.30141L11.7155 4.30141C12.1013 4.69658 12.0938 5.3297 11.6986 5.71552C11.3034 6.10134 10.6703 6.09376 10.2845 5.69859L9.07096 4.45567L9.07094 11.5321L10.2879 10.2979C10.6757 9.90462 11.3089 9.90017 11.7021 10.2879C12.0954 10.6757 12.0998 11.3089 11.7121 11.7021L8.78299 14.6727C8.39785 15.0633 7.76995 15.0707 7.37568 14.6893L4.30474 11.7188C3.90778 11.3348 3.89726 10.7017 4.28124 10.3047C4.66522 9.90778 5.2983 9.89726 5.69526 10.2812L7.07094 11.6119L7.07096 4.37487L5.69879 5.71532C5.30373 6.10126 4.67061 6.09386 4.28468 5.69879C3.89874 5.30373 3.90615 4.67061 4.30121 4.28468L7.37217 1.28468C7.56192 1.09931 7.81755 0.996932 8.0828 1.00007Z",
    fill: color
  }), direction === Directions$6.HORIZONTAL && React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01472 7.90243C1.01786 7.63719 1.12625 7.38406 1.31606 7.19874L4.31605 4.26971C4.71123 3.88389 5.34435 3.89146 5.73017 4.28664C6.11599 4.68181 6.10841 5.31492 5.71324 5.70075L4.47032 6.91427L11.5468 6.91429L10.3125 5.69729C9.91927 5.30952 9.91482 4.67637 10.3026 4.28311C10.6904 3.88985 11.3235 3.8854 11.7168 4.27317L14.6873 7.20223C15.0779 7.58738 15.0853 8.21528 14.7039 8.60955L11.7334 11.6805C11.3494 12.0774 10.7163 12.088 10.3194 11.704C9.92243 11.32 9.91191 10.6869 10.2959 10.29L11.6266 8.91429L4.38951 8.91427L5.72997 10.2864C6.1159 10.6815 6.1085 11.3146 5.71344 11.7006C5.31838 12.0865 4.68526 12.0791 4.29932 11.684L1.29932 8.61306C1.11396 8.4233 1.01158 8.16768 1.01472 7.90243Z",
    fill: color
  }));
};
SwapIcon.category = 'Common Actions';
SwapIcon.Directions = Directions$6;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TagIcon = function TagIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.18633 5.87749C1.14793 6.45298 1.35979 7.01701 1.7676 7.42482L8.90405 14.5613C9.48984 15.1471 10.4396 15.147 11.0254 14.5613L14.5609 11.0257C15.1466 10.44 15.1467 9.4902 14.5609 8.90441L7.42445 1.76796C7.01665 1.36016 6.45261 1.14829 5.87713 1.18669L2.78905 1.39246C2.03915 1.44255 1.44218 2.03951 1.3921 2.78941L1.18633 5.87749ZM5.72207 5.72243C6.11257 5.33194 6.1126 4.69875 5.72207 4.30822C5.33154 3.91769 4.69835 3.91772 4.30785 4.30822C3.91736 4.69872 3.91733 5.33191 4.30785 5.72243C4.69838 6.11296 5.33157 6.11293 5.72207 5.72243Z",
    fill: color
  }));
};
TagIcon.category = 'Tags';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TagsCloudIcon = function TagsCloudIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M5 1C4.44775 1 4 1.44769 4 2C4 2.55231 4.44775 3 5 3H11C11.5522 3 12 2.55231 12 2C12 1.44769 11.5522 1 11 1H5Z",
    fill: color
  }), React.createElement("path", {
    d: "M5 13C4.44775 13 4 13.4477 4 14C4 14.5523 4.44775 15 5 15H11C11.5522 15 12 14.5523 12 14C12 13.4477 11.5522 13 11 13H5Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 6C1 5.44769 1.44775 5 2 5H8C8.55225 5 9 5.44769 9 6C9 6.55231 8.55225 7 8 7H2C1.44775 7 1 6.55231 1 6Z",
    fill: color
  }), React.createElement("path", {
    d: "M12 5C11.4478 5 11 5.44769 11 6C11 6.55231 11.4478 7 12 7H14C14.5522 7 15 6.55231 15 6C15 5.44769 14.5522 5 14 5H12Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 10C1 9.44769 1.44775 9 2 9H4C4.55225 9 5 9.44769 5 10C5 10.5523 4.55225 11 4 11H2C1.44775 11 1 10.5523 1 10Z",
    fill: color
  }), React.createElement("path", {
    d: "M8 9C7.44775 9 7 9.44769 7 10C7 10.5523 7.44775 11 8 11H14C14.5522 11 15 10.5523 15 10C15 9.44769 14.5522 9 14 9H8Z",
    fill: color
  }));
};
TagsCloudIcon.category = 'Tags';

var _sizeToParams$1;
var Sizes$e = {
  DEFAULT: 'default',
  BIG: 'big'
};
var Types$p = {
  DEFAULT: 'default',
  CROSSOUT: 'crossout'
};
var sizeToParams$1 = (_sizeToParams$1 = {}, _defineProperty(_sizeToParams$1, Sizes$e.DEFAULT, {
  numericSize: 16
}), _defineProperty(_sizeToParams$1, Sizes$e.BIG, {
  numericSize: 48
}), _sizeToParams$1);
var TeamIcon = function TeamIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$e.DEFAULT : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$p.DEFAULT : _ref$type,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  var _ref2 = sizeToParams$1.hasOwnProperty(size) ?
    // hasOwnProperty explicitly checked here
    // eslint-disable-next-line security/detect-object-injection
    sizeToParams$1[size] : sizeToParams$1[Sizes$e.DEFAULT],
    numericSize = _ref2.numericSize;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    style: {
      display: 'block'
    }
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    style: size === Sizes$e.BIG ? {
      transform: 'scale(3)',
      transformOrigin: '0 0'
    } : {}
  }, type === Types$p.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M4.5 1C3.25 1 2 1.75617 2 4.02469C2 6.10417 3.11921 8 4.5 8C5.88079 8 7 6.10417 7 4.02469C7 1.94522 5.75 1 4.5 1Z",
    fill: color
  }), React.createElement("path", {
    d: "M9 7.02469C9 4.75617 10.25 4 11.5 4C12.75 4 14 4.94522 14 7.02469C14 9.10417 12.8808 11 11.5 11C10.1192 11 9 9.10417 9 7.02469Z",
    fill: color
  }), React.createElement("path", {
    d: "M14.8357 13.3227C14.0167 14.3521 12.8256 15 11.5 15C10.1744 15 8.98335 14.3521 8.16435 13.3227C7.86199 12.9427 7.999 12.3677 8.39433 12.1177C8.71711 11.9135 9.11939 11.9939 9.43366 12.2143C10.0136 12.6209 10.7862 12.8465 11.5 12.8465C12.2138 12.8465 12.9864 12.6209 13.5663 12.2143C13.8806 11.9939 14.2829 11.9135 14.6057 12.1177C15.001 12.3677 15.138 12.9427 14.8357 13.3227Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.83565 10.3227C7.01665 11.3521 5.82564 12 4.5 12C3.17436 12 1.98335 11.3521 1.16435 10.3227C0.861991 9.94267 0.999 9.36775 1.39433 9.11766C1.71711 8.91347 2.11939 8.99393 2.43366 9.21425C3.01365 9.62086 3.78623 9.84652 4.5 9.84652C5.21377 9.84652 5.98635 9.62086 6.56634 9.21425C6.88061 8.99393 7.28289 8.91347 7.60567 9.11766C8.001 9.36775 8.13801 9.94267 7.83565 10.3227Z",
    fill: color
  })), type === Types$p.CROSSOUT && React.createElement("g", null, React.createElement("path", {
    d: "M6.94678 4.81085L3.88554 7.87209C2.8019 7.41343 2.00003 5.78485 2.00003 4.02469C2.00003 1.75617 3.25003 1 4.50003 1C5.75003 1 7.00003 1.94522 7.00003 4.02469C7.00003 4.29095 6.98168 4.5542 6.94678 4.81085Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.49893 9.2587L1.28695 10.4707C1.24522 10.4223 1.20436 10.3729 1.16438 10.3227C0.862021 9.94267 0.999029 9.36775 1.39436 9.11766C1.71714 8.91347 2.11942 8.99393 2.43369 9.21425C2.45517 9.22932 2.47693 9.24413 2.49893 9.2587Z",
    fill: color
  }), React.createElement("path", {
    d: "M1.279 13.3071C5.28368 9.30238 9.28822 5.29757 13.2929 1.29289C13.6834 0.902369 14.3166 0.902369 14.7071 1.29289C15.0976 1.68342 15.0976 2.31658 14.7071 2.70711L12.9362 4.47802C13.5577 4.95208 14 5.7877 14 7.02469C14 9.10417 12.8808 11 11.5 11C10.4052 11 9.47481 9.80809 9.13641 8.2778L7.92397 9.49024C8.04272 9.75679 8.02908 10.0796 7.83568 10.3227C7.24114 11.0699 6.45055 11.6162 5.55473 11.8595L2.70711 14.7071C2.31658 15.0976 1.68342 15.0976 1.29289 14.7071C0.907056 14.3213 0.902425 13.6986 1.279 13.3071Z",
    fill: color
  }), React.createElement("path", {
    d: "M14.8357 13.3227C14.0167 14.3521 12.8257 15 11.5 15C10.1744 15 8.98338 14.3521 8.16438 13.3227C7.86202 12.9427 7.99903 12.3677 8.39436 12.1177C8.71714 11.9135 9.11942 11.9939 9.43369 12.2143C10.0137 12.6209 10.7863 12.8465 11.5 12.8465C12.2138 12.8465 12.9864 12.6209 13.5664 12.2143C13.8806 11.9939 14.2829 11.9135 14.6057 12.1177C15.001 12.3677 15.138 12.9427 14.8357 13.3227Z",
    fill: color
  }))));
};
TeamIcon.category = 'Entity';
TeamIcon.Sizes = Sizes$e;
TeamIcon.Types = Types$p;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Sizes$f = {
  DEFAULT: 'default',
  BIG: 'big'
};
var TestRailIcon = function TestRailIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? Sizes$f.DEFAULT : _ref$size;
  var numericSize = size === Sizes$f.BIG ? 24 : 16;
  return React.createElement("svg", {
    width: "".concat(numericSize, "px"),
    height: "".concat(numericSize, "px"),
    viewBox: "0 0 ".concat(numericSize, " ").concat(numericSize),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    style: size === Sizes$f.BIG ? {} : {
      transform: 'scale(0.725)',
      transformOrigin: '0 0'
    }
  }, React.createElement("rect", {
    x: "2",
    y: "2",
    width: "5",
    height: "5",
    fill: "#74BB53"
  }), React.createElement("rect", {
    x: "2",
    y: "9",
    width: "5",
    height: "5",
    fill: "#74BB53"
  }), React.createElement("rect", {
    x: "9",
    y: "9",
    width: "5",
    height: "5",
    fill: "#F4EC65"
  }), React.createElement("rect", {
    x: "2",
    y: "16",
    width: "5",
    height: "5",
    fill: "#74BB53"
  }), React.createElement("rect", {
    x: "9",
    y: "16",
    width: "5",
    height: "5",
    fill: "#74BB53"
  }), React.createElement("rect", {
    x: "16",
    y: "16",
    width: "5",
    height: "5",
    fill: "#CD455D"
  })));
};
TestRailIcon.category = 'Tool';
TestRailIcon.Sizes = Sizes$f;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var ThumbsUpIcon = function ThumbsUpIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M2.04575 7C1.49643 7 1.04996 7.44312 1.04575 7.99243L1.00003 13.9924C0.995758 14.5476 1.44473 15 1.99997 15H3.99234V7H2.04575Z",
    fill: color
  }), React.createElement("path", {
    d: "M6.94588 4.50818C6.32139 5.57872 5.99234 6.79588 5.99234 8.03525V15H12.1902C12.6588 15 13.0647 14.6746 13.1664 14.217L14.9762 7.21704C15.115 6.59253 14.6398 6 14 6H11.2093C10.5791 6 10.106 5.42432 10.2282 4.80615L10.7443 2.19385C10.8664 1.57568 10.3933 1 9.76328 1H9.56668C9.21103 1 8.88217 1.18896 8.70291 1.49609L6.94588 4.50818Z",
    fill: color
  }));
};
ThumbsUpIcon.category = 'Entity';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TimeIcon = function TimeIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13403 15 1 11.866 1 8C1 4.13403 4.13403 1 8 1C11.866 1 15 4.13403 15 8ZM9 5C9 4.44775 8.55225 4 8 4C7.44775 4 7 4.44775 7 5V8C7 8.27612 7.11255 8.52673 7.29346 8.7077L9.53955 10.9499C9.93042 11.3401 10.5637 11.3395 10.9539 10.9487C11.344 10.5578 11.3435 9.92462 10.9526 9.53448L9 7.58527V5Z",
    fill: color
  }));
};
TimeIcon.category = 'Time';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TimelineIcon = function TimelineIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M7 4C7 3.44772 7.44772 3 8 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H8C7.44772 5 7 4.55228 7 4Z",
    fill: color
  }), React.createElement("path", {
    d: "M1 8C1 7.44772 1.44772 7 2 7H11C11.5523 7 12 7.44772 12 8C12 8.55228 11.5523 9 11 9H2C1.44772 9 1 8.55228 1 8Z",
    fill: color
  }), React.createElement("path", {
    d: "M6 12C6 11.4477 6.44772 11 7 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H7C6.44772 13 6 12.5523 6 12Z",
    fill: color
  }));
};
TimelineIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TopMenuHelpIcon = function TopMenuHelpIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 6.80952C7 5.30328 8.29661 4 10 4C11.7034 4 13 5.30328 13 6.80952C13 7.8238 12.4223 8.73503 11.5175 9.23353C9.6837 10.2438 9 11.6531 9 13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13C11 12.4421 11.2328 11.6738 12.4825 10.9853C13.9689 10.1664 15 8.61537 15 6.80952C15 4.10788 12.7149 2 10 2C7.28511 2 5 4.10788 5 6.80952C5 7.36181 5.44772 7.80952 6 7.80952C6.55228 7.80952 7 7.36181 7 6.80952ZM10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18Z",
    fill: color
  }));
};
TopMenuHelpIcon.category = 'Menu';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TopMenuReportsIcon = function TopMenuReportsIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.9335 3.359C19.1318 2.84353 18.8746 2.26494 18.3591 2.06668C17.8437 1.86842 17.2651 2.12557 17.0668 2.64105L14.033 10.529C13.4659 12.0035 11.4934 12.2693 10.5562 10.9974L9.53881 9.61669C7.82336 7.28857 4.28039 7.49409 2.84562 10.0049L1.13193 13.0039C0.857918 13.4834 1.02451 14.0943 1.50403 14.3683C1.98355 14.6423 2.5944 14.4757 2.86841 13.9962L4.5821 10.9972C5.29949 9.74179 7.07097 9.63903 7.9287 10.8031L8.94609 12.1838C10.8204 14.7276 14.7654 14.1961 15.8997 11.2469L18.9335 3.359ZM2 17C1.44772 17 1 17.4477 1 18C1 18.5523 1.44772 19 2 19H18C18.5523 19 19 18.5523 19 18C19 17.4477 18.5523 17 18 17H2Z",
    fill: color
  }));
};
TopMenuReportsIcon.category = 'Menu';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TPLogoIcon = function TPLogoIcon() {
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M14.8466 6.70455C14.5649 6.70455 14.3772 6.6143 14.0956 6.4338L8.55689 1.92121C8.08751 1.5602 7.99364 0.838191 8.46302 0.386932C8.83852 -0.0643266 9.58953 -0.154578 10.0589 0.29668L15.5976 4.80927C16.067 5.17027 16.1608 5.89229 15.6915 6.34355C15.5037 6.52405 15.1282 6.70455 14.8466 6.70455Z",
    fill: "#319A8A"
  }), React.createElement("path", {
    d: "M6.67844 16.0003C6.20906 16.0003 5.73969 15.7295 5.64582 15.2783C5.45806 14.7368 5.73969 14.105 6.30295 13.9245L13.2498 11.4877C13.813 11.3072 14.4701 11.5779 14.6579 12.1195C14.8456 12.661 14.564 13.2927 14.0008 13.4732L7.05396 15.91C6.88281 15.9727 6.77232 16.0003 6.67844 16.0003Z",
    fill: "#F1CE4A"
  }), React.createElement("path", {
    d: "M1.14078 11.5785C1.04691 11.5785 1.04691 11.5785 0.953034 11.5785C0.295903 11.4882 -0.0796009 10.9467 0.014275 10.315L1.23465 3.36558C1.32853 2.73382 1.89179 2.37281 2.54892 2.46306C3.20605 2.55332 3.58156 3.09483 3.48768 3.72659L2.26729 10.676C2.17342 11.2175 1.70404 11.5785 1.14078 11.5785Z",
    fill: "#AE304A"
  }), React.createElement("path", {
    d: "M7.05639 12.0292C6.77476 12.0292 6.58701 11.939 6.30538 11.7585L4.42786 10.2242C3.95848 9.86318 3.8646 9.14117 4.33398 8.68991C4.70949 8.23865 5.46049 8.1484 5.92987 8.59966L7.80739 10.1339C8.27677 10.4949 8.37065 11.217 7.90127 11.6682C7.71352 11.939 7.33802 12.0292 7.05639 12.0292Z",
    fill: "#3AB5A2"
  }), React.createElement("path", {
    d: "M10.8108 10.5857C10.717 10.5857 10.717 10.5857 10.6231 10.5857C9.96595 10.4955 9.59044 9.95396 9.68432 9.32219L10.0598 7.0659C10.1537 6.43414 10.717 6.07313 11.3741 6.16338C12.0312 6.25363 12.4067 6.79514 12.3128 7.42691L11.9373 9.6832C11.8435 10.2247 11.3741 10.5857 10.8108 10.5857Z",
    fill: "#A16915"
  }), React.createElement("path", {
    d: "M5.739 6.70461C5.26962 6.70461 4.80024 6.43385 4.70637 5.9826C4.51862 5.44109 4.80024 4.80932 5.3635 4.62882L7.61651 3.81655C8.17977 3.63605 8.8369 3.90681 9.02465 4.44832C9.2124 4.98983 8.93078 5.62159 8.36752 5.80209L6.11451 6.61436C5.92676 6.70461 5.83287 6.70461 5.739 6.70461Z",
    fill: "#ADB300"
  }));
};
TPLogoIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var TrashIcon = function TrashIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M7 1C6.44775 1 6 1.44775 6 2H3C2.44775 2 2 2.44775 2 3C2 3.55225 2.44775 4 3 4H13C13.5522 4 14 3.55225 14 3C14 2.44775 13.5522 2 13 2H10C10 1.44775 9.55225 1 9 1H7Z",
    fill: color
  }), React.createElement("path", {
    d: "M13 6H3L3.66528 13.1844C3.7605 14.2131 4.62354 15 5.65674 15H10.3433C11.3765 15 12.2395 14.2131 12.3347 13.1844L13 6Z",
    fill: color
  }));
};
TrashIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var UploadIcon = function UploadIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    d: "M9 10C9 10.5523 8.55225 11 8 11C7.44775 11 7 10.5523 7 10V4.41422L5.70715 5.70718C5.31653 6.09769 4.68347 6.09769 4.29285 5.70718C3.90234 5.31656 3.90234 4.6835 4.29285 4.29288L7.29285 1.29288C7.68347 0.902374 8.31653 0.902374 8.70715 1.29288L11.7072 4.29288C12.0977 4.6835 12.0977 5.31656 11.7072 5.70718C11.3165 6.09769 10.6835 6.09769 10.2928 5.70718L9 4.41422V10Z",
    fill: color
  }), React.createElement("path", {
    d: "M2 13C1.44775 13 1 13.4478 1 14C1 14.5522 1.44775 15 2 15H14C14.5522 15 15 14.5522 15 14C15 13.4478 14.5522 13 14 13H2Z",
    fill: color
  }));
};
UploadIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$q = {
  DEFAULT: 'default',
  CROSSOUT: 'crossout'
};
var UserIcon = function UserIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$q.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$q.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M7.9979 1C6.2479 1 4.4979 1.97222 4.4979 4.88889C4.4979 7.5625 6.0648 10 7.9979 10C9.93101 10 11.4979 7.5625 11.4979 4.88889C11.4979 2.21528 9.7479 1 7.9979 1Z",
    fill: color
  }), React.createElement("path", {
    d: "M7.9979 15C10.0727 15 11.9367 14.0974 13.2186 12.6633C13.6918 12.1339 13.4774 11.333 12.8586 10.9846C12.3534 10.7002 11.7238 10.8123 11.232 11.1192C10.3242 11.6856 9.11503 12 7.9979 12C6.88078 12 5.67159 11.6856 4.76385 11.1192C4.27199 10.8123 3.64237 10.7002 3.13718 10.9846C2.51845 11.333 2.30402 12.1339 2.77724 12.6633C4.05907 14.0974 5.92313 15 7.9979 15Z",
    fill: color
  })), type === Types$q.CROSSOUT && React.createElement("g", null, React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.0866 1.67105C9.47874 1.21755 8.73832 1 7.9979 1C6.2479 1 4.4979 1.97222 4.4979 4.88889C4.4979 5.60542 4.61045 6.305 4.81242 6.94524L10.0866 1.67105ZM1.27828 13.3078L12.879 1.70711C12.8839 1.70218 12.8888 1.69722 12.8936 1.69223L13.2929 1.29289C13.6834 0.902369 14.3166 0.902369 14.7071 1.29289C15.0976 1.68342 15.0976 2.31658 14.7071 2.70711L11.4065 6.00773C11.0453 8.20586 9.65639 10 7.9979 10C7.82 10 7.6452 9.97936 7.47443 9.93978L5.7996 11.6146C6.49847 11.8657 7.26784 12 7.9979 12C9.11503 12 10.3242 11.6856 11.232 11.1192C11.7238 10.8123 12.3534 10.7002 12.8586 10.9846C13.4774 11.333 13.6918 12.1339 13.2186 12.6633C11.9367 14.0974 10.0727 15 7.9979 15C6.42613 15 4.97528 14.482 3.80689 13.6073L2.70711 14.7071C2.31658 15.0976 1.68342 15.0976 1.29289 14.7071C0.907302 14.3215 0.902431 13.6994 1.27828 13.3078Z",
    fill: color
  })));
};
UserIcon.category = 'Entity';
UserIcon.Types = Types$q;

/*********************************************************************
 * © Copyright IBM Corp. 2025
 *********************************************************************/
var VerticalArrowsIcon = function VerticalArrowsIcon(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? FontColorSuccess : _ref$backgroundColor,
    _ref$arrowColor = _ref.arrowColor,
    arrowColor = _ref$arrowColor === void 0 ? MrWhite : _ref$arrowColor;
  return React.createElement("svg", {
    style: {
      display: 'block'
    },
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "7",
    fill: backgroundColor
  }), React.createElement("path", {
    d: "M5.35406 7.99997C5.01492 7.99997 4.82966 8.39552 5.04677 8.65605L6.61596 10.5391C6.81585 10.7789 7.18428 10.7789 7.38418 10.5391L8.95333 8.65604C9.17043 8.39551 8.98517 7.99997 8.64604 7.99997L5.35406 7.99997Z",
    fill: arrowColor
  }), React.createElement("path", {
    d: "M5.35406 6.00002C5.01492 6.00002 4.82966 5.60448 5.04677 5.34395L6.61591 3.46098C6.8158 3.22111 7.18423 3.2211 7.38413 3.46098L8.9533 5.34395C9.17041 5.60448 8.98515 6.00002 8.64601 6.00002L5.35406 6.00002Z",
    fill: arrowColor
  }));
};
VerticalArrowsIcon.category = 'Common Actions';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var Types$r = {
  DEFAULT: 'default',
  OFF: 'off'
};
var VisibilityIcon = function VisibilityIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconsGeneralColor : _ref$color,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? Types$r.DEFAULT : _ref$type;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, type === Types$r.DEFAULT && React.createElement("g", null, React.createElement("path", {
    d: "M8.00195 11.5C9.65869 11.5 11.002 10.1569 11.002 8.5C11.002 6.84315 9.65869 5.5 8.00195 5.5C6.34521 5.5 5.00195 6.84315 5.00195 8.5C5.00195 10.1569 6.34521 11.5 8.00195 11.5Z",
    fill: color
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.00195 14C3.58374 14 0.00195312 9 0.00195312 9C0.00195312 9 3.58374 3 8.00195 3C12.4202 3 16.002 9 16.002 9C16.002 9 12.4202 14 8.00195 14ZM3.78418 7.38891C3.28174 7.9095 2.8501 8.43507 2.51074 8.88296C2.8252 9.22121 3.21069 9.60498 3.6521 9.9862C4.97876 11.1315 6.51709 12 8.00195 12C9.48682 12 11.0251 11.1315 12.3518 9.9862C12.7932 9.60498 13.1787 9.22121 13.4932 8.88296C13.1538 8.43507 12.7222 7.9095 12.2197 7.38891C10.8486 5.9684 9.35083 5 8.00195 5C6.65308 5 5.15527 5.9684 3.78418 7.38891Z",
    fill: color
  })), type === Types$r.OFF && React.createElement("path", {
    d: "M2.81858 5.4256C2.50144 4.97352 1.87766 4.86422 1.42551 5.18147C0.97361 5.49871 0.864235 6.12237 1.18162 6.57445L1.24094 6.66217L1.24168 6.66347C1.44773 6.96975 2.02488 7.82911 2.90012 8.6866L1.5156 10.0711C1.12522 10.4616 1.12522 11.0948 1.5156 11.4853C1.90623 11.8758 2.53928 11.8758 2.92991 11.4853L4.47556 9.93949C5.19944 10.3919 6.04466 10.7615 7.00095 10.9186V12.5147C7.00095 13.067 7.44871 13.5147 8.00095 13.5147C8.5532 13.5147 9.00095 13.067 9.00095 12.5147V10.919C9.95994 10.7625 10.8052 10.3939 11.5285 9.94181L13.072 11.4853C13.4626 11.8758 14.0957 11.8758 14.4863 11.4853C14.8767 11.0948 14.8767 10.4616 14.4863 10.0711L13.1025 8.68746C13.9511 7.85278 14.5207 7.0125 14.7405 6.68825C14.7722 6.64119 14.7969 6.60499 14.8137 6.58126C15.1347 6.13185 15.0307 5.5073 14.5813 5.18629C14.1318 4.86528 13.5073 4.96937 13.1863 5.41878C13.1589 5.45698 13.1257 5.5056 13.0864 5.56318L13.0798 5.57279C12.8183 5.95541 12.2976 6.71712 11.5032 7.44917C10.581 8.2988 9.40037 9.00002 7.99998 9.00002C6.60252 9.00002 5.41258 8.28986 4.48289 7.43208C3.6677 6.67988 3.13792 5.89648 2.89988 5.54458C2.86741 5.49646 2.84031 5.4564 2.81858 5.4256Z",
    fill: color
  }));
};
VisibilityIcon.category = 'Common Actions';
VisibilityIcon.Types = Types$r;

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var WarningIcon = function WarningIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? FontColorWarning : _ref$color;
  return React.createElement("svg", {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1",
    style: {
      display: 'block'
    }
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.0216 2.19864C9.1488 0.600452 6.8512 0.600455 5.97841 2.19864L1.36358 10.649C0.29367 12.6082 1.71338 14.9968 3.94769 14.9968H12.0523C14.2866 14.9968 15.7063 12.6082 14.6364 10.649L10.0216 2.19864ZM9 5C9 4.44771 8.55225 4 8 4C7.44775 4 7 4.44771 7 5V9C7 9.55229 7.44775 10 8 10C8.55225 10 9 9.55229 9 9V5ZM9 12C9 12.5523 8.55225 13 8 13C7.44775 13 7 12.5523 7 12C7 11.4477 7.44775 11 8 11C8.55225 11 9 11.4477 9 12Z",
    fill: color
  }));
};
WarningIcon.category = 'Info';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
var defaultMiroIconForegroundColor = '#07003B';
var defaultMiroIconBackgroundColor = '#FFD02F';
var MiroIcon = function MiroIcon(_ref) {
  var _ref$foregroundColor = _ref.foregroundColor,
    foregroundColor = _ref$foregroundColor === void 0 ? defaultMiroIconForegroundColor : _ref$foregroundColor,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? defaultMiroIconBackgroundColor : _ref$backgroundColor;
  return React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    width: "16",
    height: "16",
    rx: "2",
    fill: backgroundColor
  }), React.createElement("path", {
    d: "M3.78537 2H2.02927L3.55122 6.03902L2 14H3.7561L7.06341 5.57073L5.54146 14H7.23902L10.5171 4.92683L8.99512 14H10.7512L14 3.8439L10.8098 2H8.99512L10.4878 4.37073L7.29756 2H5.5122L7.06341 5.16098L3.78537 2Z",
    fill: foregroundColor
  }));
};
MiroIcon.category = 'Boards & Views';

/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/

export { AccessPrivateIcon, AccessCustomIcon, ActionCompletedIcon, AddIcon, AddTagIcon, AllocationIcon, AllocationsIcon, ApproveStatusIcon, ApproximatelyEqualIcon, ArrowIcon, AttachmentIcon, AzureIcon, AzureDevOpsIcon, AutomationRuleIcon, AutoPushIcon, BitbucketIcon, BlockerIcon, BoardEmptyLanesIcon, BoardIcon, BranchIcon, CalendarIcon, CapacityIcon, CardIcon, CaretIcon, ChartAreaIcon, ChartBarIcon, ChartBurndownIcon, ChartLineIcon, ChartScatterplotIcon, ChartStackedAreaIcon, ChartStackedBarIcon, ChevronIcon, CircleIcon, CloseIcon, CodeIcon, CommentIcon, CopyIcon, EnableIcon, DashboardIcon, DateAnticipatedFinishIcon, DateCreatedIcon, DateFinishedIcon, DateForecastedFinishIcon, DateLastRunIcon, DateLastStateChangedIcon, DatePlannedFinishIcon, DatePlannedStartIcon, DateStartedIcon, DescriptionIcon, DoubleCaretIcon, DownloadIcon, DragdropIndicatorIcon, EditIcon, EmotionIcon, ExternalIcon, ExternalLinkIcon, FavoriteIcon, FilterIcon, FunctionIcon, FocusIcon, FolderIcon, FullscreenIcon, GitHubIcon, GitLabIcon, HelpIcon, HierarchyIcon, IdeaIcon, ImportIcon, InfoIcon, InternalIcon, JiraIcon, JiraServiceDeskIcon, KeyboardShortcutsIcon, LastModifiedIcon, LastViewedIcon, LinkIcon, ListIcon, FlexibleListIcon, ListColumnsIcon, ListLanesIcon, ListFirstLevel, ListSecondLevel, LiveChatIcon, LoadingIcon, MailIcon, MaximizeIcon, MenuActivityIcon, MenuBoardsIcon, MenuFeedbackIcon, MenuHelpIcon, MenuNotificationIcon, MenuReportsIcon, MenuSearchIcon, MenuSettingsIcon, MenuTimesheetIcon, MergeRequestIcon, MessageErrorIcon, MessageNoDataIcon, MessageManyFacetsIcon, MetricsIcon, MoreCardsIcon, MultiSelectIcon, NavIcon, NewFieldIcon, NewWindowIcon, NotificationIcon, OneByOneIcon, OwnerIcon, PhabricatorIcon, PhoneIcon, PinnedIcon, PipelineIcon, PlayIcon, PluginIcon, PlusIcon, PresentIcon, PrivateIcon, PrintIcon, ProcessIcon, ProjectIcon, PublicIcon, QAIcon, QAStatusIcon, RecentIcon, RectangleIcon, RelationIcon, RelationsIcon, ReloadIcon, RemoveIcon, ReplyIcon, RequestIcon, ReturnIcon, RevertIcon, SearchIcon, SelectIcon, SettingsIcon, ShareIcon, ShowMoreIcon, SolutionsIcon, SortIcon, StopIcon, SwapIcon, TagIcon, TagsCloudIcon, TeamIcon, TestRailIcon, ThumbsUpIcon, TimeIcon, TimelineIcon, TopMenuHelpIcon, TopMenuReportsIcon, TPLogoIcon, TrashIcon, UploadIcon, UserIcon, VerticalArrowsIcon, VisibilityIcon, WarningIcon, MiroIcon };
